var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-card-2 {\n        fill: #3b6060;\n      }\n\n      .cls-card-3 {\n        fill: #ededed;\n      }\n\n      .cls-card-4 {\n        fill: #e7e7e7;\n      }\n\n      .cls-card-5 {\n        fill: #f1f1f1;\n      }\n\n      .cls-card-6 {\n        fill: #f5f5f5;\n      }\n\n      .cls-card-7 {\n        fill: #9fbbbb;\n      }\n\n      .cls-card-8 {\n        fill: #f8f8f8;\n      }\n\n      .cls-card-9 {\n        fill: #a3bebe;\n      }\n\n      .cls-card-10 {\n        fill: #a7c1c1;\n      }\n\n      .cls-card-11 {\n        fill: #91b7b7;\n      }\n\n      .cls-card-12 {\n        fill: #466565;\n      }\n\n      .cls-card-13 {\n        fill: #4f6b6b;\n      }\n\n      .cls-card-14 {\n        fill: #546e6e;\n      }\n\n      .cls-card-15 {\n        fill: #5b7272;\n      }\n\n      .cls-card-16 {\n        fill: #6e8b8b;\n      }\n\n      .cls-card-17 {\n        fill: #607676;\n      }\n\n      .cls-card-18 {\n        fill: #708e8e;\n      }\n\n      .cls-card-19 {\n        fill: #4a6f6f;\n      }\n\n      .cls-card-20 {\n        fill: #738787;\n      }\n\n      .cls-card-21 {\n        fill: #6b8787;\n      }\n\n      .cls-card-22 {\n        fill: #6b8989;\n      }\n\n      .cls-card-23 {\n        fill: #658181;\n      }\n\n      .cls-card-24 {\n        fill: #a4c2c2;\n      }\n\n      .cls-card-25 {\n        fill: #406766;\n      }\n\n      .cls-card-26 {\n        fill: #a6c3c3;\n      }\n\n      .cls-card-27 {\n        fill: #416867;\n      }\n\n      .cls-card-28 {\n        fill: #3a5d41;\n      }\n\n      .cls-card-29 {\n        fill: #3e6564;\n      }\n\n      .cls-card-30 {\n        fill: #375f5e;\n      }\n\n      .cls-card-31 {\n        fill: #3f6665;\n      }\n\n      .cls-card-32 {\n        fill: #33563a;\n      }\n\n      .cls-card-33 {\n        fill: #436a69;\n      }\n\n      .cls-card-34 {\n        fill: #3c6362;\n      }\n\n      .cls-card-35 {\n        fill: #3d6463;\n      }\n\n      .cls-card-36 {\n        fill: #466b6a;\n      }\n\n      .cls-card-37 {\n        fill: #436968;\n      }\n\n      .cls-card-38 {\n        fill: #40614a;\n      }\n\n      .cls-card-39 {\n        fill: #a1bfbf;\n      }\n\n      .cls-card-40 {\n        fill: #a5c0c0;\n      }\n\n      .cls-card-41 {\n        fill: #446a69;\n      }\n\n      .cls-card-42 {\n        fill: #426968;\n      }\n\n      .cls-card-43 {\n        fill: #496f6e;\n      }\n\n      .cls-card-44 {\n        fill: #627f6e;\n      }\n\n      .cls-card-45 {\n        fill: #4e6d4f;\n      }\n\n      .cls-card-46 {\n        fill: #6e897d;\n      }\n\n      .cls-card-47 {\n        fill: #799287;\n      }\n\n      .cls-card-48 {\n        fill: #5b7863;\n      }\n\n      .cls-card-49 {\n        fill: #5b785b;\n      }\n\n      .cls-card-50 {\n        fill: #3c5a36;\n      }\n\n      .cls-card-51 {\n        fill: #93a696;\n      }\n\n      .cls-card-52 {\n        fill: #456446;\n      }\n\n      .cls-card-53 {\n        fill: #78917a;\n      }\n\n      .cls-card-54 {\n        fill: #b4beb6;\n      }\n\n      .cls-card-55 {\n        fill: #c2cbc4;\n      }\n\n      .cls-card-56 {\n        fill: #afbbb3;\n      }\n\n      .cls-card-57 {\n        fill: #b9c4bc;\n      }\n\n      .cls-card-58 {\n        fill: #bbc3ba;\n      }\n\n      .cls-card-59 {\n        fill: #a6b2aa;\n      }\n\n      .cls-card-60 {\n        fill: #b8bdb0;\n      }\n\n      .cls-card-61 {\n        fill: #95aeab;\n      }\n\n      .cls-card-62 {\n        fill: #9dac9d;\n      }\n\n      .cls-card-63 {\n        fill: #e4ded1;\n      }\n\n      .cls-card-64 {\n        fill: #a8b4a7;\n      }\n\n      .cls-card-65 {\n        fill: #a4bab9;\n      }\n\n      .cls-card-66 {\n        fill: #9ab9b9;\n      }\n\n      .cls-card-67 {\n        fill: #a1bebe;\n      }\n\n      .cls-card-68 {\n        fill: #3a605f;\n      }\n\n      .cls-card-69 {\n        fill: #9dbcbc;\n      }\n\n      .cls-card-70 {\n        fill: #3a6160;\n      }\n\n      .cls-card-71 {\n        fill: #486665;\n      }\n\n      .cls-card-72 {\n        fill: #39605f;\n      }\n\n      .cls-card-73 {\n        fill: #8bb2b2;\n      }\n\n      .cls-card-74 {\n        fill: #799087;\n      }\n\n      .cls-card-75 {\n        fill: #30412b;\n      }\n\n      .cls-card-76 {\n        fill: #2a442a;\n      }\n\n      .cls-card-77 {\n        fill: #283a28;\n      }\n\n      .cls-card-78 {\n        fill: #46624d;\n      }\n\n      .cls-card-79 {\n        fill: #849b94;\n      }\n\n      .cls-card-80 {\n        fill: #6e887c;\n      }\n\n      .cls-card-81 {\n        fill: #324c30;\n      }\n\n      .cls-card-82 {\n        fill: #2f5038;\n      }\n\n      .cls-card-83 {\n        fill: #617867;\n      }\n\n      .cls-card-84 {\n        fill: #88b0b0;\n      }\n\n      .cls-card-85 {\n        fill: #83acac;\n      }\n\n      .cls-card-86 {\n        fill: #8db2b2;\n      }\n\n      .cls-card-87 {\n        fill: #91b5b5;\n      }\n\n      .cls-card-88 {\n        fill: #97b8b8;\n      }\n\n      .cls-card-89 {\n        fill: #86afaf;\n      }\n\n      .cls-card-90 {\n        fill: #395f5e;\n      }\n\n      .cls-card-91 {\n        fill: #3b6160;\n      }\n\n      .cls-card-92 {\n        fill: #43654c;\n      }\n\n      .cls-card-93 {\n        fill: #355c5b;\n      }\n\n      .cls-card-94 {\n        fill: #3f6564;\n      }\n\n      .cls-card-95 {\n        fill: #3c6261;\n      }\n\n      .cls-card-96 {\n        fill: #4d6c6b;\n      }\n\n      .cls-card-97 {\n        fill: #456867;\n      }\n\n      .cls-card-98 {\n        fill: #496f6f;\n      }\n\n      .cls-card-99 {\n        fill: #35583c;\n      }\n\n      .cls-card-100 {\n        fill: #e8e9e9;\n      }\n\n      .cls-card-101 {\n        fill: #2d5031;\n      }\n\n      .cls-card-102 {\n        fill: #466852;\n      }\n\n      .cls-card-103 {\n        fill: #406665;\n      }\n\n      .cls-card-104 {\n        fill: #416665;\n      }\n\n      .cls-card-105 {\n        fill: #497372;\n      }\n\n      .cls-card-106 {\n        fill: #e6e6e6;\n      }\n\n      .cls-card-107 {\n        fill: #7a7e59;\n      }\n\n      .cls-card-108 {\n        fill: #577664;\n      }\n\n      .cls-card-109 {\n        fill: #6e7754;\n      }\n\n      .cls-card-110 {\n        fill: #627353;\n      }\n\n      .cls-card-111 {\n        fill: #567355;\n      }\n\n      .cls-card-112 {\n        fill: #7f988f;\n      }\n\n      .cls-card-113 {\n        fill: #627f64;\n      }\n\n      .cls-card-114 {\n        fill: #999474;\n      }\n\n      .cls-card-115 {\n        fill: #8ca18d;\n      }\n\n      .cls-card-116 {\n        fill: #6d896f;\n      }\n\n      .cls-card-117 {\n        fill: #839a85;\n      }\n\n      .cls-card-118 {\n        fill: #3e5f47;\n      }\n\n      .cls-card-119 {\n        fill: #afb5ad;\n      }\n\n      .cls-card-120 {\n        fill: #aab7af;\n      }\n\n      .cls-card-121 {\n        fill: #a8a4a0;\n      }\n\n      .cls-card-122 {\n        fill: #4e4c38;\n      }\n\n      .cls-card-123 {\n        fill: #3a3933;\n      }\n\n      .cls-card-124 {\n        fill: #9fada5;\n      }\n\n      .cls-card-125 {\n        fill: #98a69d;\n      }\n\n      .cls-card-126 {\n        fill: #9f8f63;\n      }\n\n      .cls-card-127 {\n        fill: #9a8e69;\n      }\n\n      .cls-card-128 {\n        fill: #91a097;\n      }\n\n      .cls-card-129 {\n        fill: #385f5e;\n      }\n\n      .cls-card-130 {\n        fill: #365c5b;\n      }\n\n      .cls-card-131 {\n        fill: #365d5c;\n      }\n\n      .cls-card-132 {\n        fill: #4c6e6d;\n      }\n\n      .cls-card-133 {\n        fill: #262525;\n      }\n\n      .cls-card-134 {\n        fill: #273227;\n      }\n\n      .cls-card-135 {\n        fill: #40452c;\n      }\n\n      .cls-card-136 {\n        fill: #663b28;\n      }\n\n      .cls-card-137 {\n        fill: #532724;\n      }\n\n      .cls-card-138 {\n        fill: #9e6271;\n      }\n\n      .cls-card-139 {\n        fill: #4e312a;\n      }\n\n      .cls-card-140 {\n        fill: #743e41;\n      }\n\n      .cls-card-141 {\n        fill: #433928;\n      }\n\n      .cls-card-142 {\n        fill: #5b5854;\n      }\n\n      .cls-card-143 {\n        fill: #56492e;\n      }\n\n      .cls-card-144 {\n        fill: #673432;\n      }\n\n      .cls-card-145 {\n        fill: #3f2323;\n      }\n\n      .cls-card-146 {\n        fill: #7e573b;\n      }\n\n      .cls-card-147 {\n        fill: #8c4460;\n      }\n\n      .cls-card-148 {\n        fill: #583224;\n      }\n\n      .cls-card-149 {\n        fill: #814e4d;\n      }\n\n      .cls-card-150 {\n        fill: #8a988c;\n      }\n\n      .cls-card-151 {\n        fill: #77897a;\n      }\n\n      .cls-card-152 {\n        fill: #819083;\n      }\n\n      .cls-card-153 {\n        fill: #365039;\n      }\n\n      .cls-card-154 {\n        fill: #504c32;\n      }\n\n      .cls-card-155 {\n        fill: #556f5c;\n      }\n\n      .cls-card-156 {\n        fill: #3e5846;\n      }\n\n      .cls-card-157 {\n        fill: #4d6956;\n      }\n\n      .cls-card-158 {\n        fill: #677f70;\n      }\n\n      .cls-card-159 {\n        fill: #8cb3b3;\n      }\n\n      .cls-card-160 {\n        fill: #9a857a;\n      }\n\n      .cls-card-161 {\n        fill: #928078;\n      }\n\n      .cls-card-162 {\n        fill: #84736c;\n      }\n\n      .cls-card-163 {\n        fill: #756860;\n      }\n\n      .cls-card-164 {\n        fill: #96b8b8;\n      }\n\n      .cls-card-165 {\n        fill: #95b6b6;\n      }\n\n      .cls-card-166 {\n        fill: #9dbdbd;\n      }\n\n      .cls-card-167 {\n        fill: #9bb;\n      }\n\n      .cls-card-168 {\n        fill: #9bbaba;\n      }\n\n      .cls-card-169 {\n        fill: #213b21;\n      }\n\n      .cls-card-170 {\n        fill: #345a5a;\n      }\n\n      .cls-card-171 {\n        fill: #27492b;\n      }\n\n      .cls-card-172 {\n        fill: #546948;\n      }\n\n      .cls-card-173 {\n        fill: #335958;\n      }\n\n      .cls-card-174 {\n        fill: #2e5033;\n      }\n\n      .cls-card-175 {\n        fill: #355d5c;\n      }\n\n      .cls-card-176 {\n        fill: #395f5f;\n      }\n\n      .cls-card-177 {\n        fill: #436665;\n      }\n\n      .cls-card-178 {\n        fill: #345c5b;\n      }\n\n      .cls-card-179 {\n        fill: #92b4b4;\n      }\n\n      .cls-card-180 {\n        fill: #4b6a52;\n      }\n\n      .cls-card-181 {\n        fill: #385434;\n      }\n\n      .cls-card-182 {\n        fill: #51725e;\n      }\n\n      .cls-card-183 {\n        fill: #4d683f;\n      }\n\n      .cls-card-184 {\n        fill: #2e2a29;\n      }\n\n      .cls-card-185 {\n        fill: #8a8249;\n      }\n\n      .cls-card-186 {\n        fill: #777843;\n      }\n\n      .cls-card-187 {\n        fill: #6c7257;\n      }\n\n      .cls-card-188 {\n        fill: #928563;\n      }\n\n      .cls-card-189 {\n        fill: #696e37;\n      }\n\n      .cls-card-190 {\n        fill: #7b8269;\n      }\n\n      .cls-card-191 {\n        fill: #8a8860;\n      }\n\n      .cls-card-192 {\n        fill: #686b4a;\n      }\n\n      .cls-card-193 {\n        fill: #545136;\n      }\n\n      .cls-card-194 {\n        fill: #717a5a;\n      }\n\n      .cls-card-195 {\n        fill: #355937;\n      }\n\n      .cls-card-196 {\n        fill: #58433e;\n      }\n\n      .cls-card-197 {\n        fill: #85414a;\n      }\n\n      .cls-card-198 {\n        fill: #723c4a;\n      }\n\n      .cls-card-199 {\n        fill: #723331;\n      }\n\n      .cls-card-200 {\n        fill: #302b2b;\n      }\n\n      .cls-card-201 {\n        fill: #63422c;\n      }\n\n      .cls-card-202 {\n        fill: #6b5b42;\n      }\n\n      .cls-card-203 {\n        fill: #3f2e2d;\n      }\n\n      .cls-card-204 {\n        fill: #755b37;\n      }\n\n      .cls-card-205 {\n        fill: #5d4f31;\n      }\n\n      .cls-card-206 {\n        fill: #8f7e56;\n      }\n\n      .cls-card-207 {\n        fill: #9a9983;\n      }\n\n      .cls-card-208 {\n        fill: #958269;\n      }\n\n      .cls-card-209 {\n        fill: #80765d;\n      }\n\n      .cls-card-210 {\n        fill: #9dbbbb;\n      }\n\n      .cls-card-211 {\n        fill: #97b6b6;\n      }\n\n      .cls-card-212 {\n        fill: #9bbbba;\n      }\n\n      .cls-card-213 {\n        fill: #9ababa;\n      }\n\n      .cls-card-214 {\n        fill: #302827;\n      }\n\n      .cls-card-215 {\n        fill: #423927;\n      }\n\n      .cls-card-216 {\n        fill: #733d31;\n      }\n\n      .cls-card-217 {\n        fill: #984467;\n      }\n\n      .cls-card-218 {\n        fill: #563b34;\n      }\n\n      .cls-card-219 {\n        fill: #38342d;\n      }\n\n      .cls-card-220 {\n        fill: #6b6058;\n      }\n\n      .cls-card-221 {\n        fill: #314039;\n      }\n\n      .cls-card-222 {\n        fill: #61544a;\n      }\n\n      .cls-card-223 {\n        fill: #545e61;\n      }\n\n      .cls-card-224 {\n        fill: #a04576;\n      }\n\n      .cls-card-225 {\n        fill: #89817a;\n      }\n\n      .cls-card-226 {\n        fill: #728372;\n      }\n\n      .cls-card-227 {\n        fill: #736e60;\n      }\n\n      .cls-card-228 {\n        fill: #7b7c6e;\n      }\n\n      .cls-card-229 {\n        fill: #6b3542;\n      }\n\n      .cls-card-230 {\n        fill: #696656;\n      }\n\n      .cls-card-231 {\n        fill: #677765;\n      }\n\n      .cls-card-232 {\n        fill: #4e604d;\n      }\n\n      .cls-card-233 {\n        fill: #493328;\n      }\n\n      .cls-card-234 {\n        fill: #6b8274;\n      }\n\n      .cls-card-235 {\n        fill: #7fc9c9;\n      }\n\n      .cls-card-236 {\n        fill: #7ec5cb;\n      }\n\n      .cls-card-237 {\n        fill: #67b9bf;\n      }\n\n      .cls-card-238 {\n        fill: #79bcbf;\n      }\n\n      .cls-card-239 {\n        fill: #68bbbe;\n      }\n\n      .cls-card-240 {\n        fill: #6f837c;\n      }\n\n      .cls-card-241 {\n        fill: #a08d83;\n      }\n\n      .cls-card-242 {\n        fill: #9b8a81;\n      }\n\n      .cls-card-243 {\n        fill: #937a68;\n      }\n\n      .cls-card-244 {\n        fill: #826a58;\n      }\n\n      .cls-card-245 {\n        fill: #72c4c5;\n      }\n\n      .cls-card-246 {\n        fill: #62bcbc;\n      }\n\n      .cls-card-247 {\n        fill: #72c2c3;\n      }\n\n      .cls-card-248 {\n        fill: #88845e;\n      }\n\n      .cls-card-249 {\n        fill: #92906d;\n      }\n\n      .cls-card-250 {\n        fill: #717f5e;\n      }\n\n      .cls-card-251 {\n        fill: #335a59;\n      }\n\n      .cls-card-252 {\n        fill: #91cfd1;\n      }\n\n      .cls-card-253 {\n        fill: #776d43;\n      }\n\n      .cls-card-254 {\n        fill: #373423;\n      }\n\n      .cls-card-255 {\n        fill: #463e24;\n      }\n\n      .cls-card-256 {\n        fill: #67b2a7;\n      }\n\n      .cls-card-257 {\n        fill: #9abbbb;\n      }\n\n      .cls-card-258 {\n        fill: #616f4f;\n      }\n\n      .cls-card-259 {\n        fill: #8eb4b4;\n      }\n\n      .cls-card-260 {\n        fill: #5e775f;\n      }\n\n      .cls-card-261 {\n        fill: #5d7e69;\n      }\n\n      .cls-card-262 {\n        fill: #587961;\n      }\n\n      .cls-card-263 {\n        fill: #6f846c;\n      }\n\n      .cls-card-264 {\n        fill: #33512e;\n      }\n\n      .cls-card-265 {\n        fill: #596850;\n      }\n\n      .cls-card-266 {\n        fill: #575260;\n      }\n\n      .cls-card-267 {\n        fill: #7d5c67;\n      }\n\n      .cls-card-268 {\n        fill: #3a3c2d;\n      }\n\n      .cls-card-269 {\n        fill: #543e2c;\n      }\n\n      .cls-card-270 {\n        fill: #32322b;\n      }\n\n      .cls-card-271 {\n        fill: #43503f;\n      }\n\n      .cls-card-272 {\n        fill: #575169;\n      }\n\n      .cls-card-273 {\n        fill: #655e57;\n      }\n\n      .cls-card-274 {\n        fill: #48434f;\n      }\n\n      .cls-card-275 {\n        fill: #4c3f31;\n      }\n\n      .cls-card-276 {\n        fill: #998c4e;\n      }\n\n      .cls-card-277 {\n        fill: #858b5d;\n      }\n\n      .cls-card-278 {\n        fill: #c1b0a8;\n      }\n\n      .cls-card-279 {\n        fill: #a69869;\n      }\n\n      .cls-card-280 {\n        fill: #9b8a6a;\n      }\n\n      .cls-card-281 {\n        fill: #792e33;\n      }\n\n      .cls-card-282 {\n        fill: #682c2e;\n      }\n\n      .cls-card-283 {\n        fill: #582e2e;\n      }\n\n      .cls-card-284 {\n        fill: #8b375c;\n      }\n\n      .cls-card-285 {\n        fill: #4f2c36;\n      }\n\n      .cls-card-286 {\n        fill: #5f282a;\n      }\n\n      .cls-card-287 {\n        fill: #732c44;\n      }\n\n      .cls-card-288 {\n        fill: #5d2c2e;\n      }\n\n      .cls-card-289 {\n        fill: #4b2a2d;\n      }\n\n      .cls-card-290 {\n        fill: #87666c;\n      }\n\n      .cls-card-291 {\n        fill: #3e372a;\n      }\n\n      .cls-card-292 {\n        fill: #74684a;\n      }\n\n      .cls-card-293 {\n        fill: #743c37;\n      }\n\n      .cls-card-294 {\n        fill: #453027;\n      }\n\n      .cls-card-295 {\n        fill: #613229;\n      }\n\n      .cls-card-296 {\n        fill: #783633;\n      }\n\n      .cls-card-297 {\n        fill: #3c252c;\n      }\n\n      .cls-card-298 {\n        fill: #6e4335;\n      }\n\n      .cls-card-299 {\n        fill: #733440;\n      }\n\n      .cls-card-300 {\n        fill: #352627;\n      }\n\n      .cls-card-301 {\n        fill: #60302e;\n      }\n\n      .cls-card-302 {\n        fill: #ac3967;\n      }\n\n      .cls-card-303 {\n        fill: #6f2d3e;\n      }\n\n      .cls-card-304 {\n        fill: #232323;\n      }\n\n      .cls-card-305 {\n        fill: #4d4237;\n      }\n\n      .cls-card-306 {\n        fill: #46392a;\n      }\n\n      .cls-card-307 {\n        fill: #2a252a;\n      }\n\n      .cls-card-308 {\n        fill: #3f6e6a;\n      }\n\n      .cls-card-309 {\n        fill: #9a2f6b;\n      }\n\n      .cls-card-310 {\n        fill: #7c8879;\n      }\n\n      .cls-card-311 {\n        fill: #778c80;\n      }\n\n      .cls-card-312 {\n        fill: #7e7e72;\n      }\n\n      .cls-card-313 {\n        fill: #777d6f;\n      }\n\n      .cls-card-314 {\n        fill: #782f42;\n      }\n\n      .cls-card-315 {\n        fill: #8d4059;\n      }\n\n      .cls-card-316 {\n        fill: #933c5e;\n      }\n\n      .cls-card-317 {\n        fill: #4e292c;\n      }\n\n      .cls-card-318 {\n        fill: #50292f;\n      }\n\n      .cls-card-319 {\n        fill: #819389;\n      }\n\n      .cls-card-320 {\n        fill: #788476;\n      }\n\n      .cls-card-321 {\n        fill: #87cdce;\n      }\n\n      .cls-card-322 {\n        fill: #74c1c4;\n      }\n\n      .cls-card-323 {\n        fill: #80c7cc;\n      }\n\n      .cls-card-324 {\n        fill: #86c2c4;\n      }\n\n      .cls-card-325 {\n        fill: #809083;\n      }\n\n      .cls-card-326 {\n        fill: #8d9f93;\n      }\n\n      .cls-card-327 {\n        fill: #a7988f;\n      }\n\n      .cls-card-328 {\n        fill: #af9b89;\n      }\n\n      .cls-card-329 {\n        fill: #a68c77;\n      }\n\n      .cls-card-330 {\n        fill: #ab9581;\n      }\n\n      .cls-card-331 {\n        fill: #9c826c;\n      }\n\n      .cls-card-332 {\n        fill: #937763;\n      }\n\n      .cls-card-333 {\n        fill: #918d67;\n      }\n\n      .cls-card-334 {\n        fill: #968356;\n      }\n\n      .cls-card-335 {\n        fill: #7bbcb9;\n      }\n\n      .cls-card-336 {\n        fill: #87c3c4;\n      }\n\n      .cls-card-337 {\n        fill: #594e23;\n      }\n\n      .cls-card-338 {\n        fill: #4c4222;\n      }\n\n      .cls-card-339 {\n        fill: #6d582d;\n      }\n\n      .cls-card-340 {\n        fill: #7b6938;\n      }\n\n      .cls-card-341 {\n        fill: #574c29;\n      }\n\n      .cls-card-342 {\n        fill: #222121;\n      }\n\n      .cls-card-343 {\n        fill: #796a53;\n      }\n\n      .cls-card-344 {\n        fill: #5f4c23;\n      }\n\n      .cls-card-345 {\n        fill: #638371;\n      }\n\n      .cls-card-346 {\n        fill: #9b9979;\n      }\n\n      .cls-card-347 {\n        fill: #7f8d71;\n      }\n\n      .cls-card-348 {\n        fill: #244324;\n      }\n\n      .cls-card-349 {\n        fill: #455149;\n      }\n\n      .cls-card-350 {\n        fill: #3d3f40;\n      }\n\n      .cls-card-351 {\n        fill: #564b37;\n      }\n\n      .cls-card-352 {\n        fill: #617364;\n      }\n\n      .cls-card-353 {\n        fill: #72846f;\n      }\n\n      .cls-card-354 {\n        fill: #63454d;\n      }\n\n      .cls-card-355 {\n        fill: #394e4a;\n      }\n\n      .cls-card-356 {\n        fill: #616149;\n      }\n\n      .cls-card-357 {\n        fill: #945d63;\n      }\n\n      .cls-card-358 {\n        fill: #573e37;\n      }\n\n      .cls-card-359 {\n        fill: #6a3844;\n      }\n\n      .cls-card-360 {\n        fill: #6d6249;\n      }\n\n      .cls-card-361 {\n        fill: #8d8d7a;\n      }\n\n      .cls-card-362 {\n        fill: #7f8179;\n      }\n\n      .cls-card-363 {\n        fill: #a49557;\n      }\n\n      .cls-card-364 {\n        fill: #94946a;\n      }\n\n      .cls-card-365 {\n        fill: #cabcb7;\n      }\n\n      .cls-card-366 {\n        fill: #c9b5a8;\n      }\n\n      .cls-card-367 {\n        fill: #c7a289;\n      }\n\n      .cls-card-368 {\n        fill: #8b7e65;\n      }\n\n      .cls-card-369 {\n        fill: #a69382;\n      }\n\n      .cls-card-370 {\n        fill: #a89779;\n      }\n\n      .cls-card-371 {\n        fill: #434445;\n      }\n\n      .cls-card-372 {\n        fill: #685367;\n      }\n\n      .cls-card-373 {\n        fill: #a53e66;\n      }\n\n      .cls-card-374 {\n        fill: #a54370;\n      }\n\n      .cls-card-375 {\n        fill: #8f2e59;\n      }\n\n      .cls-card-376 {\n        fill: #8a435b;\n      }\n\n      .cls-card-377 {\n        fill: #9e525c;\n      }\n\n      .cls-card-378 {\n        fill: #402e2d;\n      }\n\n      .cls-card-379 {\n        fill: #982a4c;\n      }\n\n      .cls-card-380 {\n        fill: #933748;\n      }\n\n      .cls-card-381 {\n        fill: #a66e72;\n      }\n\n      .cls-card-382 {\n        fill: #b6507b;\n      }\n\n      .cls-card-383 {\n        fill: #805a63;\n      }\n\n      .cls-card-384 {\n        fill: #282828;\n      }\n\n      .cls-card-385 {\n        fill: #2f2a2a;\n      }\n\n      .cls-card-386 {\n        fill: #3d3330;\n      }\n\n      .cls-card-387 {\n        fill: #6d2839;\n      }\n\n      .cls-card-388 {\n        fill: #903e6d;\n      }\n\n      .cls-card-389 {\n        fill: #a13375;\n      }\n\n      .cls-card-390 {\n        fill: #83665a;\n      }\n\n      .cls-card-391 {\n        fill: #9c4e6b;\n      }\n\n      .cls-card-392 {\n        fill: #742831;\n      }\n\n      .cls-card-393 {\n        fill: #873f61;\n      }\n\n      .cls-card-394 {\n        fill: #99557b;\n      }\n\n      .cls-card-395 {\n        fill: #503039;\n      }\n\n      .cls-card-396 {\n        fill: #3f2827;\n      }\n\n      .cls-card-397 {\n        fill: #a22f58;\n      }\n\n      .cls-card-398 {\n        fill: #482c2b;\n      }\n\n      .cls-card-399 {\n        fill: #823d4e;\n      }\n\n      .cls-card-400 {\n        fill: #885165;\n      }\n\n      .cls-card-401 {\n        fill: #562938;\n      }\n\n      .cls-card-402 {\n        fill: #866958;\n      }\n\n      .cls-card-403 {\n        fill: #705744;\n      }\n\n      .cls-card-404 {\n        fill: #7b2c66;\n      }\n\n      .cls-card-405 {\n        fill: #ab3785;\n      }\n\n      .cls-card-406 {\n        fill: #884465;\n      }\n\n      .cls-card-407 {\n        fill: #4e292b;\n      }\n\n      .cls-card-408 {\n        fill: #82355e;\n      }\n\n      .cls-card-409 {\n        fill: #5c2a37;\n      }\n\n      .cls-card-410 {\n        fill: #9d3a7c;\n      }\n\n      .cls-card-411 {\n        fill: #869891;\n      }\n\n      .cls-card-412 {\n        fill: #75c0c4;\n      }\n\n      .cls-card-413 {\n        fill: #b3a59b;\n      }\n\n      .cls-card-414 {\n        fill: #b8a799;\n      }\n\n      .cls-card-415 {\n        fill: #b39e92;\n      }\n\n      .cls-card-416 {\n        fill: #af9689;\n      }\n\n      .cls-card-417 {\n        fill: #9d7a6a;\n      }\n\n      .cls-card-418 {\n        fill: #a3976f;\n      }\n\n      .cls-card-419 {\n        fill: #a8a17e;\n      }\n\n      .cls-card-420 {\n        fill: #a4966e;\n      }\n\n      .cls-card-421 {\n        fill: #8c7645;\n      }\n\n      .cls-card-422 {\n        fill: #86897b;\n      }\n\n      .cls-card-423 {\n        fill: #7daca8;\n      }\n\n      .cls-card-424 {\n        fill: #c4bdb3;\n      }\n\n      .cls-card-425 {\n        fill: #beb6a9;\n      }\n\n      .cls-card-426 {\n        fill: #bbb5ab;\n      }\n\n      .cls-card-427 {\n        fill: #403621;\n      }\n\n      .cls-card-428 {\n        fill: #433826;\n      }\n\n      .cls-card-429 {\n        fill: #3e2e25;\n      }\n\n      .cls-card-430 {\n        fill: #534d3c;\n      }\n\n      .cls-card-431 {\n        fill: #524023;\n      }\n\n      .cls-card-432 {\n        fill: #8d695c;\n      }\n\n      .cls-card-433 {\n        fill: #9a7176;\n      }\n\n      .cls-card-434 {\n        fill: #2e2c24;\n      }\n\n      .cls-card-435 {\n        fill: #564e3c;\n      }\n\n      .cls-card-436 {\n        fill: #96796b;\n      }\n\n      .cls-card-437 {\n        fill: #5f5549;\n      }\n\n      .cls-card-438 {\n        fill: #a8a383;\n      }\n\n      .cls-card-439 {\n        fill: #2b332e;\n      }\n\n      .cls-card-440 {\n        fill: #2f2d2e;\n      }\n\n      .cls-card-441 {\n        fill: #9c7280;\n      }\n\n      .cls-card-442 {\n        fill: #635f62;\n      }\n\n      .cls-card-443 {\n        fill: #725644;\n      }\n\n      .cls-card-444 {\n        fill: #3c3828;\n      }\n\n      .cls-card-445 {\n        fill: #a79a8e;\n      }\n\n      .cls-card-446 {\n        fill: #ad929d;\n      }\n\n      .cls-card-447 {\n        fill: #847a67;\n      }\n\n      .cls-card-448 {\n        fill: #4f4932;\n      }\n\n      .cls-card-449 {\n        fill: #5d4b29;\n      }\n\n      .cls-card-450 {\n        fill: #524a31;\n      }\n\n      .cls-card-451 {\n        fill: #393329;\n      }\n\n      .cls-card-452 {\n        fill: #6c5d40;\n      }\n\n      .cls-card-453 {\n        fill: #b68764;\n      }\n\n      .cls-card-454 {\n        fill: #4f6b6e;\n      }\n\n      .cls-card-455 {\n        fill: #758889;\n      }\n\n      .cls-card-456 {\n        fill: #b35f82;\n      }\n\n      .cls-card-457 {\n        fill: #b04d74;\n      }\n\n      .cls-card-458 {\n        fill: #b36f91;\n      }\n\n      .cls-card-459 {\n        fill: #962d53;\n      }\n\n      .cls-card-460 {\n        fill: #922c6d;\n      }\n\n      .cls-card-461 {\n        fill: #966960;\n      }\n\n      .cls-card-462 {\n        fill: #5b274b;\n      }\n\n      .cls-card-463 {\n        fill: #8a275a;\n      }\n\n      .cls-card-464 {\n        fill: #5e2745;\n      }\n\n      .cls-card-465 {\n        fill: #40272c;\n      }\n\n      .cls-card-466 {\n        fill: #867c6d;\n      }\n\n      .cls-card-467 {\n        fill: #7c9d78;\n      }\n\n      .cls-card-468 {\n        fill: #835552;\n      }\n\n      .cls-card-469 {\n        fill: #937767;\n      }\n\n      .cls-card-470 {\n        fill: #722b55;\n      }\n\n      .cls-card-471 {\n        fill: #96796a;\n      }\n\n      .cls-card-472 {\n        fill: #888593;\n      }\n\n      .cls-card-473 {\n        fill: #773f64;\n      }\n\n      .cls-card-474 {\n        fill: #9f337f;\n      }\n\n      .cls-card-475 {\n        fill: #2f2729;\n      }\n\n      .cls-card-476 {\n        fill: #643932;\n      }\n\n      .cls-card-477 {\n        fill: #532d2a;\n      }\n\n      .cls-card-478 {\n        fill: #582a2d;\n      }\n\n      .cls-card-479 {\n        fill: #a23876;\n      }\n\n      .cls-card-480 {\n        fill: #a63c6a;\n      }\n\n      .cls-card-481 {\n        fill: #4c2c32;\n      }\n\n      .cls-card-482 {\n        fill: #9e496f;\n      }\n\n      .cls-card-483 {\n        fill: #842e58;\n      }\n\n      .cls-card-484 {\n        fill: #743a51;\n      }\n\n      .cls-card-485 {\n        fill: #9f2b70;\n      }\n\n      .cls-card-486 {\n        fill: #ab3f8a;\n      }\n\n      .cls-card-487 {\n        fill: #bbb1a8;\n      }\n\n      .cls-card-488 {\n        fill: #c6b5aa;\n      }\n\n      .cls-card-489 {\n        fill: #c7b7ae;\n      }\n\n      .cls-card-490 {\n        fill: #282624;\n      }\n\n      .cls-card-491 {\n        fill: #c8bcb3;\n      }\n\n      .cls-card-492 {\n        fill: #b7ae9f;\n      }\n\n      .cls-card-493 {\n        fill: #c2b6aa;\n      }\n\n      .cls-card-494 {\n        fill: #9f8f79;\n      }\n\n      .cls-card-495 {\n        fill: #b0a798;\n      }\n\n      .cls-card-496 {\n        fill: #bfb0a7;\n      }\n\n      .cls-card-497 {\n        fill: #bfafa2;\n      }\n\n      .cls-card-498 {\n        fill: #c29397;\n      }\n\n      .cls-card-499 {\n        fill: #b59f91;\n      }\n\n      .cls-card-500 {\n        fill: #bdb4a6;\n      }\n\n      .cls-card-501 {\n        fill: #4e5e59;\n      }\n\n      .cls-card-502 {\n        fill: #ae8c7d;\n      }\n\n      .cls-card-503 {\n        fill: #b59a8b;\n      }\n\n      .cls-card-504 {\n        fill: #ac8c7d;\n      }\n\n      .cls-card-505 {\n        fill: #a97276;\n      }\n\n      .cls-card-506 {\n        fill: #bd848b;\n      }\n\n      .cls-card-507 {\n        fill: #a67b6d;\n      }\n\n      .cls-card-508 {\n        fill: #98835a;\n      }\n\n      .cls-card-509 {\n        fill: #9b8760;\n      }\n\n      .cls-card-510 {\n        fill: #b5ae8e;\n      }\n\n      .cls-card-511 {\n        fill: #877455;\n      }\n\n      .cls-card-512 {\n        fill: #857146;\n      }\n\n      .cls-card-513 {\n        fill: #7a6435;\n      }\n\n      .cls-card-514 {\n        fill: #c9c3b9;\n      }\n\n      .cls-card-515 {\n        fill: #635128;\n      }\n\n      .cls-card-516 {\n        fill: #615351;\n      }\n\n      .cls-card-517 {\n        fill: #292522;\n      }\n\n      .cls-card-518 {\n        fill: #786338;\n      }\n\n      .cls-card-519 {\n        fill: #5a4524;\n      }\n\n      .cls-card-520 {\n        fill: #614749;\n      }\n\n      .cls-card-521 {\n        fill: #84667d;\n      }\n\n      .cls-card-522 {\n        fill: #9a7e91;\n      }\n\n      .cls-card-523 {\n        fill: #64513c;\n      }\n\n      .cls-card-524 {\n        fill: #7c5849;\n      }\n\n      .cls-card-525 {\n        fill: #a78193;\n      }\n\n      .cls-card-526 {\n        fill: #85716b;\n      }\n\n      .cls-card-527 {\n        fill: #85754c;\n      }\n\n      .cls-card-528 {\n        fill: #375e5b;\n      }\n\n      .cls-card-529 {\n        fill: #9b8a8c;\n      }\n\n      .cls-card-530 {\n        fill: #c0aea7;\n      }\n\n      .cls-card-531 {\n        fill: #b59fa0;\n      }\n\n      .cls-card-532 {\n        fill: #c6bfbc;\n      }\n\n      .cls-card-533 {\n        fill: #cbc3bb;\n      }\n\n      .cls-card-534 {\n        fill: #574630;\n      }\n\n      .cls-card-535 {\n        fill: #b7998c;\n      }\n\n      .cls-card-536 {\n        fill: #9e9391;\n      }\n\n      .cls-card-537 {\n        fill: #413224;\n      }\n\n      .cls-card-538 {\n        fill: #a39aa3;\n      }\n\n      .cls-card-539 {\n        fill: #bfa39e;\n      }\n\n      .cls-card-540 {\n        fill: #a3887a;\n      }\n\n      .cls-card-541, .cls-card-622 {\n        fill: #af9184;\n      }\n\n      .cls-card-542 {\n        fill: #bf9eb0;\n      }\n\n      .cls-card-543 {\n        fill: #ba9f95;\n      }\n\n      .cls-card-544 {\n        fill: #642742;\n      }\n\n      .cls-card-545 {\n        fill: #7d2756;\n      }\n\n      .cls-card-546 {\n        fill: #47272f;\n      }\n\n      .cls-card-547 {\n        fill: #5a273b;\n      }\n\n      .cls-card-548 {\n        fill: #a68675;\n      }\n\n      .cls-card-549 {\n        fill: #702845;\n      }\n\n      .cls-card-550 {\n        fill: #942d6c;\n      }\n\n      .cls-card-551 {\n        fill: #823e64;\n      }\n\n      .cls-card-552 {\n        fill: #572d3b;\n      }\n\n      .cls-card-553 {\n        fill: #cbb5b0;\n      }\n\n      .cls-card-554 {\n        fill: #c5aea4;\n      }\n\n      .cls-card-555 {\n        fill: #c6bab2;\n      }\n\n      .cls-card-556 {\n        fill: #473c2a;\n      }\n\n      .cls-card-557 {\n        fill: #44555e;\n      }\n\n      .cls-card-558 {\n        fill: #c6b1a9;\n      }\n\n      .cls-card-559 {\n        fill: #bfa699;\n      }\n\n      .cls-card-560 {\n        fill: #b37d7a;\n      }\n\n      .cls-card-561 {\n        fill: #c5a6b1;\n      }\n\n      .cls-card-562 {\n        fill: #9b6865;\n      }\n\n      .cls-card-563 {\n        fill: #824144;\n      }\n\n      .cls-card-564 {\n        fill: #ab8d81;\n      }\n\n      .cls-card-565 {\n        fill: #ba978a;\n      }\n\n      .cls-card-566 {\n        fill: #bfa99c;\n      }\n\n      .cls-card-567 {\n        fill: #bca098;\n      }\n\n      .cls-card-568 {\n        fill: #b7998e;\n      }\n\n      .cls-card-569 {\n        fill: #723c3b;\n      }\n\n      .cls-card-570 {\n        fill: #c0c0bf;\n      }\n\n      .cls-card-571 {\n        fill: #a7968d;\n      }\n\n      .cls-card-572 {\n        fill: #cdc7bd;\n      }\n\n      .cls-card-573 {\n        fill: #c6b2ab;\n      }\n\n      .cls-card-574 {\n        fill: #beafb7;\n      }\n\n      .cls-card-575 {\n        fill: #b4a7ad;\n      }\n\n      .cls-card-576 {\n        fill: #c3aea7;\n      }\n\n      .cls-card-577 {\n        fill: #74675f;\n      }\n\n      .cls-card-578 {\n        fill: #b5988d;\n      }\n\n      .cls-card-579 {\n        fill: #cab9b4;\n      }\n\n      .cls-card-580 {\n        fill: #c8b5ae;\n      }\n\n      .cls-card-581 {\n        fill: #d2bbb8;\n      }\n\n      .cls-card-582 {\n        fill: #cebcb7;\n      }\n\n      .cls-card-583 {\n        fill: #bea299;\n      }\n\n      .cls-card-584 {\n        fill: #c2a8a0;\n      }\n\n      .cls-card-585 {\n        fill: #b79688;\n      }\n\n      .cls-card-586 {\n        fill: #bea49c;\n      }\n\n      .cls-card-587 {\n        fill: #baa39b;\n      }\n\n      .cls-card-588 {\n        fill: #b0948d;\n      }\n\n      .cls-card-589 {\n        fill: #bfa9a0;\n      }\n\n      .cls-card-590 {\n        fill: #b5a39b;\n      }\n\n      .cls-card-591 {\n        fill: #d2c1bf;\n      }\n\n      .cls-card-592 {\n        fill: #937e74;\n      }\n\n      .cls-card-593 {\n        fill: #d3c4c1;\n      }\n\n      .cls-card-594 {\n        fill: #b89785;\n      }\n\n      .cls-card-595 {\n        fill: #cac9c7;\n      }\n\n      .cls-card-596 {\n        fill: #bbaba6;\n      }\n\n      .cls-card-597 {\n        fill: #b8978d;\n      }\n\n      .cls-card-598 {\n        fill: #c2aaa3;\n      }\n\n      .cls-card-599 {\n        fill: #b39c94;\n      }\n\n      .cls-card-600 {\n        fill: #b19488;\n      }\n\n      .cls-card-601 {\n        fill: #a08476;\n      }\n\n      .cls-card-602 {\n        fill: #a8958a;\n      }\n\n      .cls-card-603 {\n        fill: #cfc0bc;\n      }\n\n      .cls-card-604 {\n        fill: #b39a8f;\n      }\n\n      .cls-card-605 {\n        fill: #3c342f;\n      }\n\n      .cls-card-606 {\n        fill: #9aa4a5;\n      }\n\n      .cls-card-607 {\n        fill: #d7c3c2;\n      }\n\n      .cls-card-608 {\n        fill: #a6877b;\n      }\n\n      .cls-card-609 {\n        fill: #3f3634;\n      }\n\n      .cls-card-610 {\n        fill: #8c6b5f;\n      }\n\n      .cls-card-611 {\n        fill: #4f4c3c;\n      }\n\n      .cls-card-612 {\n        fill: #afb5b3;\n      }\n\n      .cls-card-613 {\n        fill: #a29fa6;\n      }\n\n      .cls-card-614 {\n        fill: #756a63;\n      }\n\n      .cls-card-615 {\n        fill: #908072;\n      }\n\n      .cls-card-616 {\n        fill: #c6b2ad;\n      }\n\n      .cls-card-617 {\n        fill: #ad8371;\n      }\n\n      .cls-card-618 {\n        fill: #a8aeb0;\n      }\n\n      .cls-card-619 {\n        fill: #617173;\n      }\n\n      .cls-card-620 {\n        fill: #7e8c89;\n      }\n\n      .cls-card-621 {\n        fill: #cbb9b5;\n      }\n\n      .cls-card-622 {\n        opacity: 0.5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-card-2",
    d: "M1253.75,789s21.19-7.85,23.22-8.9-23.22,8.32-23.22,8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1323.87,665.42c12.8-4.71,25.8-9.18,38.74-13.54,1.69-.26,5.59-3,5.65,0,.23,8.57-.15,17.45-2.29,25.67-.49,1.74.19,4.43-2,5.1-2.87-.11-6.6,1.9-4.15,5,.81,1.42,3.72,2,2.87,4a6.78,6.78,0,0,1-5.83,5.91c-6.52,2.39-13,4.89-19.49,7.31-5.82,2-11.48,4.7-17.42,6.36-1.57-.24-2.22-2.41-3.16-3.56-1.88-1.94,1.13-.86,1.49-3.82,2.2-5.31,2.59,2.37,5.17,1.1,1.76-.92,4-1,5.48-2.34-2.4,0-5.17,3.2-6.66.25-.59-1.43-2.68-3.28-2.08-4.8a96.08,96.08,0,0,0,4.41-23C1324.71,672,1325.6,668.17,1323.87,665.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-4",
    d: "M1363.61,682.18c1.73-.13,1.71-2.85,1.5-4.18,1.76-.58,5.77,9.08,7.32,8.54.7-.42-.12-.93-.3-1.4-.61-4.35,4.2.27,6-.63-3.1-1.65-6.46-1.16-4.6-5.63-1.47.11-1.26,1.75-1.77,2.72-2.24,3.51-3.37-4.72-6-3.7-.23.07-.45-.14-.64-.29,3-8.05,2.61-17.5,2.6-26.16-.81-1.92-3.55.68-5.1.43,5.34-2.2,11-3.86,16.38-5.86,1.59-.58,3.57-1.29,4.7.46,7.71,10.68,16.54,20.76,24,31.54-.12.64-.69.74-1.16.92-6,2.27-12,4.58-18.07,6.74-8.63,3.41-17.35,6.56-26,9.83-.52.2-1.29.53-1.68,0,.45-1.25,2.12-4.31,1.24-5.36,1-.72,2.55-.09,3.73-.73,3.87-1.23,1.8-5.35-1-6.36C1364.25,682.81,1363.59,682.92,1363.61,682.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-5",
    d: "M1319.58,702.23c-1.45,2.55-1.19,6.69-4.68,3.2a22.54,22.54,0,0,1-2-2.11c-.48-.41-1.27-.53-1.39-1.27-.48-1.54-2.07-1.19-3-2-.21-.51-.69-.57-1.18-.65-1-.66-.69-1.93-2.3-1.43-2.94-.68-5.77-2.3-8.82-2.88-15-3.5-11.32,2.07-10.9-10.14-.53-1.41.93-2.08,1-3.3a2.87,2.87,0,0,1,.38-2.19c.29-.39-.22-.64-.27-1,7.92-3.23,16.42-5.44,24.23-8.46h0c.46-.15,1.13-.35,1.49,0,.14-.06,0,.06-.06-.08,0-.54.51-.44.75-.68h0c.21-.21.55,0,.74-.26h0a8.51,8.51,0,0,0,2-.71h0c1.54-.47,3.86-.31,4.84-1.7.92-.47,2.12-.1,2.9-1h0c.21-.2.56,0,.74-.25h0c2.76-.95,1.18,9.64,1.11,11.42-.59,1.36,1.06,2.54.15,3.5a4,4,0,0,0-.79,3.6c.12,1.41-1.21,2.51-.75,4-.73,3-1.95,6-2.37,9.14,0,.63-.5,1-1,1.3-1.3-1.22-1.2-3.2-3.56-2C1317.39,698.43,1319.31,700.06,1319.58,702.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-6",
    d: "M1286.35,678.51h1.22c.3,1.1-1.23,1.55-.8,2.69a1.74,1.74,0,0,1-.71,2.11,1,1,0,0,0-.33,1.29c.79,2.86-.45,5.69-1.06,8.44-1.38.87-3.1.62-4.63.79a50.5,50.5,0,0,0-11.4,2.13c-14.23,3.79-28.18,16-29.46,31.37-1,2.79.33,5.68.58,8.49.21,1.7,1.47,3.36,1.24,5-1.17.9-5.81,3-7,2.38-3-4.45-4.72-10.49-7-15.53,8.27-10.52,16.14-21.93,19.16-35.16,13.07-4.78,26.29-9.33,39.48-13.78.2-.21.55,0,.74-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1424.9,700.08c3.37,4.89,8.25,9.49,10.8,14.58-1.22,1.68-3.74,1.47-5.31,2.47-.49.21-1,.72-1.54.51-.75-1.78-2.65-1.15-3.84-2.2-.72-.65-1.41-1.27-2.53-.72-1.13.34-1.93-1.45-3.26-1.24-2.27.5-2.72,4.16-4.21,5.84-.6,1-1.6,1.69-2,2.82-.17.45-.74.46-1.17.2-4.19-2.52-9.26-2.34-13.51-4.69-.2-.14-.49-.22-.56-.44-.5-1.6-1.77-.75-2.71-.83-2,.46-2,3.52-3.34,4.9a2,2,0,0,1-3.4.37,3,3,0,0,0-2.08-.8c-1.9,0-3.26-1.41-4.86-2-1.58.45-2.69-.47-3.84-1.27-1.42-1.28-6.63-.66-4.9-3.58a24.66,24.66,0,0,0,2.92-5.13c.6-.61.54-3,1.82-1.52-1.16-1.53,1.22-2.2,2.22-.65.12.15.17.37.41.38s.44-.41.73-.48.78.12,1.18.14c3.38,2,7.31,2.53,10.85,4.18.94.3,2.41,1.35,2.91,0,1.62-2.71,2.18-6.23,4.91-8.07,1-1.13,2.18.9,3.22,0,.49-.4,1-.38,1.27.27,2,2.16,5.44,4.1,8.47,3.14,1-.45,1.61-.09,1.6,1s.58,1,1.3,1.13c2.5.68,3,.48,4.09-1.92C1422,704.62,1422.51,700.76,1424.9,700.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-8",
    d: "M1246.14,692.54c1.09,7.09-13.25,30.81-19.13,35.16-3.48-7.31-6.49-14.92-9.78-22.34-.5-1.06-1-2.36.41-2.85,9.36-3.7,19-6.61,28.52-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1424.9,700.08c-2.27,3-2.22,5.33-6.6,3.95-3-1.76-6.39-2.27-9.54-3.61-.91-.47-2.06.17-2.66-1a2.27,2.27,0,0,0-4.16.45c-.55,1.56-1.85,5.3-4.1,3.83-1.61-.76-3.6-.62-5.24-1.52-.86.26-1.31-.61-1.76-1.16-2-.39-4.43-.61-6.1-2.17a1,1,0,0,0-1.14-.38c-3.81.35-3.07-4.33-1.17-6.22.4-.57,1.14-.33,1.61.14,1.23,1.4,2.81-1.77,3.75.45.79,1.56,1.67-1,4.24,1.59,1.13,1.16,1.25-.7,2.57.19,10.9,4.5,5.45,2.32,10.35-3.2.57-.28.18-.69.22-1a4.35,4.35,0,0,1,2.22-3.71,1.27,1.27,0,0,1,1.73.2c1.12,1.39,3.1-.11,4.38,1.19.64,1.2,2.59,0,2.87,1.81C1419.63,692.73,1422.19,696.54,1424.9,700.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-10",
    d: "M1413.28,688.21c-.79.28-1.85-.89-2.25.12a.3.3,0,0,1-.5.12c-.59-.44-1.49-.43-1.84-1.25-.2-.45-.52-.4-.88-.16-1.42.64-1.71,2-2.28,3.35-1.14,1.07-2.37,1.62-3.89.76-2.66-1.37-6.94-1-8.56-3.85-1.73,1.13-1.95-1.1-3.47-.78-.84.14-1.42-.26-1.32-1.24,6.36-2.61,12.86-5,19.37-7.26,3.52,3.47,6,8,9.23,11.64a1.94,1.94,0,0,1,0,.24c.23.25.48.47.7.73l0,.24a2.83,2.83,0,0,0,.24.25c-2.06,1.13-1.54-2.56-3.45-1.86-1.3.29-1.3.29-1.15-1a3,3,0,0,1,.26-.25A3.13,3.13,0,0,0,1413.28,688.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-11",
    d: "M1234,743.23c1.69-.3,7.28-4,7.82-1.7,2.29,4.59,6,8.44,10,11.71.51,1.22-1.09,2.07-2.14,1.18a1.52,1.52,0,0,0-2.21.31c-9.21,8.75-5.91,5-11.5-5.76h0C1235.69,747.56,1233.19,744.22,1234,743.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-2",
    d: "M1316.64,763.73c-20.06,7.66-40.5,17.54-60.44,24,.07-.83.78-1,1.35-1.2,6.5-2.61,13-5.27,19.47-7.89,9.63-3.89,19.1-7.78,28.73-11.65C1307.72,766.64,1316.06,761.58,1316.64,763.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-12",
    d: "M1316.64,763.73l-.54-.26c0-1.13,1.77-1.11,2.55-1.55,11.14-4.94,22.5-9.32,33.79-13.77.44.13,1.09-.2,1.24.55C1341.34,753.71,1329,758.86,1316.64,763.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-13",
    d: "M1353.68,748.7c-.41-.26-.81.1-1.21,0-.1-.84.6-1,1.13-1.17,5.17-2,10.23-4.37,15.45-6.18,2.1-.35,9.17-5.09,10.3-3.08C1370.8,741.77,1362.28,745.34,1353.68,748.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-14",
    d: "M1379.35,738.29c-.41-.25-.82.1-1.23,0-.08-.77.54-.91,1-1.12,5.65-2.37,11.37-4.53,17-7,1.32,0,6.18-3.29,6.46-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-15",
    d: "M1402.61,728.86a1,1,0,0,0-.72-.22c.27-1.77,10.63-4.63,12.87-6,1.9-.32,10.59-5.42,11.09-3.27a.37.37,0,0,1-.18,0C1418,722.68,1410.31,725.78,1402.61,728.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-16",
    d: "M1236,749c2,3.32,3,7.2,4.86,10.64,2.34,2.4,3.05,6.4,4.53,9.42.37,1.3,2.62,4.07,1.47,5.15C1243,765.91,1239.27,757.46,1236,749Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-17",
    d: "M1425.85,719.41a1.06,1.06,0,0,0-.71-.22c0-1.12,2.75-2.05,3.87-1.72.33-.16.67-.29,1-.44h0c1.54-.93,3.51-1.07,5.07-2h0c.1-.06.17-.15.26-.21C1436.75,715.83,1427,718.62,1425.85,719.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1320.27,666.66c1.33,2.29-1.7.7-2.51,1.76-.33.25-.66.46-1.06.08s-.85-.06-1.27-.14A34.28,34.28,0,0,1,1320.27,666.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1310.58,670.05c-.46.69-2.45.52-1.74,1.7.48.64-.69,1.25-1.08.64-.37-.41-.64-.94-1.31-.89A21.54,21.54,0,0,1,1310.58,670.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-18",
    d: "M1251.69,785.32a22.3,22.3,0,0,1-2.41-5.89C1250.2,779,1252.86,785.05,1251.69,785.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-19",
    d: "M1256.33,787.68l.27.28c-1.16.31-2.84,1.77-3.65.23-.1-.22,0-.34.18-.44C1254.18,787.91,1255.49,786.88,1256.33,787.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-16",
    d: "M1233.77,743.44c.67,1.86,1.81,3.61,2.22,5.54C1235.36,748,1233.42,744.38,1233.77,743.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1323.17,665.67c-.2.35-.3,1.29-.85,1.08-.67-.48-1.37,0-2-.09A10.58,10.58,0,0,1,1323.17,665.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-6",
    d: "M1246.16,692.55a14.06,14.06,0,0,1-4.9,1.69A26.53,26.53,0,0,1,1246.16,692.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-18",
    d: "M1253.17,788l-.22.22a9.55,9.55,0,0,1-1.26-2.87l0,0A2.08,2.08,0,0,1,1253.17,788Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1312,670.06h-1.46a6.06,6.06,0,0,1,2.18-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1315.43,668.36a2.14,2.14,0,0,1-2,.71A4.3,4.3,0,0,1,1315.43,668.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-20",
    d: "M1435.54,715.29l-.21-.43a1.49,1.49,0,0,0,.15-1.25C1436.16,714.46,1436.16,714.48,1435.54,715.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-21",
    d: "M1247.59,775.87a3.35,3.35,0,0,1-.74-1.69C1247.64,773.8,1248.41,775.51,1247.59,775.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-21",
    d: "M1248.32,777.55a3.11,3.11,0,0,1-.73-1.68l0,0c1.08.1,1.2.72.87,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-22",
    d: "M1249.32,779.46l0,.3a3,3,0,0,1-.72-1.73l.18-.07C1249.5,778.25,1249.81,778.71,1249.32,779.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-5",
    d: "M1286.36,678.51a.88.88,0,0,1-.74.25A1.11,1.11,0,0,1,1286.36,678.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1313.49,669.06a.89.89,0,0,1-.74.26A.92.92,0,0,1,1313.49,669.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1323.9,665.43a.85.85,0,0,1-.74.25A1,1,0,0,1,1323.9,665.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-6",
    d: "M1226.76,727.19a.74.74,0,0,1,.25.51A.65.65,0,0,1,1226.76,727.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-23",
    d: "M1248.57,778a.64.64,0,0,1-.25-.48l0,0C1248.76,777.53,1248.74,777.76,1248.57,778Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1415.92,688.45l-.22-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-17",
    d: "M1425.41,719.61l.26-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1417.88,691.11l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1417.61,690.63l-.21-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1417.38,690.39l-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1417.15,690.15l-.24-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1416.89,689.66l-.21-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1416.65,689.42l-.22-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1416.42,689.18l-.23-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1415.45,688l-.23-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1415.69,688.21l-.23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-24",
    d: "M1319.79,711q13-4.94,25.94-9.8c2.63-1.29,5.22-.31,7.44,1.13,1.08.36,2.57.42,2.71,1.91a1.32,1.32,0,0,1-1.59.89c-1,.76-2,.65-1,2.06-.9-1.37.21-1.46,1-2.06,1.06.29,1.17,1.38,1.77,2.06,1,1.5,0,2.65-.67,3.85-.36.9-.63,2.26-1.78,2.3.85.58-.07,1.69-.8,1.85-.93-.07-1.52-1.15-2.62-.95-1.6-1.35-3.83-1.66-5.46-3-.47,1-1.59.08-1.94-.62-.51-.88-1.09-.61-1.78-.18-1.27.87,1,1.71.24,2.78-1.39,1.53-2.65-3.13-4.39-3.55-.33.79-.46,1.73-1.4,2.1-.58.23-.08.79-.33,1.11-.2.78-1.32.65-1.55,0,.13.52.82.9.64,1.63-.1,1.16-1.39.86-1.74,0,0,.29.43.63.54,1,.78,1.73-1.38,1.91-2.45,1.8-1.06.14-1.72-1.6-.56-1.93,0,0,.09-.07.08-.07-.6.21-1.3.43-1.69-.32a.81.81,0,0,1,.22-1.18c-1,.63-1.61,2.51-3.17,1.47-1.61-1.3-4.45-.6-5.43-2.51C1319.77,712.25,1319.18,711.44,1319.79,711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-25",
    d: "M1355.55,685.19c-.85.23-1.64,1-2.45.26-1.34-1.31-6.07.34-3.76,2.25,2.29.85,4.81-.52,7.17.24,2.32.52,3.59,3.27,1.29,4.72-2.45,1.72-6.57,2.58-8.65-.18,2.72-2.21,3.12,2.06,7.11-.9,1.67-4.43-7.69-.12-9.34-3.15C1343.94,684.06,1354.06,681.51,1355.55,685.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-26",
    d: "M1355.64,704.22a2.92,2.92,0,0,0-2.91-1.2c-.41-1.32-1.86-.91-2.65-1.59-2.2-1.42-1.85.56-3-.67,4.43-2,9.16-3.33,13.61-5.29l.23,0c.42,1.2-.36,2.13-.72,3.16.1.89-.57,1.57-.72,2.41a4.39,4.39,0,0,1-1.48,2.66c-1.64.72.19,2.66-1.25,3.5C1354.86,706.71,1355.26,705.49,1355.64,704.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-27",
    d: "M1365.11,677.61c.68,0,1.29-.76,1.94-.46,1.5,1.54,2.39,3.45,3.84,5.3.77-2.22.83-4.23,3.47-4.55-1.33,5.86-2,3.17,5.29,6.59-2.11,1.72-4.1,0-6.23-.71-.28-.11-.59-.38-.84,0-.64,1,.8,1.9,1.22,2.82-.66.51-2,1.32-2.44.25-2.11-2.94-4-6-6.25-8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-28",
    d: "M1319.1,710.41c1.75,1.62-1.51,3,2,3.42,1.09.88-.93,2.14-1.92,2.06-.74,0-.8.76-1.09,1.27-.39.68-.07,1.79-1.21,2-.8-.22-.85-1.2-1.35-1.49s-1.38.08-2-.3c-3.09-1.52-4-5.85-.06-7,3.19-.26.72-4.13,3-3.63l0,0a.32.32,0,0,0,.25.29h0c1,2.05.22,4.27-2.13,4.64a1.93,1.93,0,0,0-2,1.28c-1.52,1.51,1.66,3,2.67,2.38C1317.87,714.59,1315.87,709.76,1319.1,710.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-29",
    d: "M1331.73,693.69c.92-.75,2.26-.65,3.15-1.28,1.2-1,1.93-.66,2.53.72-4.47,1.42-.19,4.23.85,6.79-1.53,1-2.11,1.15-3-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-30",
    d: "M1320.94,699.82c.89.84,1.87,4.37,3.2,3.83s2.77-1,4.17-1.57c1.06-.52,1.26-.09,1.67.9-2.1,1.32-4.9,1.84-7.22,2.92-.56.21-.86.16-1.14-.39-.93-1.74-3.24-4.34-.85-5.93h0A2.07,2.07,0,0,1,1320.94,699.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-31",
    d: "M1364.87,682.62c6.51,2.32,3.1,9.54-3,7.31-.24,0-.38-.29-.64-.23-.11-.1-.2-.22-.34-.25h0c-.08-1.07,1.38-.56,1.92-1.15C1369.88,687.91,1361,683.87,1364.87,682.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-32",
    d: "M1319.1,710.41c-.77.16-1.19.81-1.73,1.28h0c.26.38,0,.86.29,1.27s-.32.4-.38.66a6,6,0,0,1-2.77,2.81c-.48-.54-1.42-.25-1.78-1-.88-1-1.7-1.53-.38-2.7.12.09.41.16.47.41,0,1.08,2.7,1.58,2.87.73-.07-1.85-2.47-.38-3.34-1.14.13-2.13,2.64-.75,3.42-2.35.18-.36.6-.32,1.07-.36a1.59,1.59,0,0,1-.19-1.87C1316.33,705.67,1318.77,709.74,1319.1,710.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-33",
    d: "M1364.87,682.62a1.46,1.46,0,0,0-.53,1.5c-.41.53-1,.23-1.45.25-2.33,0-1.62,2.24-.39,3.26a.84.84,0,0,1,0,1.51c-.19.25-.35.39-.65.12s-.63,0-.9.19c-4.65-2.67-2.21-7.58,2.7-7.27C1364,682.45,1364.52,682.28,1364.87,682.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-34",
    d: "M1327.42,695.3c1.65-1.08,1.94-1,2.93.65l3.49,5.65c-1.6.95-2.11,1.13-3-.64C1329.71,699.06,1328.37,697.26,1327.42,695.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-29",
    d: "M1344.67,697.61c-2,1-2,1-3.12-.73s-2.08-3.27-3.11-4.91c-.43-.68-.41-.7.34-1C1340.82,689.3,1343.18,696.14,1344.67,697.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-35",
    d: "M1320.77,699.58a7.06,7.06,0,0,1-1,2.69.65.65,0,0,0-.2,0h0a4.91,4.91,0,0,1-.74-1.22l0,0a9,9,0,0,1-.74-1.24l0,0c-.21-.09-.16-.34-.28-.47h0a2.21,2.21,0,0,1-.46-.76l0,0c-.22-.09-.16-.34-.29-.48h0a2,2,0,0,1-.46-.77l0,0c-.23-.09-.17-.34-.29-.49h0c-.82-.7.12-1,.81-1.16.2,0,.44-.21.68-.24s.48-.36.62,0l0,0c.24.07.18.33.3.48h0c.5.25.59.75.73,1.22h0c.5.25.58.75.73,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-36",
    d: "M1337.84,690c-1.91,0-1.47-2.09.24-2S1339.26,690.08,1337.84,690Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-37",
    d: "M1327.33,691.93c1.28.07,1.72,1.54.23,1.92C1325.66,694.45,1325.17,691.89,1327.33,691.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-38",
    d: "M1316.46,706.8c-1.86.46.69,3.89-3,3.93-.44-1,1.57-1.11,1.4-3.56-.09-.5-.07-2,1-1.24l0,0a.42.42,0,0,1,.26.29l0,0a.35.35,0,0,1,.26.29A2.42,2.42,0,0,0,1316.46,706.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-33",
    d: "M1361.9,689.93l.51.18H1362Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-35",
    d: "M1320.94,699.82l-.17-.24A.22.22,0,0,1,1320.94,699.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-35",
    d: "M1321.23,700.31l-.2-.31A.34.34,0,0,1,1321.23,700.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-38",
    d: "M1316.69,707.07l-.25-.29A.33.33,0,0,1,1316.69,707.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-38",
    d: "M1316.9,707.32l-.26,0a2.36,2.36,0,0,1,0-.28A.26.26,0,0,1,1316.9,707.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1319.56,711.2a.78.78,0,0,1,0-.22.5.5,0,0,1,.21,0l0,.3C1319.66,711.34,1319.59,711.31,1319.56,711.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-33",
    d: "M1361.34,689.69l.34.17A.34.34,0,0,1,1361.34,689.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-33",
    d: "M1360.92,689.45l.28.18A.25.25,0,0,1,1360.92,689.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1359.75,698.62c.56-1,.53-2.18,1.2-3.11,9.12-3.39,18.16-7.08,27.34-10.23,1.65,2.33,1.66-1.44,3.38,1.73.32.22.66.37.9-.1s1.19-.89,1.58-.34c.17.32-.17.37-.32.53-.87.82.72.94,1.27,1.1.2,0,.52,0,.56.15.35.92,1.17.75,1.87.9s1.5.51,2.29.7c1.55-.15,3,2.14,4.32.65.29-.39.91-.18,1.39-.21.18.6.82.83,1.18,1.27-.14.14-.2.25-.24.25-2.75-.75-2.6,3.35-3.78,5-.74,2.14-2.26-.2-3.7.37s-.88-1.34-1.87-1c-.47.24-.79.07-1.2-.22s-2.72-2-2.53-.62c.11.32.39.64,0,1-.8-.85-3.54-3.83-4.51-2.38a.84.84,0,0,1-.93.37c-.91-.23-.19-1.25-.79-1.72-.42-.41-.68-.37-1,.18-2.07,2.09-2.76-1.47-3.43-.31-1.54,2.17-1.38,4.72-2.22,7.06-.83,1.74-1.18,4-2.68,5.24-1,.27-1.75-1.28-2.4.1-1.16.91-1.88-1.39-3.37-1-1,0-2.6-.34-2.68-1.61-.31-.56-1-1-1.18-1.64-1.16-1.68-1.82,1.52-3.27.74A8.66,8.66,0,0,1,1359.75,698.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-41",
    d: "M1382.55,683.35a5.68,5.68,0,0,1-5.13-3.3c-2-5.77,8.18-6,9.42-1.14C1388.05,681.61,1384.87,683.35,1382.55,683.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-42",
    d: "M1388.39,674.39l4,5.31c-.17.16-.22.24-.28.26-2,.77-1.5.81-2.66-.75-.86-1.38-2.77-2.75-2-4.56C1387.6,674.15,1387.92,673.93,1388.39,674.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-43",
    d: "M1388.39,674.39c-.87-.08-.43,1.34-1.06,1.79-1.39-1.62-2.54-3.4-3.84-5.12C1386,669,1386.92,672.93,1388.39,674.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-44",
    d: "M1298.72,695.47a2.38,2.38,0,0,1,.74.24c.2.72-.41.76-.81,1-1.43.33-3.18,2.35-1.52,3.46s4.09.2,6.1.57c2.39.43,2.8-2.41,4.2-1.56h0c.25.13.63.1.67.5-.89,4-6.5.83-8.46,3.48-1.27.55-2.6.94-3.84.07-.51-2.32-3.92-5.19-.23-6.73a4.16,4.16,0,0,0,1.78-.86C1297.7,695.23,1298.26,695.62,1298.72,695.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-45",
    d: "M1296.3,694.76c1.37-.07,1.61,1.33.37,1.36s-1.94,1-2.93,1.49c-.15.07-.37.09-.41.24-.35,1.68-1.79,1.58-3,1.86a1.75,1.75,0,0,1-1.53.79,1,1,0,0,1-.58-2c1.34-.92,1.38-1.13.62-2.56a2.48,2.48,0,0,1-.51-2.53c.77-.2,1.31.71,1.63,1.21C1291.5,696.67,1294.36,695.47,1296.3,694.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-46",
    d: "M1307,699.06c-1.43,2.69-4.53,1.81-7,2-1.78.83-2.86-.3-3.91-1.4-1.75-2.1,2.16-3,3.34-4a8.24,8.24,0,0,1,2.15.77c.06.47-.3.6-.6.53-.86-.19-1.53.35-2.3.48s-.89.75-.89,1.36c.21,1.27,4,.89,5.22,1.13C1304.8,700.34,1305.83,696.72,1307,699.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-47",
    d: "M1306.23,698.61c-2.45,3-4.2,1.35-7.53,1.51-2.26.49-1.79-2.56-.41-2.94,1-.27,1.89-.93,3-.56.08,0,.21-.09.32-.14a14.33,14.33,0,0,1,2,.69c.36.2.76.33,1.12.53C1305.31,697.84,1306.16,697.59,1306.23,698.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-48",
    d: "M1293.39,697.17c1.14-.37,2-1.37,3.29-1.44.31,0,.73-.19.59-.7a3.32,3.32,0,0,1,1.45.44c-2.2.77-6.43,2.62-3.46,5.11,1.45.55.86,3.2-.59,2.81C1293.77,701.38,1292.35,699.43,1293.39,697.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-49",
    d: "M1288.55,695l.24.24c-.12.46.25.73.43,1.07a1.62,1.62,0,0,1-.71,2.28c-.5.18-.74.95-1.43.62-.79-.82-.08-1.7-.12-2.56-.29-1.06-.48-2.16-.69-3.25l.09-.13a11.18,11.18,0,0,1,2.94.25l-.12.13c-.28,0-.56-.07-.84-.06C1288.3,694.06,1288.07,694.58,1288.55,695Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-50",
    d: "M1289.3,693.51a26.91,26.91,0,0,1,6.77,1.22C1295.13,696.28,1289.25,696.32,1289.3,693.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-51",
    d: "M1282,693.27a14.42,14.42,0,0,1,3.28-.18h0c2.88.25-.51.91-1.48.65-1.52.15.34,2.14-.81,3.15-.21,2.14-.77,2-2.23.66C1279.64,696.66,1281.29,694.14,1282,693.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-52",
    d: "M1289.32,693.63c1.5,2.35,4.81,1.76,7,1.13-.62,1.37-2.84,1-4.1,1.38-1,.76-1.55-.08-2-.72s-1.22-1-1.31-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1308.91,700c1.12.12,2.75.73,2.91,2l-.12.13c-1.14.25-1.71-.73-2.53-1.18C1309,700.7,1308.64,700.35,1308.91,700Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1312,670c.49.06,1.33-.07,1.36.62C1313.16,671.8,1311.75,671,1312,670Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1306.23,698.61l-1.53-.92c1.31-.39,1.94-.07,2.25,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1316.64,696c-.46.23-.34.58-.21.94C1315.4,696.68,1315.61,695.34,1316.64,696Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1307.9,699.6l-.49-.47c.56,0,1.17-.14,1.26.69A.44.44,0,0,1,1307.9,699.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1319.52,697.2a3,3,0,0,1-.73-1.22C1319.68,696,1319.53,696.64,1319.52,697.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1320.25,698.41a2.83,2.83,0,0,1-.73-1.22C1320.41,697.21,1320.25,697.86,1320.25,698.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1318.85,701a2.79,2.79,0,0,1,.74,1.22A1.37,1.37,0,0,1,1318.85,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1312.3,702.47a1.54,1.54,0,0,1,1,.74C1312.85,703.77,1311.88,703,1312.3,702.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1318.13,699.79a1.24,1.24,0,0,1,.46.76A.78.78,0,0,1,1318.13,699.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1316.69,697.36a1.24,1.24,0,0,1,.46.77A.75.75,0,0,1,1316.69,697.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1317.41,698.58a1.19,1.19,0,0,1,.46.76A.78.78,0,0,1,1317.41,698.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1304.38,694.27c-.05.13-.23.06-.14-.06S1304.36,694.19,1304.38,694.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1317.24,695.75a.65.65,0,0,1-.59.22A.82.82,0,0,1,1317.24,695.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1318.59,700.55a.56.56,0,0,1,.27.48A.66.66,0,0,1,1318.59,700.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1303.56,697.16a.63.63,0,0,1-.5-.22A.74.74,0,0,1,1303.56,697.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1316.42,696.9a.61.61,0,0,1,.29.49A.62.62,0,0,1,1316.42,696.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1318.8,696a.62.62,0,0,1-.3-.48A.59.59,0,0,1,1318.8,696Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1317.92,695.51a.58.58,0,0,1-.55.2A.78.78,0,0,1,1317.92,695.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1304,697.38a.57.57,0,0,1-.46-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-46",
    d: "M1299.44,695.71a.65.65,0,0,1-.47-.2A.5.5,0,0,1,1299.44,695.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1318.54,695.56l-.44-.11C1318.29,695.3,1318.44,695.33,1318.54,695.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1317.14,698.12a.54.54,0,0,1,.28.48A.65.65,0,0,1,1317.14,698.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1307,699.06a1.46,1.46,0,0,0,0-.2.68.68,0,0,1,.46.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1317.87,699.34a.59.59,0,0,1,.28.47A.6.6,0,0,1,1317.87,699.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1314.71,704.65l.26.25-.13.07a.35.35,0,0,1-.19-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1314.47,704.41l.24.24,0,0a.24.24,0,0,1-.27-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1315,704.9l.24.25-.16.05a.24.24,0,0,1-.12-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1314.23,704.17l.24.24,0,0a.24.24,0,0,1-.26-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1314,703.93l.25.24,0,0a.25.25,0,0,1-.26-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1315.21,705.15l.24.24-.15.05a.23.23,0,0,1-.13-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1313.74,703.68l.24.25,0,.05a.29.29,0,0,1-.26-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1315.45,705.39l.24.25-.16.06a.26.26,0,0,1-.12-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1313.5,703.44l.24.24,0,.06a.26.26,0,0,1-.25-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1315.89,705.93c-.16,0-.48-.14-.25-.26l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1308.67,699.82l.24.22c-.16.15-.29,0-.3-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1313.27,703.21l.23.23,0,.07a.21.21,0,0,1-.25-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1316.13,706.19a.34.34,0,0,1-.26-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1316.36,706.44a.34.34,0,0,1-.26-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1304.52,697.63a.41.41,0,0,1-.33-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1312.05,702.23l.25.24,0,0a.23.23,0,0,1-.28-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-3",
    d: "M1311.82,702l.23.23,0,0c-.17,0-.25,0-.27-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-53",
    d: "M1285.25,693.08h0c0-.15.14.07.06-.07s-.08-.09-.14,0S1285.24,692.92,1285.25,693.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-54",
    d: "M1238.67,727.18c-.42-2.65,4.64-18.11,7.81-15.8,4.47,3.65,7.32-1.86,6.33,4.46-1.88,5.71-6.56-1.64-8.56,2.55C1242.65,721.29,1241.51,725.49,1238.67,727.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-55",
    d: "M1263.61,697.18a23.07,23.07,0,0,1,4.83-1.69.83.83,0,0,1-.58,1.23,31.81,31.81,0,0,0-10.16,7.77,8.82,8.82,0,0,1-2.37,3.26c-1.36.61-2.22,2.37-4,1.82-1.18-.49-3.3,0-3.44-1.75C1251.88,702.49,1258.27,700.63,1263.61,697.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-56",
    d: "M1238.67,727.18c.34-1.17,1.45-1.83,1.89-3a3.84,3.84,0,0,1,1.23-1.86,1.56,1.56,0,0,0,.56-1.16c.24-1.47,1.39-2.58,1.75-4s1.16-.26,1.92-.63c.51-.48.88-.27,1.34.11,4.39,3,3.68-1.13,4.69,0,.15.18.15-.45.41-.56,1.06.2.27,1.35.68,1.94a1.72,1.72,0,0,1-2,2.06c-.41-.06-.68.23-1,.43-1.41,1.47-3.2-1.31-4,.6-3.29,9.36-5.6,2.86-7.58,10A9.81,9.81,0,0,1,1238.67,727.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-57",
    d: "M1247.86,707.82c1,1.11,2.62.63,3.9,1.29,1.27.37,2.21-1.42,3.37-1.77.69.38.78.84.15,1.37a12,12,0,0,0-1.31,3.82,1.09,1.09,0,0,1-1.27.37c-2.62,1.21-5.53.14-7.51-1.93A18.25,18.25,0,0,1,1247.86,707.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-58",
    d: "M1256.82,705.4c.71-2.71,5.89-5.88,8.16-7.37.66-1.58,2.74-1.15,3.46-2.54a33.68,33.68,0,0,1,7.75-1.72c.14,1.52-1.18,2-2.09,2.55-1.75,1.54-2.78.44-4.55,1.28-2.42,0-4.09,2-6.25,2.81a1.72,1.72,0,0,0-1,.89c-.34.7-1.19.68-1.66,1.2C1259.47,703,1257.84,705.7,1256.82,705.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-59",
    d: "M1238.62,731.11c0-2.81,2.28-4.32,4.91-4.34,2.88-.14,3.53-4,6.74-3.82,1.12.09,1.82-1.11,2.9-1,1,.38.3,1.29.07,1.92-1.8,1.65-4.29,2.48-6,4.36a1.65,1.65,0,0,1-1.29.55c-2.45.09-6.07-.48-6.54,2.77-.4.61.17,1.48-.57,2A6.55,6.55,0,0,1,1238.62,731.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-60",
    d: "M1269.4,697.15c.85-.52,1.92-.23,2.79-.31.62-1,2-.78,2.61-1.79.31-.51,1.1-.65,1.39-1.28a15.83,15.83,0,0,1,3.88-.45c-.29,4.83-2.19,3.55-5.63,4.23C1273.44,697.82,1269.6,698.52,1269.4,697.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-61",
    d: "M1238.87,733.52c.13-.73-.18-1.52.27-2.22.66,0,.89.6.86,1.15,1,2.87,4.11,5.29,1.06,8.3l-.32,0c-.39-1.65,0-3.49-1.38-4.8A6.71,6.71,0,0,1,1238.87,733.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-62",
    d: "M1282,693.27c0,.67-.4,1.28-.31,2,0,.32-.27.45-.47.63-1.22,1,.14,1.51.79,2.25-.47.72-4.11-.09-4.65-.76C1281.07,696.42,1278.64,693.07,1282,693.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-63",
    d: "M1263.61,697.18a8.17,8.17,0,0,1-6.57,3.36A34.77,34.77,0,0,1,1263.61,697.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-64",
    d: "M1280.8,693.31c-.56,1.66-.62,4-2.91,3.86-1.27.22-2.4.83-3.63,0,1.45-.77,4,.71,4.7-1.34.35-.83.41-1.85,1.11-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-65",
    d: "M1239.36,735.91c2,.56,1.56,2.33,1.22,3.88A13.59,13.59,0,0,1,1239.36,735.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-55",
    d: "M1247.86,707.83l-.24.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-55",
    d: "M1247.62,708.07l-.22.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-66",
    d: "M1429,717.47l-3.87,1.72h0c-.14.16-.36.12-.52.23-7.34,2.74-14.57,5.9-21.87,8.78-3,2-5.94-1-8.86-1.45-1.44.1-3.34-2.5-4.5-.7s-4.16,9.52-6.79,7.25c-.91-1.23-2.34-.06-3.32-.91-1.12-1.22-2.69-1.15-4.12-1.46-1.73-.59-2.26-2.9-4.48-2.77-.2,0-.4-.14-.58,0-1.27.88-2.18-.07-3.18-.62,0-2.4,2.19-4.75,3.13-7,1.1-2.45,2-5.3,5.18-3.77,1.23.28,2.75.27,3.71,1.19a1.62,1.62,0,0,0,1.77.44c2-.37,3.3,2.18,5.52,1.86.65,0,1.25.52,2,.34.32-.08.41.28.51.56,1.87,2.81,3.61-2.36,4.37-3.78.77-2.41,2.19-1.08,3.9-1.87s.4,1.46,1.5,1.68a3.4,3.4,0,0,1,1.36.76c.64.52.9-.9,1.59.21.53.83,1.6.42,2.35.66,2.92,1.41,6,1.52,8.8,3.33.33-2,2.59-3.18,3.17-5.23,1.46-2.59,2.27-5.81,5.71-3.11.84,1.6,2.11-1.19,3,.46,1.41,2.25,4.36.48,4.24,2.7A1.7,1.7,0,0,0,1429,717.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1378.89,702.25l.24-1c1-1.31,1-3.19,1.94-4.59,1.36-.38.52,2.18,2.73,1.11,1.15-.65,1,.84,1.9,1.18,1.16.75,2.61.71,3.67,1.61,0,2.36-4.32-.24-1.31,3.58.23.1,0-.13,0-.19a2.27,2.27,0,0,1-.3-.32s-.07-.09-.08-.09c-1.43-2.42,1.42-2.45,2.21-.36,0,0,.08.1.13.11s-.15-.23-.2-.31c-1.83-2.23,1-2.92,2-.65,0,0,.12.11.16,0a6.35,6.35,0,0,1,1-1.24c1.16,2.29,3.87.71,5.36,2.25,2.06,1.33,2.51-3.15,3.4-4.28a4.15,4.15,0,0,1,2.16-1.76c1,.48,2.07.7,2.7,1.74.49.79.56.77,1.4.38s1.11,1.23,2.38.78c.28,0,.66-.18.8.07.65,1.2,2.19.62,3,1.54.16.18.47,0,.68-.08,1.61-.84,2.33,2.85,7.67,1.92-.89,1.66-2.2,5.71-4.16,5.91a16.14,16.14,0,0,0-2.42-.71c-.79.35-2.55-1.54-1.3-1.78.36-.08.12-.38-.06-.53-1-.26-1.21,1.39-3.2.33-1.07-.2-2.14.15-3-.85s-4.54-1.15-3.69-3.08c-.3-.06-.39,0-.46.12-1.26,2.27-2.46-1.48-4.22.81-2,2.18-2.52,5.23-4.07,7.72-.84,1.8-3-.32-4.34-.55-3.23-1.34-7-1.62-9.77-4,.06-.36.48-.34.68-.56-.71.86-3.9-1-1.65-2.28-1.1.81-1.1.85-.22,2.07,0,.61.36,1.47-.53,1.19s-1.62-1.66-2.92-1.14c-.82-.23-.06-1.51.52-1.71a10.14,10.14,0,0,0,1-2.18C1378.73,702.42,1378.8,702.32,1378.89,702.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1369.67,702.49c.59.77,1.63.77,2.42,1,.31-.08.42-.77.65-.53.56.56,1.4.78,1.81,1.5.19.34.37.52.71.17a2.56,2.56,0,0,1,.93,3.41.72.72,0,0,1-.69-.16c.3.33.59.66.23,1.13a.91.91,0,0,1-.24.7c-1.79-.45-1.61-3-3.56-2,.77-.69,2.16.28,1.06,1-.28.24-.84.38-.59.89.83,1.17,2.13-1.07,3.09.09a9.41,9.41,0,0,1-2,4.07c-1.3.72-.31,1.74-.83,2.41a23.71,23.71,0,0,0-3.31-.35c-.73-1-1.95-1.09-2.95-1.57-1-.86-1.11-3.12-2.65-3.13-2.73,0,.21,2.87-1.92,2.52-.69-.54-1.12-1.4-2-1.67-.62-.32-1.42-.13-2-.73-1-.14-1.57,1.74-2.88-.1.09-1.35,1.82-2.49.72-3.84.25-.38.69,0,1-.28.76-3.6,1.82.8,3.58-2.09.17-.5,1.12-.51.81-1.13-.86-1.7,1.91-2,2.22-.43-.79-1.75-2.47-1.26-2.64.55-.62.53-1.31-.11-2-.16-.32,0-.67,0-.81-.4a2.23,2.23,0,0,0,.73-1.42c.09-.07.15-.17.24-.24v-.49c.09-.07.16-.17.25-.24l.24-1.21a1.5,1.5,0,0,0,.48-1.21c.57-.15,1.06-.14,1.2.59,1,.12,1.4,1.13,2.28,1.4a9.87,9.87,0,0,1,1.72,2.13c-.09-.55-.59-1.39.13-1.7.89.55,1-.82,1.72-.95.45.75.35,1.7,1.55,1.37A3.11,3.11,0,0,1,1369.67,702.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-68",
    d: "M1380.34,706.63c-2.79-3.06,3.06-3.13,1.67-1.91-.53-.05-1.18-.45-1.51.18-.28,1.08,1.23,2.12,2,.93.69-.89,1.2.28.5.78l0,0a.81.81,0,0,1-.27.25l0,0c-.19.29-.55.07-.77.26a.35.35,0,0,0-.2,0l-1.19-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1372.59,716.05c.21-.24.62-.53.92-.39,1.28.82,3,.64,4.16,1.6-1.76.4-3.53-.43-5.32-.48C1372.16,716.44,1372.39,716.25,1372.59,716.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-70",
    d: "M1376.49,707c-.25-.87-1.25-1.41-1.23-2.36,1.19-.37,1.58,0,1.7,1.44.17.39.52.64.69,1l.16.25c.32.16.6.82.28,1.09C1377.31,708.78,1377,707.46,1376.49,707Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-34",
    d: "M1375.73,709.06c-.28-.8-1.63-1.75-1.22-2.55.8-.27,1.15,1.16,1.7,1.58h0C1376.61,708.69,1376.73,709.55,1375.73,709.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-66",
    d: "M1431.74,716.32a3.7,3.7,0,0,1-1.75.71C1430.64,716.17,1430.66,715.83,1431.74,716.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-71",
    d: "M1379.39,707.11a.5.5,0,0,0,.21,0c.14.14.54.12.47.42C1379.63,708.34,1378.5,707.68,1379.39,707.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1377.65,707.11l-.2-.29C1377.68,706.73,1377.83,706.92,1377.65,707.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1378.15,707.82l-.34-.46C1378,707.44,1378.29,707.48,1378.15,707.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-20",
    d: "M1435.06,715.06a.66.66,0,0,1-.51.24A.84.84,0,0,1,1435.06,715.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-66",
    d: "M1430,717a.7.7,0,0,1-.49.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-20",
    d: "M1435.32,714.86l-.26.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-72",
    d: "M1387.83,703.07c.06.28.35.42.49.66l0,0c.18.1.11.35.28.45s.08.19,0,.27h0a.54.54,0,0,1-1,0l0,0c-.17-.62-1.83-2-1.18-2.52.65-.11,1.08-.76,1.76-.66a1.16,1.16,0,0,0,1.16-.66,1.72,1.72,0,0,1,1.86.23h0a.72.72,0,0,1,.26.26l0,0c.18.09.12.34.29.44a3.25,3.25,0,0,0,.23.29h0a1.27,1.27,0,0,1,.25.27l0,0c0,.35.65.56.28.91h0a.64.64,0,0,1-1-.24h0a.88.88,0,0,1-.24-.27l0,0c-.2-.23-.28-.53-.52-.75l0,0c-.17-.09-.12-.32-.28-.41-.78-.54-1.49.24-.73.92h0c.28.3.41.7.73,1l0,0c.42.38-.2.61-.51.7a.48.48,0,0,1-.42-.26l0,0c-.2-.09-.15-.34-.28-.48h0a9.8,9.8,0,0,0-.73-1l0,0C1387.83,701.44,1387.05,702.26,1387.83,703.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1400.57,698.56c.06-.4.67-.27.49.11S1400.52,698.92,1400.57,698.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1390.73,700.51l-1.17,0A1,1,0,0,1,1390.73,700.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1399.4,698.59c.09,0,.12.09.06.14S1399.33,698.67,1399.4,698.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1391.73,701.49a.67.67,0,0,1-.29-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1391.23,700.82l-.31-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1392.2,702a.32.32,0,0,1-.25-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1392,701.78l-.2-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-67",
    d: "M1391.47,701.07a.35.35,0,0,1-.26-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1413.35,687.8c1.22-1.16,1.89-.1.18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1396.49,687.45c.06-.05.14,0,.15,0S1396.46,687.57,1396.49,687.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-9",
    d: "M1413.52,688l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1244.73,768.58c-1.36-3-2.71-5.93-3.88-9,.4-.39,1.36-.58,1.46-1.14-.32-.82.19-.77.72-.72,2.3-.7,4-5.31,6.63-4,2.24,1.76,1.48-1.16,3.38.09,5,3.27,10.52,5.08,16.29,6.39a72.24,72.24,0,0,0,9.75.75c1.22.23,3.71-.57,4.44.46-.37,2-2.85,3.51-4.25,5-1.14,1.16-2,.12-3.18-.15-4-.38-7.34-3-11.16-4.13-3.27-1.19-4.91,2.42-7.22,3.93-2.39,1.93-4.9,6.65-8.39,5.18A8,8,0,0,1,1244.73,768.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-74",
    d: "M1241.51,741.76c-.13-.33-.43-.79-.12-1.08a5,5,0,0,0,.22-5.47c-1.15-1-1.65-3.26,0-4,1.07-1,2.33-.1,3.25.66.57.48,1-.74,1.6-.65,1.1,0,1.71,1.63.47,2-1.34.7.09,2.31-2.19,3C1242.88,737.53,1244.35,741.09,1241.51,741.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-75",
    d: "M1250.54,752.69c-.14-.16-.4-.13-.5-.35h0a9.37,9.37,0,0,1-1.23-1.21c.15-.73.59-.38,1-.25,5.39,2.64,5.7-3,10-2.7.75.84.05,1.9.42,2.79-1,2.42,3,5.58-.06,7v0a5.44,5.44,0,0,1-1.53-3.86c.11-1.33-1.09-1.85-1.84-2.62-.23-.23-.52.09-.72.27A5.81,5.81,0,0,1,1250.54,752.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-76",
    d: "M1243.79,745.59c-.54-1.63-1.2-3.75.72-4.73.76-.16,1.68-.77,2.36-.05s-.28,1.23-.35,1.87c-1.94,3.37,3.86,6.49,1.29,7.53A20.88,20.88,0,0,1,1243.79,745.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-77",
    d: "M1251,752.89c3.13-.8,3.18-.12,6-2.43.66,1.33,2.5,1.75,2.15,3.58a1.93,1.93,0,0,0,.84,2c-.24.67.39,1.22.25,1.87-1.19-.36-3.45-1-2.42-2.72.63-1.38-1.93-1.88-2.89-1.54-1.11.51-2.09,0-3.16-.1-.07-.07-.12-.15-.23-.17S1250.8,753.16,1251,752.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-78",
    d: "M1242.53,743.63c-1.55-1.52.62-2.87,1.89-3.51s3.14-2.19,4.5-1c1,2.59-2.79,4.34.8,7.55.76,2.17,2-.27,1.89,3.48-1.38,1.85-2.12-1.35-2.8-2.24-.55-1.36-2.24-2.16-2.07-3.71.23-2.47,1.36-4.78-2.27-2.93h0a2.67,2.67,0,0,0-1.37,1.87A.61.61,0,0,1,1242.53,743.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-79",
    d: "M1243,731.06c-.88.21-2.54.93-1.81,2-.22,1.08.53,1.57,1.18,2.14.44,1.88.72,4.66-1.09,6-.08-.16-.15-.33-.23-.49,1-1.69,1.39-4.61-.47-5.82a8,8,0,0,1-.64-1.68c-.73-2.13,2.73-3.66,4.13-2.64C1244.05,731.52,1243.53,731.28,1243,731.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-80",
    d: "M1241.51,741.76a1.12,1.12,0,0,1,.54-.76c1.92-.79.53-5.09,2.23-5.22,2.07-.24,2-3.32,4.4-3.14,1.54,1.46-2.7,4.22-3.82,5.16-.71.72-.85,2.06-1.35,3a5.3,5.3,0,0,0-1.6,1.42.26.26,0,0,1-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-81",
    d: "M1247.81,750.21c.37-.58.55-1-.16-1.62s-1-1.78-1.73-2.53c.09-1.13-.69-2.32.24-3.38,1.42.89-.13,2.67,1.2,3.72,1.7,1.56,1.91,4.41,4.55,4.65.67.17,1.47,0,2,.59-.09.12-.22.36-.28.34-1-.23-2,.13-2.92-.32a2.77,2.77,0,0,0-1.88-.52A2.68,2.68,0,0,1,1247.81,750.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-82",
    d: "M1242.53,743.63a2.81,2.81,0,0,1,1.94-2.4c-1.71,1.54.07,2.39-.78,4.19A5.75,5.75,0,0,1,1242.53,743.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-83",
    d: "M1241.8,742.2a1.78,1.78,0,0,1,1.71-1.44c-.13.66-1.21,1.17-1.5,1.94C1241.92,742.55,1241.57,742.33,1241.8,742.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-74",
    d: "M1241.8,742.2a1.93,1.93,0,0,1,0,.24l-.18-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-82",
    d: "M1243.79,745.59l.19.24A.27.27,0,0,1,1243.79,745.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1249.55,751.92l.23.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1249.8,752.13a.3.3,0,0,1,.26.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1250,752.34a.39.39,0,0,1,.31.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1250.54,752.69l.19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1251,752.89l0,.19-.25-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1251,753.08l.32.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1251.5,753.41l.21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-84",
    d: "M1258.76,764.46c3.77-3.92,3.62-3.43,8.64-2.3a3.35,3.35,0,0,0,2,1.24c.94.22,1.71.94,2.72.91.72.86,1.93.71,2.77,1.33a.72.72,0,0,0,.79.14,1.37,1.37,0,0,1,1.8.5c1.9.89,4.22-3.63,5.86-4.74-.5-.33-1-.17-1.38-.26-.37-1,7.44-1.47,8.67-1.81,2,1,4.45.31,6.21,1.91,1.06.73,2.59.14,3.66,1,2.36,1.89,4.49-4.06,6.77-5,1.94-.86,3.32-.45,5,.88,1.1,1,2.6-.32,3.53.94s1.75.84,3,1.31c.36.16.83.22.85.73,0,.69-.91.46-1,1-.32.38-.84.11-1.18.37-.09.29-.46.36-.74.38-7.74,3.45-15.87,6.54-23.76,9.67h0c-1.37.46-2.48-.39-3.68-.75-1.28-.56-2.32,2.53-3.28-.25a2.44,2.44,0,0,0-2-1.93c-1.35-.49-2.68,2-3.34-.29-.34-.89-1.09-.89-1.82-1.22.07.46.35.47.55.56,1.3.45.23,2-.81,1.44-2.52-2-3.35,1.53-5.42,2.07-1.28-.09-2-1.37-3.33-1.56-1.47-.36-2.27-2-4-1.48a3.22,3.22,0,0,1-2.64-.93c-1.76-2.18-6.56.45-5.57-2.69C1257.88,765.17,1258.68,765.09,1258.76,764.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-85",
    d: "M1273.05,772a52.25,52.25,0,0,1,3.94-3.47c.21.66,2.14,1.85,2.54,1.22.14-.34-.16-.43-.4-.4-1,.15-1-.74-1.45-1.21-.44-1.47,4,.17,3.48,1.39,0,.21,0,.43.17.54a.47.47,0,0,0,.63-.19c.88-1.88,3.06-.25,4.18.44.64.5-.16,2.21,1.16,2.16.42-.09.45-.47.43-.87-.27-1.91,4.13,1.31,5.19,1.12-12.1,5.22-24.48,9.82-36.59,15-3.59,1.32-2.89.28-4.59-2.4a37.73,37.73,0,0,0-3.16-7.26.6.6,0,0,0-.24-.49,2.5,2.5,0,0,0-.72-1.69c-1.08-1.55,3.17-5.75,3.75-3.3,0,1.13.52,1.29,1.44,1.12a70.85,70.85,0,0,1,8.78,3.52,4.53,4.53,0,0,0,6.28-1.18C1269.74,774.87,1271,772.42,1273.05,772Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-85",
    d: "M1292.91,772.71a.71.71,0,0,1,.53-.24A.79.79,0,0,1,1292.91,772.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-86",
    d: "M1318.59,762.29c-.83-.31.35-.74.7-.94-.17-.32-.52-.13-.73-.3-.73-1-1.82.72-2.3-.36-.2-.47-.41-.86-1-.76-1-.06.89-1.15-.6-.87-3.55,1.3-2.75-2.77-7.18-1.37-.37-2.2,3.29-4.8,4.31-6.79a1.87,1.87,0,0,1,2.65-.88c2.87,0,3.06,2.09,5.19,1.68,1.13-.11,1.46,1.69,2.77,1.35,1.67,0,2.89,1.5,4.63,1.37,1-.24,1.6,1.24,2.3.16,2.55-2.32,4.51-10.15,8.91-7.3.71.71,1.84.07,2.6.73a.8.8,0,0,0,.81.12c1.43-.79,2.31.45,3.54.82,4.7,1.4-3.19,4-4.71,4.55C1333.15,756.42,1325.93,759.52,1318.59,762.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-87",
    d: "M1346,751.18c-.21-.37,0-.7.1-1s-.34-1.06-.77-.61c-1.22,1.11-1.31-1.91-3.3-.87-1.46.82-1.43-.77-2.45-.46-1.76.53-2.1-1.91-4.51-.91l-.1-.15c-.1-1.16.78-1.9,1.33-2.72,1.49-2.47,3.35-6.6,6.86-4.63,1.93,1.36,4.29.87,6.23,2a20.58,20.58,0,0,0,4.44,1.84c2.47.9,2.48.9,4-1.24,1.24-1.35,5.63-10.86,7.29-6.38,1.42-.54,1.79,1.91,3.31,1.16a1,1,0,0,1,.91.24c.74.58,1.37-.91,2.17-.11.76.54.12,1.23,0,1.86.53,1.27-.62,2-1.6,2.33a.47.47,0,0,0-.68.28C1361.54,745,1353.77,748.21,1346,751.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-84",
    d: "M1317.88,762.56a.7.7,0,0,1-.51.22C1317.32,762.38,1317.65,762.34,1317.88,762.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-88",
    d: "M1370.44,741.25c-.57-1.1,1.33-.43.73-1.23-1.09-1,.47-1.49.21-2.33-1.15-1-.5,1-1.51.84-.45,0-.79-.1-.83-.64-.44-1.17-1.81,1.28-2.78-1-.76-1.44-1.3,1.2-2.09.06-.77-.72,1-.81.47-1.52a.57.57,0,0,0-.87,0c-.54.77-1.54,1-2,1.87-1,1.06-1.79,4.09-3.56,3.38a19.14,19.14,0,0,0-4.48-1.68c-1.19.27-1.6-1.13-2.67-1.09-2.76-1-5.82-1.29-8.31-3-.4-1.07.61-1.55,1-2.3.91-2.22,2.22-5.34,5.16-4,1.69.46,3.19,1.45,5,1.64,1.1.14,1.89,1.57,3,1.71,2.19-.35,3.61,1.82,5.83,1.45,1.5-.08,2.64-5.43,4.33-5.9,1.06-.41,2.29,1.6,2.65,0,.08-.23,0-.53.34-.58.7.21.75,1.47,1.83.83.51-.25.84-.1,1,.45.41.72,1.47.88,1.64,1.82.4,1.35,1.34-.58,2,.51s1.38-.27,2.11.44c1.52,2.56,2.83.09,4.13,1.74a1.07,1.07,0,0,0,1.1.59c.39,0,.74,0,.56-.59-.13-.4.23-.55.52-.7,2-1.53,2.86-4.24,4.07-6.4.35-1.45,3.23-.51,3.92.38.53.62,1.56,0,2.19.44,1.82,1.15,4,1.51,5.85,2.52-.52.56-1.43.3-1.89.76C1389.58,733.62,1380,737.52,1370.44,741.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-88",
    d: "M1369.24,741.74a.41.41,0,0,1,0-.51c.27,0,.6-.22.72.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-66",
    d: "M1399,729.64c-.37-.4.26-.58.48-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-17",
    d: "M1424.62,719.42l.52-.23A.74.74,0,0,1,1424.62,719.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-89",
    d: "M1273.05,772c-2.13,2.16-4.37,4.18-6.69,6.16-.79.74-1.71.33-2.63.45-.17,0-.35,0-.39-.15-.22-1.09-.9-.53-1.38-.34s-.84.35-.86-.4a7.5,7.5,0,0,0-3-1.43c-.43-.06-.7-.75-1.31-.32-.14.1-.36-.14-.47-.31-.59-1-2,.4-2.45-.89-1.09-1.76-3.3,1.51-3.09-2.56-1.4.56-2.32,1.74-3.42,2.67a34.56,34.56,0,0,1-2-4.59c.13-.19-.17-.31-.22-.49s-.17-.32-.24-.49c.09-.25-.3-.41-.26-.7,8.15,4.45,6.23,2.48,12.82-2.91L1258,767c1.31-1.48,2.93.93,3.32-.47,0-.61.77-1.08.75-.23-.15.34-.43.85.13,1,1,.3,1.85,1,2.84,1.42,1,.58,1.35-.87,2.29,0,1.42,1.44,3.67,1.39,5,2.9A1.06,1.06,0,0,0,1273.05,772Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1245,769.06c0,.08.09.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1245.18,769.55c0,.07.11.14,0,.22A1.74,1.74,0,0,1,1245.18,769.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-73",
    d: "M1245.4,770c0,.07.13.13,0,.22A1.74,1.74,0,0,1,1245.4,770Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1321.25,714.6c-1.21-2.66,3.41-.25,4.46.21.84.49,1.09.36,1.61-.47,1.75.1,1.24,2.74,2.83,2.73,2-1.33,1.62,1.38,3.24-2,.37-.12.44-.42.46-.76.2-.12.62.09.57-.39.17-.16.09-.23-.09-.27a.34.34,0,0,1,0-.5.78.78,0,0,0,.57-.58c.76-.12.84.55,1.08.9-.09-.66-1.15-1.08-.65-2,1.1-.6.76-3.21,2.41-2.77.36.43-.8.85.09,1.1.17.5,1.1.7.91,1.27.38.81.63,1.89,1.72,2.08.86.38,1.06-1,.53-1.46-1-1.2,1.12-2.45,1.82-1.15.33.4.41,1.14,1.2,1,.55-.21.53-.51.14-.89-.18-.16-.39-.4-.15-.6.56-.35.79,1.31,1.88,1.33,1.09.33,2,1.16,3.21,1.16.39,0,.54.42.7.76.44,1,1.91-.21,3,1.6-.23.69.12,1.37,0,2.06a.81.81,0,0,1-1.49.11c.52.59,1,1.9-.1,2.23-1.3-.45-1.69-1.94-2.39-2.81.72.72.82,2.1,2,2.59,1.27.89,0,2-.33,2.81-.69,1.21-1.07,2.73-2.08,3.8-2.14.9-4.2-1.38-6.47-1.32-.7-.1-1.67-.46-1.44-1.34.32-.48,1-.61,1.26-1.19-.33-.88-.55-1.89-1.59-1.76.7-.08,1.1,1.17.14,1.33-.77.32-.51,1-.6,1.56a.77.77,0,0,1-.76.65c-.64-.11-1.12.4-1.72.44-1,.17-1.53-1.07-.5-1.41.3-.2.94-.21.72-.76-.47-.78-1.54,0-2.2.11-1,0-1.63-.76-2.54-1-2.27-.5-2.11,4.53-5.72,5.25-1.45.3-1.79-2.22-3.5-2-1.42-2.05-.91-4.88-1.86-7.18C1321.54,716.21,1320.94,715.39,1321.25,714.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1352,717.26a1.35,1.35,0,0,0,.51-.55c.13-.08.44-.09.4-.16-.76-1.34,1.18-2.22.74-3.47a2.82,2.82,0,0,0,1-1.63h0c.07-.08.16-.15.24-.24,2.07,1.14,2.41-1.44,3.32-.58.13,1.11,1.12.63,1.76,1-.73,1-2.06-.2-2.77.74s-.65,1.77-.65,2.79c-.42.75-1,.56-1.39,0,.31,1.27.82.77,1.75.42,2.36,1.42,2.44.93,4.83.3,6.41,5.92,12.32-.17,5.26,11.53-.11.62-.73,2.07-1.49,1.49-1.17-1.32-3.52.4-4.07-2-.15-.48-.34-.71-.85-.47-1.93.58-3.76-1-5.71-1a1.06,1.06,0,0,1-.77-.33c-1.11-1.66-3.32-1-4.55-2.34.11-1.37,1.44-2.28,1.45-3.63a1.61,1.61,0,0,0,.48-1C1351.87,718,1351.67,717.5,1352,717.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-90",
    d: "M1330.15,717.07c-1.05,1.83-2-2.21-2.83-2.73h0c-.33-.86,1.84-.86,2.43-1.3.2-.07.43-.13.54.08.18.62-.88.58-1.24.85s-.66.23-.41.68c.49,1.31,1.63-.43,2.51.19.25.45-.47.55-.73.69h0c-.18.28-.53.06-.73.27a.41.41,0,0,0,0,.51h0a5.75,5.75,0,0,0,.49.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-70",
    d: "M1344,711.5c0,.25.32.53-.11.71-.77.22-.94-1-1.39-1.41-.67-1.14-2-.11-1.17.7.46.57,1.26,2-.18,1.4a3.54,3.54,0,0,1-.55-1c-.17-.51-1-1.09-.6-1.41,1.06-1,2.81-1.28,3.56.25l0,0a7.21,7.21,0,0,0,.51.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-91",
    d: "M1349.09,708.57c-.13-.46-.89-1-.5-1.47.23-.14.47-.17.64.07.54.58,1,2.25,2,1.62.37-.23.3-.52.11-.83-.17-.5-1.1-1.15-.66-1.64,1-.33,1.33,1.54,1.93,2.12.29.56-.53.64-.86.81h0c-.1.18-.34.12-.46.27a1.79,1.79,0,0,1-1.47,0l0,0a3,3,0,0,1-.5-.5h0C1349.13,709,1349.28,708.65,1349.09,708.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-68",
    d: "M1345.69,710c-1.69-3.16,4-2.34,2-1.53-.51-.19-1.23-.43-1.44.27-.24.86,1.08,2,1.77,1.17.59-1.28,1.55-.8.81.29h0a2,2,0,0,1-.25.25h0c-.11.16-.34.1-.46.25a2.48,2.48,0,0,1-1.7,0h0A2.33,2.33,0,0,1,1345.69,710Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-92",
    d: "M1321,713.64l0,.25c-.9,1.15-2.47-.39-2.48-1.54.26-.44,1-.5,1.08-1.15l.2.07a1.31,1.31,0,0,0,.26.44h0c.17.12.12.35.26.48h0c.15.13.1.35.24.49h0c.15.13.11.36.24.49h0c.16.13.11.36.24.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-68",
    d: "M1334.28,713.16c.17.72,1.39,1.61,1,2.34a.48.48,0,0,1-.7-.21c-.42-.86-2.12-2.81-1.83-3.57C1333.49,711.28,1333.81,712.73,1334.28,713.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-70",
    d: "M1335.28,711.46c.35,1,1.94,2.43,1.63,3.39-1.22.15-1.79-2.22-2.49-3.1S1334.88,710.74,1335.28,711.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-93",
    d: "M1353.21,714.56c1.34.46-.83.84.26,1.93.15.4.88.92.46,1.33a.42.42,0,0,1-.63-.06c-.51-.88-2.32-2.47-.56-2.9h0C1352.84,714.67,1353,714.63,1353.21,714.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-94",
    d: "M1356.61,707.09a.59.59,0,0,1-1,.28,12.09,12.09,0,0,0-1.43-2.23h0c.32-.56,1.14-.34,1.44-.92a.46.46,0,0,0,.2,0,1.56,1.56,0,0,1,.28.23c.13.53-.75.59-.56,1.08A4.75,4.75,0,0,0,1356.61,707.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-34",
    d: "M1353.94,705.4c-1.07.94-.5,1.26.12,2.27.47.45-.28,1-.64.48-.32-.83-2.19-2.12-.64-2.59C1353.16,705.37,1353.49,705,1353.94,705.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-95",
    d: "M1333.39,715.08c0,.38.58.66.22,1s-.51.11-.75,0c-.06-.11-.17-.18-.22-.29l0,0c-.19-.11-.15-.35-.27-.49h0a5.08,5.08,0,0,0-.49-.75l0,0c-.19-.11-.14-.35-.27-.5C1331.7,712.27,1333.06,714.52,1333.39,715.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-68",
    d: "M1340.41,713.14c-.75,1.57-1.94-1.48-2.21-2.17l.51-.22A17.64,17.64,0,0,1,1340.41,713.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1353.46,713.39c-1.92-.74-.6-2,.2-.31C1353.78,713.29,1353.72,713.46,1353.46,713.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1349.6,710.86c.57-.18,1.19.46.75.86C1349.88,711.9,1349.81,711.2,1349.6,710.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-96",
    d: "M1338.44,710.49c-.89.06-1,0-.66-.7C1338.26,709.78,1338.54,710,1338.44,710.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-97",
    d: "M1353.46,713.39l.23-.25c.92-.19.91.88,0,.73a1.25,1.25,0,0,1-.24-.27A.74.74,0,0,0,1353.46,713.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-98",
    d: "M1331.44,712.38c.59,0,.39.78-.11.68S1331,712.33,1331.44,712.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1346.44,710.71a6.75,6.75,0,0,0,1.68,0A1.48,1.48,0,0,1,1346.44,710.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1349.82,709.49a4.41,4.41,0,0,0,1.45,0A1.16,1.16,0,0,1,1349.82,709.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1345.69,710l.76.67A.78.78,0,0,1,1345.69,710Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1329.71,715.8a1,1,0,0,1,.73-.27A.88.88,0,0,1,1329.71,715.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1330.94,715.32l.21-.47C1331.4,715.15,1331.21,715.25,1330.94,715.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1354.67,711.45a1,1,0,0,1-.25.73A1,1,0,0,1,1354.67,711.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1320.75,713.15a.65.65,0,0,1-.24-.49A.79.79,0,0,1,1320.75,713.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1320.51,712.67a.66.66,0,0,1-.24-.49A.76.76,0,0,1,1320.51,712.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1321,713.64a.66.66,0,0,1-.24-.49A.76.76,0,0,1,1321,713.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1327.36,713.89l0,.46C1327.14,714.18,1327.15,714,1327.36,713.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1331.67,714.09a.67.67,0,0,1,.27.5A.72.72,0,0,1,1331.67,714.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1320.27,712.18a.65.65,0,0,1-.26-.48A.77.77,0,0,1,1320.27,712.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1332.13,714.86a.62.62,0,0,1,.27.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1330.42,715.54a.58.58,0,0,1,.5-.22A.7.7,0,0,1,1330.42,715.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1332.4,715.31a.65.65,0,0,1,.27.49A.68.68,0,0,1,1332.4,715.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1329.7,716.31c-.19-.17-.33-.34,0-.51C1329.71,716,1329.71,716.14,1329.7,716.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1343.77,711.21a.67.67,0,0,1-.28-.48A.74.74,0,0,1,1343.77,711.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1330,716.77a.62.62,0,0,1-.27-.47A.83.83,0,0,1,1330,716.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1348.14,710.72a.75.75,0,0,1,.46-.25A.73.73,0,0,1,1348.14,710.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1349.09,708.57a.67.67,0,0,1,.27.44l-.26,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1351.29,709.51a.75.75,0,0,1,.46-.27A.71.71,0,0,1,1351.29,709.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1351.73,709.25a.4.4,0,0,1,.5-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1349.07,709.35l-.44-.13.46-.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-26",
    d: "M1354.2,705.14l-.26.26h0C1354,705.31,1354.11,705.23,1354.2,705.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1330.19,717.06a.31.31,0,0,1-.22-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1332.64,715.78a.3.3,0,0,1,.21.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1353,714.62l-.29.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1331.91,714.57a.3.3,0,0,1,.21.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1353.46,713.6l.23.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1340.88,712.56l.22.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1340.36,713l-.24-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1340.63,712.14l.18.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1320,711.71l-.17-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1354.91,711.21l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1344,711.49a.32.32,0,0,1-.23-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1343.52,710.75a.31.31,0,0,1-.21-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1348.6,710.48l.25-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1348.84,710.24l.24-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1349.59,709.27l.25.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1349.34,709l.24.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-90",
    d: "M1360.47,705.17c-.4,1.58-2.38,1.56-3.37.45-.43-1.29-.4-1.4.71-2.19,1-.26,3.42.6,1.82,1.71C1359.92,705,1360.2,704.84,1360.47,705.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-24",
    d: "M1356.12,704.43l-.28-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1359.51,699.59l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1358.78,701.77l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1359,701l-.25.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-99",
    d: "M1321.25,714.6c.45.66.25,2-.87,2a27.66,27.66,0,0,0-2.21,3.28c.08,1,1.26,1.67.93,2.72-.5.4-.88.17-1.23-.24-.37-1.62-2.21-2.17-.64-3.83-.35-.72.56-1.22.29-1.89.58-.26.43-1.29,1.23-1.26A4.42,4.42,0,0,0,1321.25,714.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-38",
    d: "M1316.88,719v.49a.41.41,0,0,1,.06.47c-1.24.39-1.69-1.73-3.15-1.55-1.76-.55-2.39-2.55-3.74-3.65-.3-.19-.53-.5-.39-.81.45-1.49,1.68-4.6,3.82-3.17-3.28,1.08-2.65,5.18.24,6.32,1.24.72,1.58-.56,2.62-.18C1317,717.47,1315.22,717.21,1316.88,719Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-100",
    d: "M1363,688.66c-3.32-1.66-2.83-6.32,1.39-4.54C1367,686,1366.8,689.56,1363,688.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-101",
    d: "M1312.28,712.66c4.45-1.79,5.51,2.72,2.3,2.25C1312.55,714.4,1312.54,715,1312.28,712.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-102",
    d: "M1313.49,710.72h-1.21a.41.41,0,0,1,.27-.58c3.09-1.55,1.41-7.46-2.31-4.93a2.8,2.8,0,0,1-1.27.59c-1.8.82-1.83,4.42-5.07,2.5a.59.59,0,0,1,.5-.83c1.16-.06,1.75-.86,2.44-1.67a15.44,15.44,0,0,1,3.73-2.88c.87-.52,1.72.4,2.63.36a.28.28,0,0,0,.25.22.3.3,0,0,0,.25.23.31.31,0,0,0,.25.24,8.15,8.15,0,0,1,.49.47,16.81,16.81,0,0,1,.49.48.32.32,0,0,0,.24.25,8.15,8.15,0,0,1,.47.49c0,.07,0,.14,0,.21-.7.29-.12,1.31-.37,1.87-.22,1-.15,2.12-1.43,2.51C1313.71,710.31,1313.61,710.56,1313.49,710.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-103",
    d: "M1377.32,698.12h-.07c-.17.16-.4.14-.6.25s-.34.18-.23.3v0a.91.91,0,0,0,1.25,0h0c.22-.31.63-.54,1-.23h0a.14.14,0,0,1,0,.23h0c-.16.12-.1.37-.29.47l0,0c-.34.35-.87.35-1.23.51a2.28,2.28,0,0,1-1.21-.23c-.1-.16-.35-.1-.45-.27l0,0a.92.92,0,0,1-.26-.26v0c-1.25-1.45.91-3.19,2.34-1.91.34.24.92.7.28.93C1377.66,697.86,1377.54,698.1,1377.32,698.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-104",
    d: "M1370.42,699.07c.36-1,.3-1.46,1.47-.92.84.4-.29,1.91,1.94,2.17a3.13,3.13,0,0,1,.2.3c0,.3-.33.28-.48.41h0a.81.81,0,0,1-1,0l0,0a2.63,2.63,0,0,1-.5-.5h0c-.16-.1-.1-.34-.27-.44a3.3,3.3,0,0,0-.22-.3v0C1371.2,698.81,1371,699.54,1370.42,699.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-35",
    d: "M1366.8,700.51v-.42c.6-.07-.21-1,.56-.93.39,0,.6.53,1.07.45.17,0,.21.15.2.34a1.55,1.55,0,0,0,1.57,1.82c.29.45-.22.57-.52.72a1.86,1.86,0,0,1-1.39-.81A1.62,1.62,0,0,1,1366.8,700.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-34",
    d: "M1365.31,702.5c.16.58.63.76,1.34.68-1.58,1.71-1.88-.53-2.81-1.18-1,.1-.33-.71-.61-1-.31,0,0-.24,0-.41.27,0,.57-.17.78.09s.72.22,1.07.34l-.21.5C1365,701.87,1365.28,702.13,1365.31,702.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1377,706.12c-.52-.52-.81-1.63-1.7-1.44,0-2.1,1.48-.67,2.41,0A2.08,2.08,0,0,1,1377,706.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-25",
    d: "M1375,699.41c.1.31.6.58.25.9h0a.61.61,0,0,1-1-.3c-.35-1.18-2-2.18-1.87-3.34C1373.3,696.19,1374.32,698.86,1375,699.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-25",
    d: "M1371.12,700.62c.07.29.34.45.49.69l0,0c.19.18.22.34-.06.46s-.65.16-.89-.18c-.27-.77-1.51-1.65-1.15-2.41C1370.32,698.83,1370.66,700.16,1371.12,700.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-105",
    d: "M1369.05,698.74a.31.31,0,1,1,0-.62A.32.32,0,1,1,1369.05,698.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1370.42,699.07c.29.15.71-.1.93.29h-.93l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1370.64,701.57a1.13,1.13,0,0,0,.73.22C1371,702.05,1370.79,702,1370.64,701.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1372.59,701h1A.63.63,0,0,1,1372.59,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1377.16,699.58a1.34,1.34,0,0,1,.75-.24A.94.94,0,0,1,1377.16,699.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1378.64,698.4a1.18,1.18,0,0,0-.72,0A.45.45,0,0,1,1378.64,698.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1377.89,697.88l.27-.46C1378.38,697.75,1378.16,697.83,1377.89,697.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1374.53,700.32h.72A.46.46,0,0,1,1374.53,700.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1369.68,702.49l.49-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1370.19,702.25c0-.16,0-.32,0-.48A.32.32,0,0,1,1370.19,702.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1376.65,698.36a.65.65,0,0,1,.54-.22A.82.82,0,0,1,1376.65,698.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1371.85,700.11a.61.61,0,0,1,.27.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1375.24,700.31l0-.48A.29.29,0,0,1,1375.24,700.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1373.55,701l.48-.31A.66.66,0,0,1,1373.55,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1378.36,699.1a.8.8,0,0,1,.29-.47A.76.76,0,0,1,1378.36,699.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1371.53,701.75l.06-.46C1371.78,701.47,1371.76,701.63,1371.53,701.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1376,699.37a.8.8,0,0,1,.55.2A.9.9,0,0,1,1376,699.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1371.36,699.39a.6.6,0,0,1,.28.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1377.92,699.34a.66.66,0,0,1,.47-.27A.73.73,0,0,1,1377.92,699.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1375.5,699.08a.7.7,0,0,1,.45.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1375,699.41l-.21-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1375.26,698.84l.26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1370.41,699.59l-.19-.24h.18l0,0A1.69,1.69,0,0,0,1370.41,699.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1374.77,699.09l-.16-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1377.68,698.63l-.23.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1376.7,698.83a.25.25,0,0,1-.27-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1375,698.5l.24.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1370.63,699.91l-.22-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1375.26,699.8l-.16-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1378.65,698.62a1.64,1.64,0,0,1,0-.23C1378.66,698.47,1378.73,698.55,1378.65,698.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1371.63,699.81l.2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1377.91,698.38a.28.28,0,0,1-.23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1376.42,698.66c-.19-.12-.18-.2,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1370.89,700.3l-.16-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1374.3,700l.22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1377.32,698.12l.34-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1371.12,700.62l-.22-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1374,700.62l-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1378.89,702.25l-.25.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1372.11,700.54l.23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1371.38,701l-.16-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1372.35,700.8l.26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1379.37,701l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1371.61,701.31l-.21-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-106",
    d: "M1384.89,680.33c-.85,2.94-5,1.06-5.5-1.28C1378.92,674.93,1385.11,677.46,1384.89,680.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-107",
    d: "M1296.77,703.22c1,.13,2.62-.84,3,.56-.24,1-1.32.7-1.85,1.24-1.08.64-2.9.21-2.52,2.06-.7.94-4.91-1.89-3.38-2.86C1294,705,1294.79,702.76,1296.77,703.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-108",
    d: "M1308.61,699.88a4.47,4.47,0,0,1,.78.66c-1.29,3.36-5.75,1.27-8.41,2.4-.55.24-1.1.44-1.53-.21,2-2.53,6.63.1,8.45-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-109",
    d: "M1296.77,703.22c-3.66.67-1.44,2.75-4.82,1.22C1291.66,703,1295.94,702.75,1296.77,703.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-110",
    d: "M1299.45,702.73a2.74,2.74,0,0,0,1.44-.23c1.48.7-.63,3.06-1.21,1.21a1.33,1.33,0,0,1-1-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-111",
    d: "M1294.6,703.22c-1.07.66-2.79,1.54-3.73.29-1.15-1.41-3.18-2-4.1-3.58.1-1.6,3.4-1.53,1.88-4-.2-.31-.34-.55.14-.71.75.94,1.84,2.82.18,3.42-.36.18-.78.26-.87.74-.35,1,1,.52,1.49.53.29,0,.25-.33.17-.57h0c.86,0,1.57-.7,2.48-.55.19,0,.35-.16.36-.39a1.56,1.56,0,0,1,.79-1.24c.41.68.14,1.43.16,2.14a1.21,1.21,0,0,0,.33,1c.52.51.5,1.32,1,1.87C1295.26,702.49,1294.78,702.87,1294.6,703.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-111",
    d: "M1288.55,695c-1-.48-1-.49-.21-1.41A1.34,1.34,0,0,1,1288.55,695Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-112",
    d: "M1300.31,697.37c1.28-.34,5.12.61,3.25,2.15-1.2.67-4.83,0-5-1.43C1298.65,697.26,1299.71,697.23,1300.31,697.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-113",
    d: "M1285.69,693.36h.71c.94.74.21,2.3,1.18,2.83h0c.13,1-.43,1.91-.49,2.91-.24.22,0,.61-.28.81a.79.79,0,0,1-1-.72c-.6-1.45.28-2.88,0-4.34A2.72,2.72,0,0,1,1285.69,693.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-114",
    d: "M1274.26,697.14a23.89,23.89,0,0,1,8.23,1.22c.37-.2,1-.11,1.08.35-.61,1.12-2.61.21-3.7.52-1.64.12-3-.92-4.58-1.05-.45-.58-1.39-.09-1.79-.8A1.58,1.58,0,0,1,1274.26,697.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-115",
    d: "M1283.46,698.62a1.83,1.83,0,0,1-1-.26c-.77-2.16.56-1.8.38-3.05-.27-.9-.52-1.93.85-2C1285,695.82,1284.17,696.38,1283.46,698.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-116",
    d: "M1285.69,693.36c.85.54.24,1.55.63,2.33.21,1.12-.59,2.23-.2,3.42-1.77-.23-2.21-.94-1.37-2.36.78-1.09-.23-2.42.42-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-53",
    d: "M1285.17,693.35c1.22,3.79-2.07,4,.95,5.76v.24c-.84.59-1.54.09-2.25-.29a1.71,1.71,0,0,1,.15-2c1.14-1.12-.55-2.79.43-3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-117",
    d: "M1284.45,693.34a1.13,1.13,0,0,0,0,.81c.94,1.67-.51,3.09-.5,4.71-.23.23-.38-.07-.49-.24h0c-1.07-1.37,1.77-2.31.11-4.18-.33-.46.12-.73.15-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-118",
    d: "M1301.14,703c-.08-.17-.17-.33-.25-.49,2.92-.61,6.2.32,8.5-2,.88.37,1.53,1.09,2.35,1.53a.32.32,0,0,0,.27.21.3.3,0,0,0,.27.22l.71.77a2.26,2.26,0,0,1-1.64.09c-1.08-.27-1.53,1.27-2.54,1.5-1.84.45-3,4.24-5.09,2.62.06-.41.38-.45.71-.52,1.48-.19,1.59-1.92,2.73-2.56a.64.64,0,1,0-.52-1.17,9.89,9.89,0,0,1-2.77.09C1303,703.11,1301.33,704.37,1301.14,703Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-56",
    d: "M1252.7,712.9c.18-.44.65-.31,1-.48,1,1.05-.24,2.89-1.21,3.63h0A16.66,16.66,0,0,1,1252.7,712.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-119",
    d: "M1256.82,705.4l.45-.28.15.1c.41.81-.28,1.34-.59,1.91-.55.76-.94,2.65-2.19,2.14-.2-1.19,1.24-.61.49-1.93C1256,706.93,1256.31,706.09,1256.82,705.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-120",
    d: "M1253.18,722.1c-1.69,2.08-5,.82-6.38,3.29a3.56,3.56,0,0,1-2.23,1.86,12.2,12.2,0,0,0-3.28.62c-1.67.2-2.1,1.53-2.61,2.94,0-6.15,3.74-2.9,4.8-5.81.5-.64,1.26-1,1.16-2,.29-.93,1-1.71,1.26-2.7.8-2.27,2.44,1,4-.26.48-.22.21-.81.65-.88,1.51.67,1.64.51,2.44-1,1.14,0,.22,1.48,1,2A1.73,1.73,0,0,1,1253.18,722.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-121",
    d: "M1253.65,720.44c-1.15-.12,0-1.56-.7-2.21V718c-.56-.39,0-1.36-.48-1.94,1.42-2.13.94-4.6,2.18-6.78l.54-.22c.86,1.1-1.51,5.76-1.48,7.4C1253.6,717.66,1255,719.7,1253.65,720.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-120",
    d: "M1252.7,717.5l.24.49a2.87,2.87,0,0,0-1,.46A1.41,1.41,0,0,1,1252.7,717.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-122",
    d: "M1260.42,702.24a23.76,23.76,0,0,1,1.92-1.42,1.12,1.12,0,0,1,1.49,1.4c-.78,1.33-2.77,1.35-4,2.14-.79-.12-.55-1,0-1.26C1260.08,702.87,1260.52,702.77,1260.42,702.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-60",
    d: "M1262.31,701l-.38.11c1.2-1.47,5.51-3.9,7.47-4,.2,1-1.49,1-2.07,1.45A16.4,16.4,0,0,1,1262.31,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-123",
    d: "M1260.42,702.24l.81-.06c-.75,1.24-1.79,1.08-1.88,2.75-.87,1.33-2.64.56-1.25-.7l0,0A17.62,17.62,0,0,1,1260.42,702.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-119",
    d: "M1258.1,704.23c-.09.38-.28.93-.73,1l-.1-.09A1.22,1.22,0,0,1,1258.1,704.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-119",
    d: "M1258.33,704a.37.37,0,0,1-.27.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-124",
    d: "M1239.62,731.78a1.11,1.11,0,0,1-.48-.48c.54-4.65,6-1.64,8.21-3.83,1.53-1.67,3.72-2.47,5.59-3.67.91.66.37,1.31-.2,1.61a44.34,44.34,0,0,0-5.33,3.79c-2,1.42-5.64-.87-6.94,1.65A1.29,1.29,0,0,1,1239.62,731.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-125",
    d: "M1239.62,731.78c.94-4.28,6.09-1.33,8.55-3.63,1-1.33,5.27-2.86,4.77-4.35h0c.36-.23.23-.7.49-1a1.63,1.63,0,0,1,.23-2c1.6.17.26,2,.75,3-.43,3.24-4.33,3.27-6.07,5.49-2.83,3-6.21-1.14-8.71,3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-124",
    d: "M1253.43,722.83c.09.45.17.89-.49,1A1,1,0,0,1,1253.43,722.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-126",
    d: "M1273.5,697.38c.46.11,2.31-.29,1.72.52,0,.68-.61.7-1,.69a1.94,1.94,0,0,0-1.46.69c-.6.24-2.08.49-2.21-.36.34-.39.39-.73-.18-.95a.29.29,0,0,1,0-.31A9.93,9.93,0,0,1,1273.5,697.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-127",
    d: "M1270.38,697.66c.34,1.33-2,1.19-1.71,0C1269.24,697.23,1269.92,697,1270.38,697.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-128",
    d: "M1239.63,732.51c1.27-4.55,6.5-.61,8.68-3.71,1.35-1.76,5-2.12,5.28-4.46,0-.16.17-.25.32-.3,2.54,3.49-4,4.11-5.69,6.06-1.44,1.44-2.43,1.53-4.24.48-3-.12-4.56,1.45-3.39,4.35A3.76,3.76,0,0,1,1239.63,732.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1370.41,720.65c-2.65-1.38-5.59-1.92-8.27-3.18-.68-.19-.11-1-.49-1.48-.52,0-.81.52-1.31.51-.18-.08-.31,0-.42.15-1,.54-1.94-.56-.7-1,.63-.59,1.45-.58,2.12-1l.07-.09a.75.75,0,0,0,.1-.2l0-.11c0-.32.06-.65.37-.81l.51.23c1-1,1.77,1,2.64.93.72-.61,1.45-.4,2.3-.41,1.48-.45,1.89,2.16,3.21,1.19,1.1-.84,1.13.53,2,.71A15,15,0,0,1,1370.41,720.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-129",
    d: "M1385.83,705.62c-2,1.11-4.51-2.51-1.54-2.9C1385.73,702.29,1387.62,704.72,1385.83,705.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1384.23,705.68h1.42A1.29,1.29,0,0,1,1384.23,705.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1391.73,703l.71,0A.46.46,0,0,1,1391.73,703Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1382,707.07a1.42,1.42,0,0,1,.77-.26A.89.89,0,0,1,1382,707.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1387.6,702.74c-.25-.23-.35-.46,0-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1380.08,707.45l-.48-.35A.64.64,0,0,1,1380.08,707.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1387.79,702a.35.35,0,0,1,.55,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1391,702a.61.61,0,0,1,.29.46A.76.76,0,0,1,1391,702Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1392.44,703v-.47A.28.28,0,0,1,1392.44,703Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1389.31,703.21a.62.62,0,0,1,.28.48A.7.7,0,0,1,1389.31,703.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1383.27,706.12v-.47A.3.3,0,0,1,1383.27,706.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1390.51,703.7l0-.47A.27.27,0,0,1,1390.51,703.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1390.51,701.35a.53.53,0,0,1,.28.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1388.58,704.16a.68.68,0,0,1-.28-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1390,703.93l.54-.23A.78.78,0,0,1,1390,703.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1389.51,701.88c-.19-.2-.22-.38,0-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1387.35,704a.64.64,0,0,1,.28.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1389.69,701.25a.46.46,0,0,1,.69,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1388.22,704.65l.35-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1387.61,704.41l.27.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1388.57,704.43l0-.24A.16.16,0,0,1,1388.57,704.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1386.42,705.16c.06-.11.13-.22.2-.33C1386.55,704.94,1386.48,705.05,1386.42,705.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1389.55,703.67a.47.47,0,0,1,.33.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1386.17,705.4l.22-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1383.73,705.43l.3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1388.32,703.73a.34.34,0,0,1-.23-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1385.83,705.62l.32-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1388.09,703.46l-.17-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1390.5,703.25l-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1389.08,702.88l.23.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1391.48,702.73l.21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1390.27,703l-.17-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1387.83,703.07l-.23-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1383,706.61l.24-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1391.25,702.46a.37.37,0,0,1,.24.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1388.82,702.49l.18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1390,702.59l-.24-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1388.58,702.22a.33.33,0,0,1,.24.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1380.34,706.63l.26.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1382.73,706.84a.33.33,0,0,1,.27-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1389.78,702.27l-.2-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1388.34,702a.29.29,0,0,1,.26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1390.76,701.74a.32.32,0,0,1,.22.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-130",
    d: "M1361.91,713.4c.16.67.22,1.3-.47,1.68h0c-.36.29-.85,0-1.22.23h0a2.63,2.63,0,0,1-.5.5l0,0c-3.87,1-2.46-5.55.69-2.6-2.91-2.22-4.24,1.18-1.69,3.19a1.19,1.19,0,0,0,1.26,0,.13.13,0,0,1,.22-.06c.52.05.93-.72,1.42-.28-1.62,1.41-3,1.36-4.81-.17-.76-.1-.26-.89-.67-1.29-.22-.11-.18-.25-.06-.41v-.49c-.13-.09-.06-.19,0-.2C1357.05,710.82,1360.72,711.13,1361.91,713.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-131",
    d: "M1366.78,712.68l-1.6-2.55c.94-.2,1.57-1,2.57-.87.31,0,.45-.31.68-.46,1.43-1,2.35.6,3,1.67.11.16.23.35,0,.52-1.19.66-1.35-2.66-2.72-1.67-.85.8,1.24,1.68.69,2.48a.42.42,0,0,1-.64-.07c-.57-.58-1.08-2.32-2.12-1.58-.27.24-.16.51,0,.76.21.56,1.19,1.14.84,1.75h0A.62.62,0,0,1,1366.78,712.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-93",
    d: "M1363.63,714.71l.47-.38c0-.75-.78,0-.95-.48h0c-.15-.11-.39-.07-.49-.27h0c-.88-.7-1.27-2.46.27-2.7s1.45-.38,2.29.9c.67,1.08,1.92,2.2.27,3.05l0,0A2.08,2.08,0,0,1,1363.63,714.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-70",
    d: "M1375,709.75a16.92,16.92,0,0,0-1.81.64c-1.23.25-1.94-1.26-.76-1.79.24-.14.52-.2.69-.46-.7-1.12-1.19.69-1.86.34-.41-1.34,2.13-1.7,2.77-.62a6.93,6.93,0,0,0,1.09,1.43C1375.48,709.54,1375.13,709.62,1375,709.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-72",
    d: "M1360.49,703.94c-.17-.54-1-1.25.11-1.34.45,0,.7-.74,1.08-.63l1,.06c.41.4,2.54,3,.85,2.41-.59-.59-1.06-2.29-2.13-1.59-.56.61.42,1.31.65,1.88.36,1-.79.53-1-.06C1360.53,704.61,1360.43,704.33,1360.49,703.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1360.49,703.94a1.47,1.47,0,0,1,.47.73,1.18,1.18,0,0,1-.49.5c-.84,0-1.37,1.27-2.25.35.53-.89,2.57-.47,1.3-1.85C1359.9,703.57,1360.13,704,1360.49,703.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1367.7,700.8c.11.15.1.38.3.48h0c.1.14.25.25.3.41-.67.72-2.16-.41-1.49-1.17l0,0C1367,700.85,1367.45,700.52,1367.7,700.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-132",
    d: "M1374.45,705.71c0,.48-.75.54-.81.09S1374.36,705.28,1374.45,705.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1365.31,702.5c-.21-.29-.66-.47-.44-1C1365.18,701.79,1365.51,702,1365.31,702.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1375,709.75l.12-.46a.64.64,0,0,1,.36.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1366.28,714.1l0-.7a1,1,0,0,1,.21.71l-.13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1366.78,712.68l.72,0A.47.47,0,0,1,1366.78,712.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1367.5,712.66c0-.16,0-.31,0-.46A.29.29,0,0,1,1367.5,712.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1361.68,702a.44.44,0,0,1-.22,0C1361.46,701.69,1361.6,702,1361.68,702Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1362.64,702l.06-.19c.14.11,0,.13-.06.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1374.19,710a.53.53,0,0,1,.56-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1359.25,703.5a.57.57,0,0,1-.22-.07A.15.15,0,0,1,1359.25,703.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1362.45,713.32l.26.26-.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-40",
    d: "M1363.16,700.79a.62.62,0,0,1,.07.23C1363.18,700.94,1363.08,700.89,1363.16,700.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-7",
    d: "M1376.21,708.09l-.21-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-133",
    d: "M1269.43,760.56c-2.4-.56-8-.45-6.43-4.24.24-.44.45-.92,0-1.34s-.23-1,0-1.52c1.85-2.63,3,2.58,4.79,2.74.36.66,1.07,1.11,1.36,1.79C1269.1,758.87,1270.1,759.82,1269.43,760.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-134",
    d: "M1252,753.58c.65-.05,1.24-.51,1.93-.17.18.08.37-.12.55-.18a2.85,2.85,0,0,1,2.6.13c1.22-.59,2,1.89,1.08,2.57-.23.19-.21.25-.06.44s0,.45-.07.67a26.46,26.46,0,0,1-5.73-3.24,2,2,0,0,1-.29-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-135",
    d: "M1260.2,758c1.82-1.78-1.37-4.35-.47-6.81.35-.14.51.09.63.35s.37.11.57,0c1.47.2.79,2.16,1.73,3s.42,1.68-.2,2.36C1261.82,757.3,1261.14,758.68,1260.2,758Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-136",
    d: "M1271.56,760.87l-.68-.07c-4.48-7.43,4.3-4,1.55-.43C1272.34,760.84,1272.05,761.06,1271.56,760.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-137",
    d: "M1269.89,756.73c.27,1.38,1.15,2.58,1,4.07-1.68.27-1.33-2-2.2-2.87h0a4.31,4.31,0,0,1-1-1.75C1268.36,755.88,1269.84,755.49,1269.89,756.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-138",
    d: "M1276.2,761.27c-1.63.45-3.92-3.89-2.13-4.53.66,0,.93.69,1.43,1C1276.29,758.4,1277,760.54,1276.2,761.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-139",
    d: "M1274.24,758.91a8.35,8.35,0,0,1,1.22,2.35,7.91,7.91,0,0,1-2.17-.2c-.22-.41-.63-.79-.56-1.28.39-.4-.17-1.45.94-1.36A.83.83,0,0,1,1274.24,758.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-140",
    d: "M1279.09,761.29c-3.09,1-4.18-5-1.89-3.08a5.93,5.93,0,0,1,1.73,1.9C1279,760.5,1279.58,760.82,1279.09,761.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-141",
    d: "M1262.15,756.71c0-.77.93-1.07.48-1.93,1.07.33,1.26.72,1,1.94-.86.36-.13,1.64-.24,2.37a3.89,3.89,0,0,1-1.44-.48A2.17,2.17,0,0,1,1262.15,756.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-142",
    d: "M1282,761.1a1.62,1.62,0,0,1-.1.18h-2.1c-.73-.27-.35-1,.34-.92a.4.4,0,0,0,.16-.13c.44-.59.14-1.23.17-1.87.43-.5.9-2.12,1.73-1.35.35.88-.23,1.67-.27,2.52C1282,760.08,1282.45,760.59,1282,761.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-143",
    d: "M1262.15,756.71c.59.71.19,1.31-.23,1.9a2.71,2.71,0,0,1-1.22-.46C1261.13,757.61,1261.33,756.86,1262.15,756.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-144",
    d: "M1276.2,759.63a4.11,4.11,0,0,1,1.68,1.65c-.61,0-1.52.3-1.68-.45C1276.17,760.4,1275.91,760,1276.2,759.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-145",
    d: "M1268.68,757.93a3.69,3.69,0,0,1,1.21,2.69l-.46-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-146",
    d: "M1271.56,760.87c.47-.17.5-.57.53-1-.09-.67,1-.79.82-.06-.22.38.37.84-.11,1.2A2.39,2.39,0,0,1,1271.56,760.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-89",
    d: "M1258.76,764.46c.24.23.58.21.86.33.52.17.1,1-.34.7a8.19,8.19,0,0,1-.77-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-147",
    d: "M1279.57,760.6l.26.69h-.74C1277.82,759.49,1279.69,758.77,1279.57,760.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-136",
    d: "M1272.8,761c0-.39-.34-.78,0-1.18a.81.81,0,0,1,.26,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-148",
    d: "M1273.05,761v-.92a.61.61,0,0,1,.24.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-77",
    d: "M1252.26,753.8a.71.71,0,0,1,.43.29A.6.6,0,0,1,1252.26,753.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-149",
    d: "M1276.2,760.83l.24.44a.65.65,0,0,1-.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-77",
    d: "M1252,753.58l.25.19A.26.26,0,0,1,1252,753.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-75",
    d: "M1259.61,757.72l.35.17A.37.37,0,0,1,1259.61,757.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-150",
    d: "M1244,730.58c3.42.72,3-.3,5.46-1.91,1.94-1.11,5.49-1.68,4.47-4.63.13-.13.23-.27.42-.29,1.5.78.08,4.61-1.65,4.89a10.24,10.24,0,0,0-4.38,2.48c-.53.59-1.25.34-1.9.42h0c-.58.36-.9,1.47-1.69,1,0-1.24-1.2-.79-1.7-1.45C1243.41,731.05,1243.83,731.08,1244,730.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-151",
    d: "M1248.58,732.75c-.39.35-.64.91-1.31.84-.34,0-.46.21-.57.5s-.31.67-.78.6c-.53-2.35,1.57-1.07,1.21-2.9,2.14-1.94,5.07-2.63,7.31-4.19.75.07.53,1.06.55,1.58-.57,1.69-3.11,1.93-4.61,2.57C1249.48,731.71,1249.42,732.8,1248.58,732.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-152",
    d: "M1254.4,727.67c.07.7-.32,1-1,1.14-2.43.36-4,2.34-6.32,3l-.73-.25c1.8-.58,3.06-2.11,5-2.7.77-.26,1.39-.93,2.26-1.05.55-.25.38-1.15.77-1.58A.93.93,0,0,1,1254.4,727.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-152",
    d: "M1243.26,731.3c1.11,0,1.79-.24,1.45,1.21-.11-.13-.46-.34-.24-.49C1244.11,731.71,1243.5,731.82,1243.26,731.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-152",
    d: "M1245.68,732.27a.6.6,0,0,1,.48-.49A1.19,1.19,0,0,1,1245.68,732.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-151",
    d: "M1245.92,734.69l-.24.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-152",
    d: "M1246.16,731.78l.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-79",
    d: "M1244.47,732v.25C1244.44,732.18,1244.38,732.1,1244.47,732Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-153",
    d: "M1253.91,751.64c-1.58-.07-4-.11-4.8-1.69-.41-2-2.69-3-2.82-5-.44-3.65,1.92-4.63-1.82-3.72a3.51,3.51,0,0,1,2.81-1c1-.12.42.76.09,1.2a6.8,6.8,0,0,0-.24,2.66c-.61,2.07,2.43,3.53,2.75,5.66.42,1.29,2,.42,3,.8,2.59.35,2.88-4,6.6-3,.41.5-.23.85-.65,1C1256.72,748.9,1255.94,751.38,1253.91,751.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-154",
    d: "M1259.48,748.25c-1.31-1.67.54-1.61.39-3.07,0-.5.46-.85.48-1.35.34-.61-.36-1.52.54-2,1.74.47,0,2.53.89,3.68.25,2.43-1.11,4.79-.76,7.26C1259,752.12,1260.21,749.72,1259.48,748.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-155",
    d: "M1243.26,741.23c.8-2.65,3.83-3.75,5.86-5.41,1.76-1.43,4,2.15,2.1,3.25a4.78,4.78,0,0,0-2,3.51c-.64,4.47,3.47,3.31,4.11,5.42-.56,1.8-3.18-.61-4-1.21h0c-2.63-2.88-.57-5.28.1-8.48C1247,738.67,1245.22,740,1243.26,741.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-156",
    d: "M1259.24,747v.72c-4.64.1-2.76,4.29-6.89,3.27-.92-.45-2.44,0-2.83-1.22-.29-2.12-3.61-3.57-2.39-5.68.24,2,2.41,3.36,3,5.38.39,1,.89,1,1.46.28C1254.2,749.13,1256.42,746.34,1259.24,747Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-157",
    d: "M1244.47,740.5c.79-1.71,3.41-1.77,4.73-3,.17-.34.45-.25.72-.13,1,1.44-1.84,3.83-1.71,5.73-.45,1.51.93,2.35,1.1,3.67-2-1.65-1.82-3.74-.84-5.83C1250,737.64,1245.77,739.75,1244.47,740.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-157",
    d: "M1249.31,746.79a1.25,1.25,0,0,1,.89.31c.65.66,1.65.61,2.36,1.14.24.18.6-.13.69-.39,1.32-.57,2.87-2.21,4.33-1.13.08.85-.94.36-1.11.9a51.12,51.12,0,0,1-5,2.32h0c-.36-.05-.71-.05-.58-.63C1251.51,748,1249.57,748,1249.31,746.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-156",
    d: "M1247.13,743.65c-.64-.81-.14-1.49.24-2.18A4.9,4.9,0,0,1,1247.13,743.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-158",
    d: "M1248.58,732.75c2.87-2.79,4.5,1.78,4.54,4.19.84,3.38-5.44,4.31-1.47,8.5,1,.77-.17,1.74-.91,1-2.47-1.84-2-5.36.19-7.27,2.56-1.53-.39-3.26-.42-5.5-1,2-2.93,2.82-4.09,4.33-.2.27-.52.18-.75.31a3.53,3.53,0,0,0-1.93,2.19c-.14.15-.26.29-.49.24.71-4.65,3-3.36,4.11-6C1247.62,733.63,1249.1,734.35,1248.58,732.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-159",
    d: "M1308.65,755.51c-1,2.72-3.53,4.26-5.11,6.58-.89,1-1.91,2.3-3.15.94-1-1.06-2.7-.3-3.76-1-1.67-1.64-4.18-.9-5.9-2.1,1.22-1.24,3.49-1.58,5.18-2.06a21.77,21.77,0,0,0,3.84-1.67c1,0,1.53-1,2.44-1.14s1.44-1.33,2.49-.93C1305.93,754.85,1307.85,754,1308.65,755.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-160",
    d: "M1295.33,758.45c-1.41.59-3,.83-4.37,1.41-1.29.19-2.57.48-3.86.71-1.94-2.44-1.25-2.43,1.35-3.36,1.42-.41,2.33,2.63,3.39.11.54-1.69,2.66-.63,3.68-1.94a1,1,0,0,1,1.41.09C1297.26,756.73,1296,757.54,1295.33,758.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-161",
    d: "M1286.12,758.41c.31,1,2,.74,1,2.16-3.2,1.17-4-2.11-4-4.65.17-2.2,2.71-2.37,3.78-3.89a1.37,1.37,0,0,1-.19,2.39C1285.37,755.1,1284.43,757.7,1286.12,758.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-162",
    d: "M1285.4,753.81c-.67.5-1.94.87-1.83,2,.07,1.83.15,4.06,2,5a14.53,14.53,0,0,1-2.87.26c.28-2.73-1.79-6.29,1.69-7.75a4.4,4.4,0,0,0,1.45-1.49.35.35,0,0,1,.65-.08c.11.59.24,1.19-.4,1.59h0l-.25.24h0C1285.75,753.72,1285.53,753.66,1285.4,753.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-163",
    d: "M1284.68,753.57c-4,2.61-.25,4.77-1.94,7.49l-.71,0a5.11,5.11,0,0,0-.73-1.48v-.48c.49,0,.93-.1.76-.82-.1-.44.25-.91,0-1.36h0c-.82-1.06.51-2.46,1.21-3.27C1283.51,753.47,1285,752.8,1284.68,753.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-89",
    d: "M1265.5,766.55c-.27.49-1,.42-1.4.07C1263.91,765.91,1265.21,766.2,1265.5,766.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-89",
    d: "M1271.34,769.66c-.42,0-.33-.72.08-.67S1271.76,769.69,1271.34,769.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-89",
    d: "M1269.71,769c-.28.06-.57-.49-.16-.54S1270.2,768.92,1269.71,769Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-86",
    d: "M1317.83,762.51l-.47.22C1316.75,762.09,1318,761.58,1317.83,762.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-86",
    d: "M1316.67,763l-.2-.07C1316.58,762.84,1316.63,763,1316.67,763Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-87",
    d: "M1308.65,755.51c-4.54-.75-5.93-1-1-3.76,1.93-1.35,3.56-3.16,5.63-4.25a1.11,1.11,0,0,0,1.35-.45c1.82-1.8,2.77-5.42,5.24-6.15,2.33.22,4.07,1.72,6.33,2,1.18-.06,2.26,1.19,3.3,1.34,2.16-.78,3.09,1.67,4.91,1.8,1.44.72,0,2.5-.78,3.25-1.59,1.83-2.51,4.11-4.12,5.9-.92,1.41-1.24.36-2-.46-.47.05-.32.77-.79.79-.63,0-.53-1.27-1.33-.94-1.18.45-1.51-1.39-2.75-1-.91,0-2.75-.07-2.43-1.38-.33-.27-.49,0-.7.07-1.93.81-2.55-2.27-4.49-1.38-.94-.21-1.9-1.38-2.55,0-.81,1.56-2.32,2.57-3.07,4.16A.87.87,0,0,1,1308.65,755.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-87",
    d: "M1344.76,751.66l-.2-.07C1344.68,751.46,1344.72,751.65,1344.76,751.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-164",
    d: "M1335.05,747.28c-1-1.43-3.12-.84-3.86-2.39-.24-.57-.52-.61-.86-.11-.93,1.08-2.46-1.08-3.66-1.15-1.27-.33-2.58-.21-3.58-1.21-.76-.69-1.77-.27-2.6-.8-2.68-1.91-4.71,8-7.24,6.14.88-2.42,3.6-4.2,4.74-6.67.54-.6.6-1.59,1.45-1.88a1.24,1.24,0,0,0,1-.72c2.88-4.79,2.48-7,8.58-4,1.38,0,2.39-.61,3.57.68.8,1.05,2.06.12,3,.92C1342.46,740.63,1343.08,734.16,1335.05,747.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-165",
    d: "M1339.89,740c.55-1.14,1.65-5.67,3.15-5.33.15.06.32.19.44.16,1-.46,1.48.63,2.3.92,1,0,1.77.77,2.79.51a1.36,1.36,0,0,1,.79.23c.73.36,1.35,1,2.29.68.86,0,1,1.6,2.15,1.15,1.26-.18,2.14,1.08,3.41,1a.61.61,0,0,1,.44.16c.49.86,1.32.75,2.1.77-3.7,6.83-3,4.84-9.5,2.66-1.22-.64-2.31-1.63-3.74-1.39C1344.07,741.51,1342.4,739.34,1339.89,740Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-165",
    d: "M1360,739.77a1.35,1.35,0,0,1,.73-1A1.3,1.3,0,0,1,1360,739.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-88",
    d: "M1369,741.17c0-.12.14,0,.19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-88",
    d: "M1366.8,742.7l0-.05S1366.82,742.7,1366.8,742.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-166",
    d: "M1340.62,723.09c1.64,1.4,4.28.63,6,2.17a2,2,0,0,0,1.26.23c.89,1-.47,2.65-1.45,3.15a27.86,27.86,0,0,0-2.18,4.11c-1.54.79-3,.08-4.22-.59a13.88,13.88,0,0,0-5.25-1.75c-1.89-.6-3.56-1.79-5.59-2-2.29-.63-2.09,2.88-4.3,3.49-4,1.66-1.72-2.77-2.07-4.76.42-1,.16-2.19.85-3.05.54,0,.92-.59,1.44-.52.43.45,1.29,3.38,2.25,2,.26-.46.47-.83,1.1-.67,1.22-.53,1.7-2.9,2.63-4,.86-1.87,3,.45,4.23.79.39,2.37,1.58,3.1,3.59,1.45.3.09.48,0,.53-.33A.79.79,0,0,1,1340.62,723.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-167",
    d: "M1322.69,731.53c.42.28.91-.35,1.35.1.13.13.38,0,.54-.17.89-.72,2-1.26,2.22-2.57.08-.44.47-.74.75-1.07.59-.71,1.51.07,2.25,0,2,.17,3.51,1.6,5.29,2.08.84-.26,1.45.21,2.14.53a2.77,2.77,0,0,1,2.3.8c1.4,1,3.11,1.14,4.72,1.51-.36.68-1.15,1.08-1.21,1.94-1,1-1.21,2.74-2.42,3.63a6,6,0,0,1-5.13-1.6,1.34,1.34,0,0,0-1.63-.32c-2.22.27-1.59-2.52-4.84-1.19-.3,0-.59,0-.7-.3-.55-1.22-2.16-.42-3.12-1.16-1.94-1.09-3.4,4.32-4.75,5.5-2.3,1.66-.15-2.67.28-3.32S1322,731.06,1322.69,731.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-168",
    d: "M1347.88,726v-.25c.08-.08.14-.19.25-.24v-.24c.52-.43.44-1.27,1-1.7h0a2,2,0,0,0,.48-.72c.22-.09.55-.3.67-.13.46.61,1.37,0,1.75.71,1.11-.25,1.63.19,2.14,1.11.85,1,2.46.31,3.5,1,1,.2,2.18,1.08,3,.19.57-.56,1.16-.36,1.2.47.08,1.38,1.82,2.72,2.44.87,1,.29,1.06,1.54,2,1.81-1.2,1.29-1.86,5.7-4,5.09-1.18-.43-2.5-.18-3.45-1.23-1.73-1.15-1.2,1.09-4.46-1.66-.59-.78-1.42-.17-2.1-.51a13.68,13.68,0,0,0-5.87-1.93A17,17,0,0,1,1347.88,726Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-66",
    d: "M1396.59,730.6l0-.05S1396.62,730.6,1396.59,730.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-169",
    d: "M1322,716.74a21.39,21.39,0,0,1,1.32,7.43c-2.2,1.18-4.13-1.31-4.49-3.26C1318.4,720.15,1321.3,716.4,1322,716.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-170",
    d: "M1340.62,723.09a3.27,3.27,0,0,1-1.18-.34c-.86-1.82,1.45-1.39,1.14-2.23-.71-.82-1.14.85-1.8.54-.2-.14-.13-.36,0-.54,1.39-2,3.72-.07,3.81,1.83-.26.27-.67-.05-.92.25a2.3,2.3,0,0,1-.78.46A.61.61,0,0,0,1340.62,723.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-171",
    d: "M1322,716.74c-.79.57-.83,1.7-1.68,2.16-.67.36-.68,1.15-1.08,1.68a10.81,10.81,0,0,0,.75,2.25c-.71.6-.88-.67-1.24-1.05-.08-.12-.06-.33-.21-.4h0a2.83,2.83,0,0,0-.25-.24c-.87-1.34.49-2.07,1-3.12.22-1.4,1.51-1.58,2.4-2.21A1.63,1.63,0,0,1,1322,716.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-172",
    d: "M1323.18,724.28l0-2.21c.34,1.34,1.08,5.26-1.43,4.16-1-.4-2.22-.48-3-1.34-.22-1-2.64-1.49-1.72-2.51C1318.83,722.42,1321.87,725.12,1323.18,724.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-173",
    d: "M1338.91,723.08c-1.11,2.3-4.6,1.08-3.59-1.45,1.53-.87,2.31-.71,3.07.63-.54.5-1.32.52-1.9.93C1337.32,724.37,1338,722.9,1338.91,723.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-130",
    d: "M1347.29,718.84c.36-.65-.65-1.64.28-2,.94.36.62,2.69,1,3.66s-1.72,1.6-1,.48-1.59-1.85-2.21-2.68c-.16-.12-.35-.28-.18-.49C1345.93,717.29,1346.53,718.69,1347.29,718.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-174",
    d: "M1321.72,715.81c-.41.43-.68,1-1.35,1.15a.61.61,0,0,0-.43.55c-.31,1.34-1.85,2.06-1.61,3.63-1.79-1.61.56-2.35.89-3.86.24-1.28,1.9-.93,2.24-2.19A1.12,1.12,0,0,1,1321.72,715.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-175",
    d: "M1341.62,717.75c1.16.61,1.56,2.35,2.4,3.39.41.38-.37.94-.64.47C1343.13,720.76,1340.54,718.14,1341.62,717.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-129",
    d: "M1350.72,719.17c-1.47,0-1.84-2.34-2.76-3.28-.46-.44.34-1,.65-.47C1348.93,716.33,1351.16,718.57,1350.72,719.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-131",
    d: "M1343.41,717.06c1.09.72,1.53,2.36,2.36,3.41,0,2.28-2.28-2.33-2.67-2.83C1342.91,717.31,1343.09,717.12,1343.41,717.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-176",
    d: "M1352,717.26c.09.39.69.77.33,1.16-1,.49-1.35-1.43-1.9-2-.11-.2-.31-.42,0-.61C1351.23,715.43,1351.52,716.83,1352,717.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-177",
    d: "M1350.45,715c0,.46-.78.51-.8.06S1350.36,714.53,1350.45,715Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-167",
    d: "M1323.38,725.5l.09-1.94a3.27,3.27,0,0,1,0,2.42C1323.27,725.85,1323.3,725.68,1323.38,725.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-166",
    d: "M1341.63,722.6c.24-.34.61-.19.92-.25A1.32,1.32,0,0,1,1341.63,722.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-24",
    d: "M1338.2,711h-.32c.1-.26.21-.05.32,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1350.72,719.17l0-.45a.74.74,0,0,1,.26.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-166",
    d: "M1340.85,723.06l.49-.22A.72.72,0,0,1,1340.85,723.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1349.34,723.31l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1349.1,723.55l-.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-166",
    d: "M1341.37,722.82l.22-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1348.37,725l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1348.13,725.49l-.25.24v-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-card-24",
    points: "1334.56 713.63 1334.61 713.59 1334.57 713.63 1334.56 713.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-178",
    d: "M1355.4,714.83a1.45,1.45,0,0,0,.48.73c.92.1.54,2.29-.32,1.13-.27-.77-1.53-1.65-1.15-2.42C1354.89,713.92,1355.11,714.57,1355.4,714.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1356.35,716.3a1.36,1.36,0,0,1-.47-.74,1.19,1.19,0,0,1,.49-.48l.47.74A1.19,1.19,0,0,1,1356.35,716.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1358.06,711.68l-1.2.61C1357,711.8,1357.74,710.76,1358.06,711.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1356.11,714.12l.06.41C1355.87,714.48,1355.87,714.48,1356.11,714.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1356.15,713.43a.24.24,0,0,1,0,.2C1356,713.55,1355.93,713.29,1356.15,713.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-card-39",
    points: "1355.4 714.83 1355.44 714.79 1355.4 714.83 1355.4 714.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-179",
    d: "M1358.91,704.25c-.1.43-.52.39-.81.53C1356.86,704.91,1358.32,703.23,1358.91,704.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-180",
    d: "M1312.29,717c.52,0,.91.62,1.34.77,1.66-.15,2.33,1.18,3.25,2.14.41.58,1.5,1.44,1.22,2.19-.34.35-1-.06-1.23.48-.92.32-1.17-.63-1.75-.94-.17-.4-.66-.36-.9-.67-.41-1.54-2.92-2-2.08-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-181",
    d: "M1316.89,722.57c-.09-2.57,1.35.64,2.29-.32l.13.09a6.89,6.89,0,0,0,3.87,1.94c0,.5,0,1-.7.62C1320.65,724,1318.67,723.55,1316.89,722.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-181",
    d: "M1319.06,722.34a.92.92,0,0,1-.48-.72c.08-.12.16-.13.24,0h0l.24.24h0A.32.32,0,0,1,1319.06,722.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-28",
    d: "M1317.13,720.16l-.25-.24v-.48A1,1,0,0,1,1317.13,720.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-174",
    d: "M1318.82,721.62h-.24v-.24h.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-174",
    d: "M1318.34,721.14l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-180",
    d: "M1314.46,708.31c-.4,2.79-3.76,1.89-4.37,5.57-.24.91,1.25.22,1.23,1.44-.82.61-1.73-.07-2.37-.49-1.32-.88,1.56-5.09,3-5S1313.59,708,1314.46,708.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-180",
    d: "M1311.32,715.32a1.66,1.66,0,0,1,.48,1l-.16.09A.59.59,0,0,1,1311.32,715.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-180",
    d: "M1311.8,716.29a1,1,0,0,1,.49.72A.44.44,0,0,1,1311.8,716.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-182",
    d: "M1311.31,715.33a2.13,2.13,0,0,0,.24,1c-.14.57.76,1.24,0,1.63s-.93-.69-1.53-.86c-3.49-2.42-2.69-6.21,1.12-7.62,2,0,3.2-3.78.83-3.89-4.71,0-3.77,4.66-7.26,3.68-.58-.19-1.56.41-1.72-.76a.66.66,0,0,1,1-.17c3.51.76,2.71-2.34,5.15-2.94a7.85,7.85,0,0,1,3.23-1.19c1.19,0,2.36,1.65,2.16,2.87.62,3.25-4,2.52-4.63,5C1308.67,715.1,1308.39,713.92,1311.31,715.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-183",
    d: "M1304.05,708.3l-1,.26a.61.61,0,0,1-1-.12c.48-2.05-2-3.53-1-5.45,1.73,1.1,1.55,3.43,2.91,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-166",
    d: "M1376.93,697.41a.85.85,0,0,1-1.08.38C1375.43,697.19,1376.77,696.82,1376.93,697.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1367.7,700.8a1.13,1.13,0,0,1-.92-.27C1367.09,700.61,1367.48,700.4,1367.7,700.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1368.18,701.51l-.19-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1368,701.28l-.24-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-184",
    d: "M1292.39,705.17l1,1.22c.77.49,1.9,1.29,1.6,2.44-.51.61-1.26.11-1.59-.42-.65-1.7-2.54-1.78-3.63-3-1.51-2-3.66-4.09-6.29-4.45a1.59,1.59,0,0,1-1.35-.78c-.07-.49-1.06-.43-.75-1,2.34-.81,5.24.59,7,2.23C1289.7,702.72,1291.48,703.47,1292.39,705.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-185",
    d: "M1295.32,707.1c-.93-1.29-1.42-1.5.43-2a4.88,4.88,0,0,1,6.14,2.5c.4,1.75-1.17,1.1-1.85.24C1298.67,706.24,1295.39,708.93,1295.32,707.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-186",
    d: "M1301.63,708.54c-.05-2.22-2.48-2.68-3.88-3.87.49-.64,1.32-.57,1.93-1l1,.48c.62,1.34,1.8,2.46,1.7,4.1C1303.43,709,1301.51,709.84,1301.63,708.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-187",
    d: "M1291.93,704.65a62.68,62.68,0,0,0-5.09-4.08c1.75-.53,3.93,2.52,5.34,3.62l-.23.25A1.49,1.49,0,0,1,1291.93,704.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-188",
    d: "M1295.32,707.1c1.18.52.66,2.66-.53,1.68,0-.87-.81-1.28-1.15-2-.17-.09-.09-.35-.28-.43h0C1293.91,705.53,1294.55,707.49,1295.32,707.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-185",
    d: "M1295.09,707.1c-.3.33-.3.33-.5-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-109",
    d: "M1292.16,704.9l-.2-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-109",
    d: "M1292.39,705.17l-.2-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-189",
    d: "M1302.35,708.29c-.16-1.66-2.49-2.36-1.7-4.1l.25-.25A4.53,4.53,0,0,1,1302.35,708.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-190",
    d: "M1287.35,700.32l-.51.25c-.21,0-.34-.13-.49-.24a5.72,5.72,0,0,0-3.09-1.26c-.36-.08.07-.24.22-.23s.15-.07.21,0a6.9,6.9,0,0,1,3.16,1C1287.06,699.47,1287.2,700.17,1287.35,700.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-49",
    d: "M1287.09,699.85l-.24,0a1,1,0,0,1,.24-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-191",
    d: "M1272.56,698.88c1.27-1.28,3.55-1.19,5.09-.52-.69.74-2.07.1-2.81,1.08C1274,699.39,1273.14,699.78,1272.56,698.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-192",
    d: "M1278.4,698.6c2.5-.16,3.15,1.87.23,1.56C1276.54,700.12,1275.55,697.89,1278.4,698.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-193",
    d: "M1280.09,699.81c-.14-.48.47-.51-.25-.94a10.24,10.24,0,0,1,3.36,0l.06.18h-1.56c.32.35.78.49.78,1C1282,700.64,1280.26,700.71,1280.09,699.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-194",
    d: "M1278.4,698.6c-.6,0-2-.14-1.24.73-.5.65-1.8.27-2.17-.27C1275.54,697.89,1277.41,698.27,1278.4,698.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-115",
    d: "M1283.69,698.85h-.21a1.64,1.64,0,0,1,0-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-195",
    d: "M1303.81,707.58c-.35,0-.63-.1-.73-.48a9.38,9.38,0,0,1,1.5-1c.87-.11,2.75-2.07,1.29-2.41-1.32-.12-2.71-.47-3.78.75a1.64,1.64,0,0,1-.46-1c1.38-1.05,3.41-.17,5-.65,1.15-.34,2.08,1.5.9,1.89C1305.81,705.65,1306.54,707.07,1303.81,707.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-196",
    d: "M1257.37,705.21l.42-.29a.57.57,0,0,0,.49.48c.42,1-1.79,4.59-3,4.13C1255.52,708,1256.83,706.69,1257.37,705.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1255.58,708.75l-.19.77c1.24.18.94,1.51.29,2.16-.45.59-.5,2.27-1.52,2a20.59,20.59,0,0,1,1-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-150",
    d: "M1254.14,721.37l-.48-.48c0-.08,0-.16,0-.24C1254.13,720.29,1254.58,721,1254.14,721.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-125",
    d: "M1253.91,720.65h-.23c-.07-.25.09-.48.16-.72A.45.45,0,0,1,1253.91,720.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-198",
    d: "M1253.91,720.65c-.46-2.21.5-3,1.29-.5.41,1,1.86,1.69,1.38,2.89-.51.91.39,1.83,0,2.74s-1.35.32-1.48-.42a3.45,3.45,0,0,0-.93-2.5C1253.8,722.14,1254.48,721.28,1253.91,720.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-199",
    d: "M1254.15,718.72a1,1,0,0,1-.5-.08l-.13-.2,0-.11-.1-.05c-.13-.49-.08-1-.22-1.52-.21-5.18,5.7-4.53,2.23-2.25a8.5,8.5,0,0,0-.59,3.24C1254.93,718.2,1254.86,718.75,1254.15,718.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-125",
    d: "M1253.65,718.64l.23.08-.09.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-125",
    d: "M1253.83,719.24a.16.16,0,0,1,0,.16A.11.11,0,0,1,1253.83,719.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-125",
    d: "M1253.44,718.28a.12.12,0,0,1,.08.16A.8.8,0,0,0,1253.44,718.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-125",
    d: "M1253.31,717.32a.09.09,0,0,1,0,.12A.09.09,0,0,1,1253.31,717.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-125",
    d: "M1253.22,716.76a.13.13,0,0,1,.06.18A.64.64,0,0,1,1253.22,716.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-200",
    d: "M1259.72,704.19c1-1.29,2.72-1.18,3.89-2.15.84-1.36,2.35-.84,3.55-1.39,1-.3,2-.08,2.13,1.15-.22,1-1.47.45-2.15.69-1.34.25-1.17,2.13-3.16,2.26C1262.86,704.49,1260.05,705.51,1259.72,704.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-201",
    d: "M1268.67,700.81h-.46c-.2.24-.54,0-.74.23h-.24c-.92.24-1.92-.33-2.85.3a.67.67,0,0,1-1-.3,1.75,1.75,0,0,1-1.06,0C1273.1,696.25,1272,704.26,1268.67,700.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-202",
    d: "M1263.37,701.05c1.35.28,2-1,3.39,0,.13.46-2.54.38-3.15,1C1263.51,701.72,1263.17,701.45,1263.37,701.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-203",
    d: "M1259.72,704.19a1.41,1.41,0,0,0,1,.25c.28.76-.49,1-1,1.31-.92.08-1.18,1.66-2.19,1.1,0-.63.64-.89.75-1.45h0c.49-.33.74-.87,1.22-1.21h.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-204",
    d: "M1268,699.84c-1.63.69-3.59.45-5.32,1,.95-.94,2.26-1.13,3.4-1.68C1266.58,699.59,1267.54,699,1268,699.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-205",
    d: "M1268,699.84c-.63-.25-2.25.43-1.92-.72.53-.78,1.42-.79,2.16-1.24a.26.26,0,0,1,.32,0c.34.46,1.47.42,1.09,1.27s-1.27-.13-1.38.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-206",
    d: "M1269.41,698.63c-.24-.24-1.64-.77-.74-1,1.1,1.25,1.82,0,3.21.18C1271.52,698.72,1270.17,699.43,1269.41,698.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-127",
    d: "M1268.19,697.88c-.26.52-.72.55-1.21.48A1.66,1.66,0,0,1,1268.19,697.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-127",
    d: "M1267,698.36a.59.59,0,0,1-.47.28A.52.52,0,0,1,1267,698.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-127",
    d: "M1268.45,697.67l0,.27-.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-122",
    d: "M1259.49,704.19a1.19,1.19,0,0,1-.49.48A.58.58,0,0,1,1259.49,704.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-196",
    d: "M1257.79,704.91l.21-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-196",
    d: "M1258.52,705.16l-.25.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-150",
    d: "M1254.14,721.64c-.15.77,1,1.72,0,2.16A2,2,0,0,1,1254.14,721.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-207",
    d: "M1275,699.06l.72.08c1,1-5.3,1.08-4.64.15a1.73,1.73,0,0,0,.28-.19,1.89,1.89,0,0,0,1.21-.22A6.86,6.86,0,0,0,1275,699.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-206",
    d: "M1270.65,699.1h.45a.13.13,0,0,1,0,.24.48.48,0,0,1-.8,0l0-.16.08-.14A.23.23,0,0,1,1270.65,699.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-208",
    d: "M1271.11,699.35c0-.08,0-.16,0-.24h.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1270.65,699.1h-.27c-.06-.23.06-.31.28-.22A.81.81,0,0,0,1270.65,699.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1358.75,716.36c-2.8-.7-2.44-4.91.77-4.3a2.66,2.66,0,0,1,1.89,1.84.51.51,0,0,1-.92.44c-1.55-4-4.65,1.21-.74,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1363.15,713.85a2.42,2.42,0,0,0,1.85-.32.22.22,0,0,1,.32,0C1365.58,714.78,1363.68,714.36,1363.15,713.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1363.63,714.71c.63.38,1.29.13,1.94.1A1.53,1.53,0,0,1,1363.63,714.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1360.22,715.31c.35-.35.82-.11,1.22-.23A1.69,1.69,0,0,1,1360.22,715.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1365.82,714.6l.46-.5C1366.57,714.37,1366,714.46,1365.82,714.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1362.67,713.58a.6.6,0,0,1,.49.27A.7.7,0,0,1,1362.67,713.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1361.94,714.6l.08-.46A.32.32,0,0,1,1361.94,714.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1360.23,716.27a.3.3,0,0,1-.22.06A.15.15,0,0,1,1360.23,716.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1359.73,715.8a.3.3,0,0,1,.26-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1360,715.56l.24-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1361.44,715.08l.25-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1365.54,714.83a.33.33,0,0,1,.26-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1361.74,714.84l.19-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-39",
    d: "M1366.3,714.35a1.23,1.23,0,0,1,0-.2l.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-210",
    d: "M1384.41,703.25c1.07-.06,2,1.83.57,1.9C1384,705.21,1383.08,703.36,1384.41,703.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-211",
    d: "M1359.83,714.68c-.38,1.59-2.16-.9-.95-1.33C1359.5,713.28,1359.68,714.21,1359.83,714.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-212",
    d: "M1364.78,712.72c-.36,1.14-2,.23-2-.67C1363,710.59,1364.76,711.71,1364.78,712.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-213",
    d: "M1373.21,709.75c-1.51,0,.41-1.84.6-.59C1373.82,709.57,1373.53,709.7,1373.21,709.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-214",
    d: "M1263.6,756.72a1.79,1.79,0,0,0-1-1.94c-.72-1.24-.61-2.77-1.28-4.06s.48-2.46.07-3.68h0a1.41,1.41,0,0,1,0-1.22c.34-.57-.41-1.63.69-1.64,1.65.9,1.53,4.54,1.36,6.21s1.34,1.22,1.8,2.54c.7,1.26,2.59,1.86,2.44,3.54a1.89,1.89,0,0,1-1.85-1.47c-.21-.75-1-1.16-1.45-1.74s-1,.43-1.21.83.26.51.36.78C1263.79,755.48,1264.32,756.09,1263.6,756.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-145",
    d: "M1268.45,757.68l.23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-215",
    d: "M1261.42,747a3.05,3.05,0,0,1,.23,1.86c0,2,1.6,3.77,1,5.88-1.16-.25-2.22-4.6-1.94-5.71,0-.24,0-.53.2-.66C1261.43,748.07,1261.29,747.51,1261.42,747Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-216",
    d: "M1267.72,756.22c-6.76-6.34,4.52-1.62,2.17.5-1.17-1.15-.68.12-1.34-.06A2.22,2.22,0,0,0,1267.72,756.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-148",
    d: "M1270.14,756.47a1.69,1.69,0,0,0,0-.23c-.34-.38,0-.88-.34-1.37s.16-.89.83-.68a12.53,12.53,0,0,0,2.43,2.45c.55.37.36,1.08.71,1.54a.33.33,0,0,1,.06.46c-1,.09-.71.87-.78,1.47l-.25-.26C1273.29,757.82,1271.19,757.54,1270.14,756.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-136",
    d: "M1269.65,756.48l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-149",
    d: "M1276.2,759.63c0,.32,0,.64,0,1-.54-.84-.07-2-1-2.63-.86-2.57-1.67-1.45-.44-4.52.72-.51.92.27,1.32.53.43,1,.65,2.17,1.62,2.9.15.67.7,1.7.16,2.26-.64-.08-.91-.73-1.48-1C1276,758.63,1276.57,759.2,1276.2,759.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-217",
    d: "M1273.76,758.18a5.07,5.07,0,0,1-1.12-1.66c.24-1.12-1.41-1.86-.52-3,1.24-.48,1.35,1.22,1.76,1.93C1275.27,757.41,1273.61,756.45,1273.76,758.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-218",
    d: "M1275,756.71c.67.64.67.67.21,1.26C1274.78,757.54,1273.87,756.85,1275,756.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-217",
    d: "M1273.82,758.64l-.06-.46a.81.81,0,0,1,.48.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-217",
    d: "M1274.45,757c0,.07,0,.14,0,.2a1.89,1.89,0,0,1-.2-.2C1274.3,756.89,1274.41,756.86,1274.45,757Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-147",
    d: "M1277.87,759.14l0-.24c.35-.07.36.14.33.39l-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-147",
    d: "M1278.36,759.88c-.08-.16-.17-.31-.26-.47l0,0c.33-.06.35.15.33.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-147",
    d: "M1278.59,760.12l-.23-.24,0,0C1278.61,759.79,1278.73,759.92,1278.59,760.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-219",
    d: "M1281.55,757.19l0,1-.22.25c-.51-.31-1.27-.67-.87-1.4s-.35-.84-.4-1.3c-.25-1.9,1.61-4.66,3.29-4.79C1284.53,752.46,1281.43,753.9,1281.55,757.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-220",
    d: "M1282,757c.45,1,1,4.33-.72,2.18A3.19,3.19,0,0,0,1282,757Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-220",
    d: "M1283.47,753.82A6.93,6.93,0,0,0,1282,757c-.39.08-.31-.3-.5-.48C1281.47,755.53,1282.29,753.16,1283.47,753.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-219",
    d: "M1280.32,761.06l-.27-.2c-.16-.72-.33-2.28.78-2.2a3.07,3.07,0,0,1,0,1.7c-.14.13-.08.35-.22.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-221",
    d: "M1280.78,758.67l-.44.73c-.84-.27-.12-2,.46-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-221",
    d: "M1280.81,760.12v-1.23c.09-.08.16-.07.22,0C1281,759.33,1281.1,759.76,1280.81,760.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-222",
    d: "M1280.8,758.4l-.47-.25c0-.58.53-.28.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-223",
    d: "M1279.57,760.6l-.25-.48.14-.08a.46.46,0,0,1,.45.41l-.07.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-222",
    d: "M1281.51,756.48l.27.47-.23.24C1281.54,757,1281.53,756.72,1281.51,756.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-221",
    d: "M1280.56,760.84l.22-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-222",
    d: "M1281.3,758.41l.22-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-222",
    d: "M1281,758.93l-.22,0a1.79,1.79,0,0,1,0-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-220",
    d: "M1281.3,759.62l.22.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-221",
    d: "M1280.08,760.6l0,.26-.21-.26h0l.12-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-221",
    d: "M1280.32,761.06l.24-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-224",
    d: "M1278.62,760.1c-.68-.92-2-3.69-1.26-4.64C1279.21,755.41,1279.2,758.88,1278.62,760.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-223",
    d: "M1280.81,757.92l-.48.23-.07.25c-.51.47-.1,1.43-.94,1.72l-.47-.49-.09-.15C1278.72,757.5,1280.13,753.86,1280.81,757.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-225",
    d: "M1254.17,723.79a2.57,2.57,0,0,0,.24-1,2.1,2.1,0,0,1,1,2.41c.07.7.65,1.55-.55,1.86-.78-.48.17-1.59-.42-2.3A.85.85,0,0,0,1254.17,723.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-151",
    d: "M1254.41,724.78c.74.65.28,1.43.23,2.16.16.28.16.48-.24.49C1254.39,726.55,1254.39,725.66,1254.41,724.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-226",
    d: "M1252.7,736.39c-1.18-2.2-.26-4.08-3.63-4.12.07-1,.85-1.13,1.66-1.11,1.18-.89,2.77-.86,3.91-1.8,1,.34,1,1.21,1.15,2-2.54.93-.85,4-.75,6,.38,1-.87.72-1.07,1.28C1252.18,739.84,1253.29,737.1,1252.7,736.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-227",
    d: "M1255.61,731.54a6.36,6.36,0,0,1-1-3.63c.64-.11,1.34,0,1.83-.57.79.5,1.9,4.92-.11,3.62.44.54.81.86.91,1.31s.4.19.64.16a3,3,0,0,1,1,2.61c-.75.58-1.25-.16-1.86-.33C1256.52,733.77,1255.27,732.71,1255.61,731.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-228",
    d: "M1256.35,727.42c.14.6-.31,2.56-1,1.41-.15-.36-.2-.8-.68-.92l-.24-.24c0-.27.14-.49.24-.73.77-.35.65-1.07.74-1.72C1255.51,726,1257.19,726.56,1256.35,727.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-229",
    d: "M1258.77,735.17a13.23,13.23,0,0,0-1-2.66c-.72-.3-.72-.84-.49-1.46a3,3,0,0,1-.25-1.45c1-.37,2.27,3.67,2.89,4.55-.7,1.68,1.48,2.35,1.28,3.8-.06,3,3.87,6.21,1.88,9.32-.43-.93-.39-2-1-2.9a1.31,1.31,0,0,1-.74-1.45c-.36-1-1.51-1.78-1.5-2.92C1260,738.24,1258.3,736.82,1258.77,735.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-230",
    d: "M1259.25,736.14c.91,1.84,1.07,3.87,1.68,5.81-.32.61.3,1.35-.23,1.95-1.27-.85-.44-2.83-1.67-3.84a8.43,8.43,0,0,1-.39-1.95C1259.14,737.54,1258.41,736.6,1259.25,736.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-231",
    d: "M1260.67,743.16c-.06.93.13,2.59-.93,2.94-1.34-.05-2.1-1-1.45-2.21A5.14,5.14,0,0,1,1260.67,743.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-232",
    d: "M1259.71,745.81c.32,0,.5-.26.72-.45-.12,1.76-2.22,2-3.61,2.16a.33.33,0,0,1-.49,0c.25-.51.86-.41,1.22-.72A2.19,2.19,0,0,1,1259.71,745.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-233",
    d: "M1261.41,742.92a7.92,7.92,0,0,1,.74,1.45c-.72.18-.31,1-.73,1.45A3,3,0,0,1,1261.41,742.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-215",
    d: "M1261.42,745.83V747A.93.93,0,0,1,1261.42,745.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-83",
    d: "M1258.27,745.34h.25c.29,1.41-1.4,1-2.19,1.45a11.72,11.72,0,0,0-3.14,1.21c-1.75-1.43-3.49-1-4.43-3.7a6.08,6.08,0,0,1,2.33-5.71c.46-.25.53-.8.26-1.38-.58-1.21-1-1.44-2.16-.74-1.83,1.3-4,2.29-5.45,4-.16-2.43,2.72-2.29,3.54-4.13.66-1.15,2.33-1.18,2.46-2.76.08-.58.6-.39,1-.36,1.11.16.13,2,1.13,2.64.71,1.72.83,2.84-1.07,3.77-.9.63-2.06,4.3-.82,5,.5.87.77,1.84,2,1.69,1-.39,2.21.28,3.2-.54a3.9,3.9,0,0,1,1.86-.37C1257.4,745.17,1258,744.88,1258.27,745.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-83",
    d: "M1243.5,740.74l.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-78",
    d: "M1256.33,747.52h.49c-1.68.92-3.35,2.53-5.33,2.42C1252.68,748.7,1254.78,748.35,1256.33,747.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-155",
    d: "M1256.33,746.79c.68-.62,1.78-.48,2.19-1.45a2.81,2.81,0,0,1,1.19.47A5,5,0,0,1,1256.33,746.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-155",
    d: "M1253.19,748a2.25,2.25,0,0,1,2.18-1A3,3,0,0,1,1253.19,748Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-155",
    d: "M1255.37,747a1.32,1.32,0,0,1,1-.24A1.32,1.32,0,0,1,1255.37,747Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-234",
    d: "M1257.3,745.82c-1.88-.23-3.5,1.73-5.33.49-1.08-.8-2.41-2.37-2-3.76.84-3.72,3.17-2.39,2.71-6.16,1,.58,0,1.63.49,2.41a.55.55,0,0,1-.14.76,7.18,7.18,0,0,0-1.57,2.22c-1.91,4,3.88,4.56,6,2.35.34-.1.62-.49,1-.24a2.79,2.79,0,0,1-.24,1.45H1258C1257.84,745.62,1257.55,745.67,1257.3,745.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-235",
    d: "M1307.91,752.11a57.19,57.19,0,0,1-5.56,3.38c-.6-1-.48-1.44.57-2.38,1.63-1.78,1.44-4.68,2.83-6.73.79-1.39,2.51,0,3.64-1.89,1.95-3.44,4.63-1.83,2.63.6C1311.13,747.66,1309.11,749.68,1307.91,752.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-236",
    d: "M1299.93,756.71l-1.45.5c-.35-.44-.12-.86.08-1.24,1-2.76,2.65-5.2,3.78-7.89C1308.72,742.72,1301.41,755.58,1299.93,756.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-237",
    d: "M1301.14,751.15c-1.4,2-1.19,5.58-3.63,6.55l-.24.22h-.49c-.31-.41-.07-.79.14-1.11,2.21-3.07,3.09-7.22,5.75-9.86,1,.2.71.6.17,1h0a1.88,1.88,0,0,0-.24.25A14.33,14.33,0,0,1,1301.14,751.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-238",
    d: "M1301.63,748.73c-1.84,3-2.89,7.38-5.55,9.45.68-3.16,3.13-6.73,4.67-9.9C1301.25,747.32,1302.45,747.74,1301.63,748.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-239",
    d: "M1299.93,756.71a57.57,57.57,0,0,1,2.91-5.56c2.61-.34-.81,3.26-.49,4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-240",
    d: "M1298.5,753.32c-.67,1.69-1.78,3.19-2.42,4.86l-.75.27c.15-1.14,1.26-1.82,1.45-3-.25-1.25.56-1.92,1.41-2.56C1298.39,753,1298.54,753.08,1298.5,753.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-84",
    d: "M1291,759.86l.47-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-238",
    d: "M1297.27,757.92l.24-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-241",
    d: "M1298.22,753.05l-1.44,2.45c-2.13,0-1,1.82-2.15,1.46a2.92,2.92,0,0,0-2.21,0c-.45.83-1.4.8-2.09,1.23s-1.53-1.39-1.58-1.94c-2.11,3.19-3.5.66-2-1.7,1.55-1.7-.33-3.55.48-5.25a1.21,1.21,0,0,1,2.33.06c0,1.09,1.24,1.51,1.26,2.61.85,5.39,4.2.67,7.43.62A.34.34,0,0,1,1298.22,753.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-242",
    d: "M1287.58,749.46a.82.82,0,0,0-.11.69c.47,1,.07,2.08.3,3.1,0,.7-.8,1.12-.53,1.89.17,1.27-1.41.65-.27,2.34.5-.08.53-.52.66-.81.27-.59.81-.88,1.23-1.31.25-.34,1.11.32.84.58-.87.73,0,1.43.36,2.06.64-1.85,1.19-.2,2.36-1-.26.59-.57,1.18.16,1.8-1,.08-1.8.12-2.6.22-1.19.1-.06-2.14-1.65-1.19-.51.23-1.1.25-1.52.68-.19.18-.46,0-.69-.06-.32.08-.52.69-.89.38-1.24-.57-.39-2.16-.34-3.23.24-1.75,3.1-1.32,2-3.44C1286,751.2,1285.78,747.87,1287.58,749.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-242",
    d: "M1292.67,757.92c-.41-.09.38-.78.33-.31A.47.47,0,0,1,1292.67,757.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-243",
    d: "M1286.36,749.94c.38.95,1.13,2.94-.23,3.39a3.38,3.38,0,0,0,.23-1.69c-.73-.54-1.49-2.43-.79-3.16C1286.84,748.41,1286.41,749.28,1286.36,749.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-243",
    d: "M1285.4,753.81l.48-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-243",
    d: "M1285.88,753.57l.25-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-244",
    d: "M1285.63,749.7c.57.53.51,1.28.73,1.94a2.77,2.77,0,0,1-1.68,1.93c-.3-.82.42-1.18.58-1.83S1284.9,750.27,1285.63,749.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-220",
    d: "M1285.64,751.88c0,.68-.64,1-1,1.45h-.24l-.14-.13C1284.12,752.13,1284.77,751.89,1285.64,751.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-220",
    d: "M1284.43,753.33c-.15.49-.57.47-1,.49h0C1283.47,753,1283.89,753,1284.43,753.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-245",
    d: "M1307.91,752.11c-.35-.29-1-.53-.12-1-.1-1.11,1.36-1.31,1.4-2.16-.45-.69.76-.63.48-1.26-.07-.15,0-.43.13-.33.86.58.55-.4.83-.58.52-.33.21-1,.74-1.44s-.43-.61-.26-1c.45-.08.59.56,1.05.44.13-.24-.1-.36-.19-.51-.6-.82,1-.55.07-1.57.64-1.43,3.37-.52,2.65-2.07-.4-1,2-.9,2.49-.42.1.67-.47,1.12-.77,1.52C1313.76,745.39,1311.94,749.71,1307.91,752.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-246",
    d: "M1311.08,749.48c-.16-.73-.58-1.1.48-1.24a.28.28,0,0,1,.07.19.25.25,0,0,0-.08-.18c.15-.49,1-.72.52-1.43,0,0,0-.17.09-.2,1.64-1.14,1.91-3.25,3.42-4.54.19-.2.49-.47.46-.67-.12-.9.62-.88,1.1-1.14s1.25-.81,1.69.22a55.36,55.36,0,0,0-5.34,7h0c-.07.09-.17.16-.24.25h0C1312.44,748.22,1312,749.18,1311.08,749.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-235",
    d: "M1318.83,740.49a14.52,14.52,0,0,0-3.74-.22c.05.4.58.37.55.83a3.19,3.19,0,0,1-2.44,1.19c-.11,1-.73.39-1.16.39-1.07-.7.48-1.94,1.11-2.4,0,0,0-.09,0-.1.25-1.95,3.27.45,4.2-2,.46-.85.6-.77,1.37-.05.28-.36.77-.87,1.11-.13-.12.26.13.55-.06.77V739l-.24.25v.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-247",
    d: "M1313.73,747a44.06,44.06,0,0,1,3.1-5c.47-.87.3-1.11,1.52-.75A22.17,22.17,0,0,1,1313.73,747Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-87",
    d: "M1315.19,745.58l.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-87",
    d: "M1315,745.82l.23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-87",
    d: "M1313.73,747h.25l-.24.25-.11-.12A1.47,1.47,0,0,0,1313.73,747Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-87",
    d: "M1313.49,747.52a1.93,1.93,0,0,1,0-.24c.07-.1.16-.1.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-87",
    d: "M1313.25,747.76l.24-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-248",
    d: "M1319.06,724.54c.28.47.86.57,1.22.94.15.61-.67.54-1,.32,1.5,1.32,4.56,2.35,3.67,4.73a6.61,6.61,0,0,0-.23,1l-.24.26c-1.19.25-.7-1.22-1.21-1.68-2-.91-2.73-4.69-5.11-2.84-.61-.56-.36-1.3-.3-1.94.31-2-2.18-2.56-2.43-4.41C1314.45,720.24,1317.52,724.08,1319.06,724.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-249",
    d: "M1323,729.4c-1.45-1.78-3.46-2.46-5-4.23a8.73,8.73,0,0,1,3.32.94s.09.08.09.07a1.33,1.33,0,0,1,.19.14s.09.08.1.07c.7.4,1.86,1.35,1.56,2.24C1323.13,728.83,1323.32,729.58,1323,729.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-250",
    d: "M1323.15,728.14c-.81-.27-1.12-1.17-1.9-1.44h0c-.33-.31-.64-.65-1-1h0v-.26c.82.18,1.7,0,2.47.53.37.27.42-.33.63-.51a6,6,0,0,1,0,1.64C1323.16,727.43,1323.47,727.87,1323.15,728.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-251",
    d: "M1332.37,722.81c.65-.16,1.58-1,1.94-.51.1.19,0,.32-.16.4-1,.59.18,1.45.43,2.14C1334.49,726.92,1332.74,723.41,1332.37,722.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-167",
    d: "M1323.15,728.14a2.74,2.74,0,0,1,.26-1,2.47,2.47,0,0,1-.21,1.49C1323.18,728.47,1323.16,728.31,1323.15,728.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-167",
    d: "M1323,729.4l.21-.07a1.37,1.37,0,0,1-.23,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-167",
    d: "M1322.72,731.29a1,1,0,0,1,.2-.76A1,1,0,0,1,1322.72,731.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-69",
    d: "M1347.88,726l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-252",
    d: "M1319.55,738.56l0-.62c-.87.3-1.12,1.11-1.8,1.72,0-.77.74-1.13.7-2-1.8,1.91-.75,2.88-4.26,2.08-1.22.27-7.3-1.37-5.91-3.07.58-2.6,2.59-2.25,4.43-2.05,2.44.51,10.7,0,7.06,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-253",
    d: "M1316.38,727.19c.39-4,3.46,1.94,4.8,2.14,1.71.45.22,1.74,1.27,2.46a5.08,5.08,0,0,1-.44,1.71c-1-.61-1.64-1.83-2.86-2.27-.88-1.39,1.77-.7-1.54-3.28.57.87,1.87,1.21,1.44,2.24a.81.81,0,0,1-1.07.27C1316.65,730.27,1314.15,727.72,1316.38,727.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-254",
    d: "M1321.51,734.93l0,.47c-.15.14-.08.4-.25.51-.22.92-4.29-.63-4.9-1.06.52-1.15,1.87-.18,2.77-.41-1-.71-1.06-2.21-2.37-2.72-.32-.17-.63-.37-.62-.81-.07-.24.65,0,.27-.5-.23-1.53,3.13.77,3.62,1.08a1.16,1.16,0,0,1,.34.53C1319.8,733.91,1322.63,732.78,1321.51,734.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-255",
    d: "M1321.74,734.22c-.79-1-2.55-.28-2.81-1.79.51,0,1.31.37,1.11-.65.75,0,1,.89,1.69,1A1.19,1.19,0,0,1,1321.74,734.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-256",
    d: "M1319.53,735.9c.59-.08,1.2.56,1.7,0a.87.87,0,0,1-.45.71,1.44,1.44,0,0,0-.74-.26C1319.93,736.15,1319.21,736.18,1319.53,735.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-164",
    d: "M1321.26,735.9a.55.55,0,0,1,.22-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-255",
    d: "M1321.51,734.93l.18-.46A.54.54,0,0,1,1321.51,734.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-164",
    d: "M1319.8,738.57h.23l-.23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-164",
    d: "M1319.55,739.29l.24-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-257",
    d: "M1341.35,721.75c.05.6-1.14.89-1.21.22S1341.29,721,1341.35,721.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-174",
    d: "M1319.07,722.34v-.48l.25.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-174",
    d: "M1319.55,722.59l-.24-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-174",
    d: "M1319.06,721.86l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-258",
    d: "M1319.06,724.54a10.48,10.48,0,0,1-4.86-3.4c.1-.43.67-.19,1-.24C1316.16,722.45,1318,723.12,1319.06,724.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-259",
    d: "M1336.64,721.66c1.39.14,0,1.16-.61.86C1335.7,722.13,1336.26,721.67,1336.64,721.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-260",
    d: "M1314.46,720.89l-.26.25c-.54-.35-1.29-.41-1.61-1-.82-1.11-2.79-1.81-2.24-3.56.54.17.72.67,1,1.29.18-.61-.27-1.14.17-1.53h0c.26.23.47.5.72.73a2.64,2.64,0,0,0,2.4,2.65A1.51,1.51,0,0,0,1314.46,720.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-260",
    d: "M1315.43,721.13l-.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-182",
    d: "M1311.79,716.54l-.24-.25h.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-261",
    d: "M1309.62,705.88c2.51-1.75,5-.59,3.71,2.6-.91,1.55-2.95,1.17-3.81,2.7-.4.67-.74,1.46-1.6,1.72h0a6.78,6.78,0,0,0,1.21,2.66c-.49.51-2-.36-2-.94a10.4,10.4,0,0,0-3.38-5.3c.34-.57.83-.51,1.35-.32,3,1.65,2.32-2.9,4.11-2.71a1.73,1.73,0,0,1,.46,1.08c-.12,1.19,1.66,1.25,2.29.59a.76.76,0,0,0-.65-1.33c-.65,0-1.34.48-1.92-.19C1309.2,706.14,1309.42,706,1309.62,705.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-262",
    d: "M1309.62,705.88c-.13.17-.21.71-.48.49-1.28.65-1,4.37-3.05,3.53-.73-.41-1.42-1.2-2.28-.62a.73.73,0,0,1-1.21-.73C1308.5,710.06,1306,706.82,1309.62,705.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-263",
    d: "M1307.93,715.08c2,.37,2.56,2.09,3.5,3.51,1.13.42,1.56,1.51,2.3,2.3a1.76,1.76,0,0,1-1.73-.53c-1.39-1.7-4.1-2.75-4.2-5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-264",
    d: "M1304.53,706.61c-.42.36-.84.7-1.45.49-2.11-3.82-.69-4.17,3-3.86,2.37.09-.39,3.49-1.56,3.37-.44-.85,1.14-1.42.44-2.16-.58-.5-1.81-.28-1.57.67C1303.4,705.91,1304.25,706,1304.53,706.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-265",
    d: "M1283,700.52l.42.07c1.24.66,1.34,2.06-.39,1.57,0,0-.1,0-.09.05-.44,1-2.31.56-2.88-.16C1277.34,699.92,1281.67,700.45,1283,700.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-266",
    d: "M1287.1,701.76c.13.07.36.13.39.23.39,1.38,1.65,1.92,2.61,2.74.68,1.06-1.85.08-2.26.47-.44-.29-1.41-.34-1.33-1s-.64-.58-.72-1C1285.43,702.37,1286.38,701.75,1287.1,701.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-267",
    d: "M1287.82,704.89c.56.08.64-.88,1.14-.31.67.7,2.9,1.13,2.2,2.43a6.13,6.13,0,0,1-3.14-1c-.25-.44.32-.71.62-.56-.68-.29-2.54.71-2.53-.57A1.67,1.67,0,0,1,1287.82,704.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-268",
    d: "M1287.1,701.76c0,.83,0,.83-1.22.77C1284.45,703.55,1282.44,699.11,1287.1,701.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-269",
    d: "M1288.07,701.49a5.21,5.21,0,0,1,2.71,2.2C1289.84,703.06,1288.56,702.53,1288.07,701.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-270",
    d: "M1294.15,708.79h.21c.56,1.64-1.83.63-2.42.08C1291.42,706.91,1293.46,708.06,1294.15,708.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-271",
    d: "M1284.88,700.82c-.77.46-.18.61.29.78-.41.14-.64.51-1,.39-.2-.5-.7-.83-.77-1.4A8.81,8.81,0,0,1,1284.88,700.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-272",
    d: "M1291.49,706.34a1.64,1.64,0,0,1,1.66,1c-.61.6-1.61-.18-1.76-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-273",
    d: "M1294.15,708.79l-1.54-.66a.48.48,0,0,1,.79-.32h0A10,10,0,0,1,1294.15,708.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-274",
    d: "M1293.4,707.81c-.51.13-1.57,0-1.22-.73C1292.63,707.25,1293.36,707.18,1293.4,707.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-272",
    d: "M1291,706.36c0-.16,0-.33,0-.49.68-.2.68-.2.55.47A.32.32,0,0,1,1291,706.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-265",
    d: "M1281.5,700.09h1a.64.64,0,0,1,.06.18C1282.36,700.65,1281.5,700.73,1281.5,700.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-107",
    d: "M1293.36,706.39a.64.64,0,0,1,.28.43A.51.51,0,0,1,1293.36,706.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-265",
    d: "M1282.54,700.26l.47.26c-.2.2-.57.24-.53-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-275",
    d: "M1285.89,700.05a.77.77,0,0,1,.46.28A.64.64,0,0,1,1285.89,700.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-273",
    d: "M1294.36,709a1,1,0,0,1,0-.24,2.32,2.32,0,0,1,.59,0A.33.33,0,0,1,1294.36,709Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-275",
    d: "M1286.36,700.34l.29.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-274",
    d: "M1293.63,708.07l-.23-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-276",
    d: "M1296.05,707.57c1.17-1.85,6.08.08,5,1.55-1.43-.32-2.68-1.31-4.25-.65A.76.76,0,0,1,1296.05,707.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-277",
    d: "M1300.9,709l.24-.49h.49a1,1,0,0,0,1,.49c.5.2,1.08.79.54,1.31-1.33.29-1.89,0-2.31-1.13A1.42,1.42,0,0,1,1300.9,709Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-188",
    d: "M1296.05,707.57l.25.25c-.28.17-.53.18-.48-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1294.36,709c1-.17,2.74-1.07,1.6.72.19,1,2.19,1.31,1.51,2.48-1.12,1.55-2.21-.44-2.77-1.33.57.43.24,1.71-.51,1.24-.28-.77-1.64-2.17-.3-2.61A3.71,3.71,0,0,1,1294.36,709Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-279",
    d: "M1296.33,709a1.8,1.8,0,0,0-1-.24c.52-.25.18-.84.47-1.18,1.18.81,2.69.17,2,2.19C1296.94,710.21,1296.67,709.56,1296.33,709Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-279",
    d: "M1295.11,708.84l-.29.13a.45.45,0,0,1,.13-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-280",
    d: "M1274.25,699.57c.41-.46,1.17.13,1.46-.43a16.29,16.29,0,0,1,2.41.47c.19.23.54,0,.73.23a.37.37,0,0,0,.5,0h.23c.3.22.69,0,1,.22,0,.59-3.48,1.64-4.21,1.23C1276.21,699.8,1273.7,701.08,1274.25,699.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1278.85,699.84c-.27,0-.6.19-.73-.23A.86.86,0,0,1,1278.85,699.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1280.54,700.06a1.26,1.26,0,0,1-1-.21l.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1279.35,699.85a.32.32,0,0,1-.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1276.19,701a3.75,3.75,0,0,0,2.23-.36c.68-.25,1.59,0,2.15-.6l.93,0c.44.33,1,.14,1.43.51-.22.49-.64.21-.93.18a13.47,13.47,0,0,0-2,0,.73.73,0,0,0-.66.43c-.72.81-1.66.23-2.48.4-.12.56-.87.68-1.35.74-.74,0-1.26.55-1.94.69-1.59,0-.65-1.52,0-2.14C1274.16,700.6,1275.76,700.48,1276.19,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-281",
    d: "M1257.53,706.85c.87-.5,1.6-1.48,2.64-1.56a1.09,1.09,0,0,0,1,.14c.3-.12-.06-.19,0-.3-.07-.73,2.3-.63,3-.93.53.39,1.22-.4,1.72.23.11.28,0,.45-.25.58-.79.53.49,1,.16,1.67-.66.88-1.28-.25-1.93,0a5.19,5.19,0,0,0-4.87,1.12c1,.63,1.93-.46,3-.25.74.12,1.62.94.48,1.44a5.11,5.11,0,0,0-3,1.77c-1.56.68-2,2.93-4.1,2.43-.19-.18-.47.21-.71.25a3.42,3.42,0,0,1,.72-1.94c.44,0,.49-.61,1-.5.55.32.71-.41,1-.38-.27.29-1.18.84-1.21-.09l-.7-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-282",
    d: "M1256.34,711c-.24.23-.76,1.17-1,.48l.73-1,.24.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-283",
    d: "M1254.15,718.72c.62-1-.39-2.21.51-3.19.19-.32.59-.71-.19-.82-.14-.35.44-1,.9-.6h0a2.63,2.63,0,0,1,1-.48l.11.13c.12.8-.79,1.51-.21,2.35-.34,2.1-.93,4.26,1,5.81.46,1.66,2.83,2.77,2.32,4.56-1.22.26-2.07-1.57-3-2.22a1.06,1.06,0,0,1-.26-1.2c.09-1.19-1.12-2-1.69-2.9h0C1254.73,719.59,1254.26,719.21,1254.15,718.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-284",
    d: "M1256.33,723.06c.67,1.52,2.94,2.41,3,4.06-1,.55-1.91-1.15-2.93-1.27-.61-.46-.15-1.09-.41-1.68-.23-.41-.19-1-.44-1.51C1256.07,722.56,1256.11,723,1256.33,723.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-285",
    d: "M1257.3,729.61h-.24a20.29,20.29,0,0,1-.74-2.64c-.2-.21,0-.54-.23-.75C1256.91,724.26,1259.22,729.89,1257.3,729.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-283",
    d: "M1254.64,720.16l0,.05S1254.65,720.17,1254.64,720.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-199",
    d: "M1254.18,719l.22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1256.1,713.14c1.38-.6,1.75-2.4,3.12-2.88a1.55,1.55,0,0,1,.21,1.47C1258.28,712.36,1257.46,715,1256.1,713.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1255.13,713.15c.06-.33.14,0,.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-283",
    d: "M1256.34,713.39h.48c0,.42-.22.4-.49.25C1256.33,713.55,1256.34,713.47,1256.34,713.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-286",
    d: "M1265.79,704.66c-.5-.41-1.21,0-1.7-.46,1.28,0,1.31-.89,1.93-1.7.91.09,2-.18,2.15,1.26C1266.84,705.64,1266.53,705.69,1265.79,704.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-287",
    d: "M1267.94,703.71c-.8-1.32-1.55-.07-1.92-1.21.77-.8,1.92-.6,2.9-.48C1269.72,702.65,1268.93,704.18,1267.94,703.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-288",
    d: "M1263.84,704.19c-.71.84-2,.3-2.66,1-.22.51-.55.55-1,.24l-.49,0c.33-.31.77-.51,1-.94C1261.76,704.56,1262.79,704.17,1263.84,704.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-289",
    d: "M1268.94,702.24a1.64,1.64,0,0,0,0-.22c.73-1,2.54-.3,1.84.86C1269.85,703.54,1269.31,703.12,1268.94,702.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-289",
    d: "M1268.67,700.81a.91.91,0,0,1,.76.49c0,.2-.16.34-.28.48C1268.68,701.62,1268.69,701.21,1268.67,700.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-289",
    d: "M1268.45,702H1267A1.25,1.25,0,0,1,1268.45,702Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-289",
    d: "M1267.47,701a1,1,0,0,1,.74-.23C1268.07,701.25,1267.74,701.05,1267.47,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-289",
    d: "M1266.73,701.28l0-.24h.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-290",
    d: "M1270.59,702.71c.28-1.14-1.65-.6-1.17-1.42h0c.5,0,1.13.13,1.51-.34,1.12-.05,1.64.92,2.1,1.74C1273,703.31,1270.49,703.42,1270.59,702.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-291",
    d: "M1268.22,699.83c-.33-.38-.85-.4-1.44-.74,2.13-1.16,1.22.32,2.62,0C1269.83,699.7,1268.66,700.21,1268.22,699.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-206",
    d: "M1270.82,700.78l-.67-.3C1269.24,697.75,1273.73,701.28,1270.82,700.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-205",
    d: "M1269.15,699.83l.24-.49c.87-.23,1,.38.52,1A1.77,1.77,0,0,0,1269.15,699.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1269.91,700.3l.23-.46a.64.64,0,0,1,0,.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-290",
    d: "M1270.83,701.08c-.23,0-.25-.25,0-.3s.22.21.06.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-288",
    d: "M1259.71,705.39a2.84,2.84,0,0,1-1.45,1A1.59,1.59,0,0,1,1259.71,705.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-292",
    d: "M1270.14,699.59a1,1,0,0,1-.75-.25c0-.24,0-.48,0-.71.51-.09,1.81-.32,1,.47h0c-.1.07-.07.22,0,.24h0q.25.12,0,.24h0C1270.3,699.69,1270.22,699.69,1270.14,699.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-208",
    d: "M1270.88,701a1.34,1.34,0,0,1,0-.2c.83-.2.62-.51.1-1.13l.13-.12a2.87,2.87,0,0,1,2.19,0,.38.38,0,0,1-.44.31l-.18-.12c.72.78,2.18.21,2.54,1.29-.5.41-1.38-.28-1.69.48a1.07,1.07,0,0,1-.74.72h0C1271.53,702.44,1272,701.48,1270.88,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1272.8,699.83c.46-.32,2.2-.58,1.43.33,1.23.28-1.1,1.27-1.42-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-208",
    d: "M1270.88,699.6h-.26c-.3-.32.3-.24.49-.24a1.77,1.77,0,0,0,0,.23C1271,699.68,1271,699.7,1270.88,699.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1270.38,699.34c0-.08-.09-.17,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1270.62,699.35v.24h-.24v-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-293",
    d: "M1263.11,747.27l0-.76c1-.58.83.72,1.37.89,1-.08.61,1.43,1.26,1.9,1.11,1-.38,3.06-1.28,1.51A4.2,4.2,0,0,1,1263.11,747.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-294",
    d: "M1263.12,748.23c.72,2.19,2.61,3.66,2.91,6.06-1.22-.42-1-2.52-2.55-1.7C1262.88,751.17,1263.19,749.69,1263.12,748.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-295",
    d: "M1265.78,753.57c-.92-1.27-2-2.44-2.18-4.11.49,0,.9.06,1,.67s1,1.32,1.18.53c.65-.18.56.54.89.75.65.64,1.94.38,2.21,1.38-.11.67-.14,1.8-1.08,1.05-.26-.18-.53-.39-.82,0-.48.48-.44-.18-.61-.31S1265.93,753.11,1265.78,753.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-136",
    d: "M1267,753.81a2.51,2.51,0,0,1-.35-.93c.69,0,1,.65,1.6,1,.23-2.11,1.23-.52,2.28-.57a.66.66,0,0,1,.1,1.24c-.38-.14-.9-.18-.54.38s0,.88.05,1.32A5.49,5.49,0,0,0,1267,753.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-296",
    d: "M1270.62,754.54l.22-.71c.31-.25.66.07.9.27.25,1,1.23,1.69,1.09,2.84A6.53,6.53,0,0,1,1270.62,754.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-297",
    d: "M1277.38,756.53c0,.14,0,.28,0,.42-1.39-.83-1.47-2.77-2.34-4.05-.3-.55-.4-1.17.49-1.37C1277.17,752.32,1277.2,754.89,1277.38,756.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-298",
    d: "M1275,753.57c-.16.69.56,1.2.41,1.93-.52.08-.38-.56-.73-.61-.24.15-.12.41-.15.62l-.15.1c-1.11-.16-.58-2-1.74-2.42a.68.68,0,0,1,.09-.81c.76-.56,1.19.62,1.9.37C1275.05,752.87,1274.87,753.29,1275,753.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-299",
    d: "M1275,753.57l-.47-.72c-2.48-.93,1.56-3.22,1.22-1-1.17.08.14,1.72,0,2.43C1275.37,754.13,1275.46,753.56,1275,753.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-300",
    d: "M1274.45,757l-.17,0c-.25-.4-1.53-2.66-.25-1.69h0a1.09,1.09,0,0,0,.24.24c.42.29.47.82.72,1.21h0C1274.94,757,1274.72,757.06,1274.45,757Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-218",
    d: "M1275,756.71a.67.67,0,0,1-.22-.5C1274.85,756.38,1274.92,756.54,1275,756.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-301",
    d: "M1274.52,755.74l-.25-.24h.23A1.79,1.79,0,0,1,1274.52,755.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-302",
    d: "M1272.79,756.47c-.68-1-1.64-1.94-1.68-3.17.16-.61,1.08-.32,1,.26a19.47,19.47,0,0,0,1.09,2.59C1273.38,756.42,1273.08,756.55,1272.79,756.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-301",
    d: "M1274,755.25c-.26-.08-.46,0-.51.26-.4-.65-1-1.71-.71-2.42C1274,753.66,1274.22,754,1274,755.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-303",
    d: "M1272.81,753.09c0,.25,0,.5,0,.75l-.7-.28h0c-.08-.09-.17-.16-.24-.25h0c-.27-.42-1-.76-.65-1.35,1.11-.75,1.12.49,1.6.88C1272.8,752.93,1272.8,753,1272.81,753.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-301",
    d: "M1273.52,755.51a.69.69,0,0,1,.25.47A.67.67,0,0,1,1273.52,755.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-304",
    d: "M1283.21,750.9c-.53.67-.79,1.58-1.73,1.88-.09.82-1.23,1.27-.77,2.31.12.28-.43.34-.4.66.13.71-1,.11-1.17-.14-4.46-6.53-7.25-7.64-.06-14,2.58-.57,6.21,7.37,4.29,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-305",
    d: "M1281.29,755.51a25.19,25.19,0,0,1,3.44-6.14c1.52.08.79,2.65-.32,3.24a6.67,6.67,0,0,0-2.61,2.73A.36.36,0,0,1,1281.29,755.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-222",
    d: "M1281.29,755.51c1-2.28,5-3.16,3.86-6,.27-.15.36.08.48.23h0c.59,3-.53,1.69-1.2,3.62a1,1,0,0,0-1,.49c-1.11.35-1.31,1.81-2,2.67A1.24,1.24,0,0,1,1281.29,755.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-306",
    d: "M1284.91,749.46a3.71,3.71,0,0,1-1.69,2.17c0-.24,0-.48,0-.73h0c.23-.89.84-1.64.48-2.66l-.21-.23,0-.25a.18.18,0,0,1,0-.31A1.76,1.76,0,0,1,1284.91,749.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-307",
    d: "M1280.07,756l.24-.24a2.24,2.24,0,0,1,1,1.55c-.39.11-.46-.29-.71-.34h0c-.16-.24-.14-.61-.49-.72A.17.17,0,0,1,1280.07,756Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-221",
    d: "M1280.34,759.4a2,2,0,0,1-.26,1.2c-.24-.42-.59-1,.2-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-308",
    d: "M1280.28,759.36a2.89,2.89,0,0,0-.25,1.19l-.19,0-.47-.5c.24-.49.06-2.15.89-1.69C1280.27,758.72,1280.28,759,1280.28,759.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-307",
    d: "M1276.66,751.41c1.36,1.5,3,3.19,3.14,5.32-.13.13-.06.34-.21.47-.2.73-.15,1.55-.72,2.16a.21.21,0,0,1-.18-.21c-.46-1.07-.36-2.55-1-3.64h0C1277,754.5,1275.85,752.39,1276.66,751.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-309",
    d: "M1276.66,751.41a13.59,13.59,0,0,0,1,4.1,1.65,1.65,0,0,0-.27,1,29,29,0,0,0-1.42-4.18c-.31-.73-.46-.94-1.21-1.21-.77-.7-1-2-1.83-2.7-.5-.75-1.4-1.28-1.27-2.36.51-.71,1-.36,1.36.11a44.05,44.05,0,0,1,3.66,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-147",
    d: "M1278.42,758.12a1.68,1.68,0,0,1,.21,1A1.14,1.14,0,0,1,1278.42,758.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-309",
    d: "M1277.65,755.51a.64.64,0,0,1,.21.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-223",
    d: "M1278.69,759.15l.18.21c-.07.1-.18.12-.24,0A.66.66,0,0,1,1278.69,759.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-147",
    d: "M1278.63,759.35l.22,0v.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-219",
    d: "M1279.82,756.47c-.25-.28-.53-.55-.24-1,.17.15.33.32.49.48v.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-219",
    d: "M1280.07,756.24c.39.09.48.37.48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-219",
    d: "M1279.59,757.2l.21-.47A.66.66,0,0,1,1279.59,757.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-310",
    d: "M1256.09,732.26a7.81,7.81,0,0,1,1.22,2.18c.44.67,1.6,1,1.12,2.13-.41.54-1-.07-1.55.32-1.68,1.21,0,4.59-3.21,1.43.26-.82.26-.82,1.1-.55-.69-.57-.43-1.48-.83-2.16.09-.74.38-1.4-.08-2.11-.64-1.25.38-2.82,1.75-2C1255.88,731.72,1255.93,732,1256.09,732.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-311",
    d: "M1253.67,738.32c.41.14.94,0,1.21.49-.05,1.88-3.43,2.39-2.66,4.37.49,1.58.69,1.68,2.33,1.39,1.28.15,2.57-1.82,3.59-.63,0,.22,0,.52-.35.44-2.56,2.11-7.48,2.29-7.25-2A12.54,12.54,0,0,1,1253.67,738.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-310",
    d: "M1253.66,736.71c-.12-.05-.05-.22.07-.13S1253.74,736.7,1253.66,736.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-312",
    d: "M1257.31,731.05a3.83,3.83,0,0,1,.44,2.61c-.76-1-2.78-3.08-1.36-4C1257.18,729.65,1256.47,730.91,1257.31,731.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-313",
    d: "M1258.27,736.63c-.11-.82-.76-1.41-1-2.19,1.8.21,2.5,2.39,1.69,3.88C1258,738,1257.82,737.64,1258.27,736.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-226",
    d: "M1256.09,732.26l-.24-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-226",
    d: "M1255.85,731.78l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-198",
    d: "M1256.1,726.22a1,1,0,0,1,.22.74A1,1,0,0,1,1256.1,726.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-314",
    d: "M1261.17,739.53c-1.22-.61.17-2-.73-2.84-.87-1-.06-2.23-.81-3.31a3.79,3.79,0,0,1-1-2.58c1.4-1.07,1.22,1.52,2.5,1.47.93.44.25,2,.66,2.81a6.83,6.83,0,0,1,.74,3.45c-.21,1.2,1.2,2.1.82,3.26-.4.48-.68.23-.9-.17C1261.94,741,1262.14,739.65,1261.17,739.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-315",
    d: "M1261.17,739.53c-.1-.32-.36-.65.1-1,.91,1,1,2.45,1.83,3.43.82.16,1.76,4.81,1.48,5.55a3.34,3.34,0,0,1-.12,1.14c-.62-.68-.33-1.83-1.32-2.14,0-1.11.36-2.2-.46-3.11C1261.87,742.23,1262.13,740.66,1261.17,739.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-316",
    d: "M1258.76,730.82c.51,1.36,2.18,2.79,1.47,4.33-.59,0-.54-.49-.54-.9-.64-.49-2.65-4.42-1-4A.84.84,0,0,1,1258.76,730.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-317",
    d: "M1259.69,734.25c.64.69.52,1.67,1,2.39v.46c-.92-.48-.93-1.53-1.39-2.3C1259.19,734.63,1259.51,734.41,1259.69,734.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-314",
    d: "M1258.53,730.56c-.33-.44-.26.54-.29.75l-.22,0a3.43,3.43,0,0,1-.27-1.92l-.2-.74c1.14,0,1.51.78,1.61,1.78C1259,730.66,1258.81,730.8,1258.53,730.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-318",
    d: "M1257.75,729.37a4.2,4.2,0,0,1,.27,1.92,1.58,1.58,0,0,1-.48-1.18,1.94,1.94,0,0,0-.23-.26,1.93,1.93,0,0,1,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-285",
    d: "M1257.31,729.85c.08.08.15.17.23.26C1257.46,730,1257.39,729.93,1257.31,729.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-319",
    d: "M1258.27,736.63a3.66,3.66,0,0,0,.73,1.69c.26.37-.07,1,.47,1.22.57,1.63-.63,1.33-1.44,1.52a1.46,1.46,0,0,1-1.58,0,2.59,2.59,0,0,0-3.1,1.47c-.21.72.15,1,.86,1.08,1.55.13,3-1.44,3.84-2.55.63,0,1.39-.5,1.76.44.58,1.1-.88,1.69-1.78,2.39-1.83.19-4.73,2.56-6.06.25-.35-.77-.76-1.65,0-2.49.46-.53.72-1.28,1.56-1.41.63-.25.6-1.29,1.38-1.43h0c.27.21.58.82,1,.48-1.48-1.78.59-2,1-3.58C1257.46,735.87,1257.78,736.39,1258.27,736.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-320",
    d: "M1257.79,741c.68-.45,1.86,0,1.71-1.22a12.46,12.46,0,0,1,1.17,3.4,1.53,1.53,0,0,1-2.16.73c-.27.12-.18.77-.72.49.42-.55,0-1.37.93-1.6a.89.89,0,0,0,.73-1.13c-.19-.84-1-.31-1.52-.42a.23.23,0,0,1-.14-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-313",
    d: "M1259.47,739.54c-.6-.24-.45-.76-.47-1.22C1259.29,738.68,1259.27,739.15,1259.47,739.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-231",
    d: "M1257.3,745.82l.49-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-231",
    d: "M1257.79,745.58l.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-321",
    d: "M1309.38,738.08c1.7.21,3.16,1.31,4.84,1.69-1.08,0-.43.37-.24,1-.4-.06-.89-.35-.89.45-.21.53-1.43.61-1,1.49-1.3.35-.43,1-1.41,1.41-.37.28-1.06.32-.71,1.09-.68.76-2.14,1.08-3.21,1.51,0-.42.36-.42.48-.63-1.67-1.13,2.54-3.56.81-4.75-.34-.18-.45-.73-.12-.92C1308.82,739.86,1308.9,738.86,1309.38,738.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1307,745.34l.24.72c-1.43-.52-1.88,3.36-2.39,4.38,0,.82-.8,1.42-.78,2.31,0,.29-.37.5-.7.58-.59-.77.92-1.93-.48-2.18,1.51-2.45,1.79-5.5,3.8-7.56C1308.12,742.68,1307.71,744.78,1307,745.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1305.07,751.94c.33,0,0,.34-.14.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-321",
    d: "M1310.6,744.88l0-.1C1310.68,744.68,1310.79,744.9,1310.6,744.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-323",
    d: "M1307,745.34a3.9,3.9,0,0,0,.43-1.76c-1.2,1-1.63,2.46-2.61,3.45a1,1,0,0,0-1,.49c-1.92.29,1.12-3.13,1.31-3.85.77-1.15,3-5.64,4.27-5.59.74,1.94-1.2,2-1.22,2.86.41.59.93-.05,1.5,0C1308.81,742.41,1308.2,744.27,1307,745.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1306,742.68c0,1.25-3.29,4.48-2.19,4.84a1,1,0,0,1-1,.48c0-.27.58-.72-.24-.72l-.13-.13C1302.34,746.44,1306.08,740,1306,742.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1301.14,751.15a11.28,11.28,0,0,1,1.46-2.9A4.64,4.64,0,0,1,1301.14,751.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1302.6,748.25l.24-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1301.63,748.73l.24-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1302.36,747.52l-.25.49-.1-.13a.33.33,0,0,1,.19-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1302.6,747.28l-.24.24h0q-.09-.33.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-322",
    d: "M1301.87,748.25V748a.14.14,0,0,1,.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-324",
    d: "M1302.11,748a4.47,4.47,0,0,1-.52,0c-.8-.55,3.67-8.19,4.51-6.75a.68.68,0,0,1-.36,1A53.14,53.14,0,0,0,1302.11,748Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-325",
    d: "M1298.22,753.05l0-.45c-.51-2.12,2-3.61,2.62-5.55.19-.4.5-.75,1.05-.53a.44.44,0,0,1,0,.52h0c-.2.29-.2.7-.5.94a1.13,1.13,0,0,1-.23.26h0c-.85,1.68-1.77,3.39-2.64,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-326",
    d: "M1300.9,748.73l.24-.49A.76.76,0,0,1,1300.9,748.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-326",
    d: "M1301.37,748l.23-.48.14.12a.61.61,0,0,0-.15.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-326",
    d: "M1301.14,748.24l.22-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-327",
    d: "M1301.87,746.54c-2.27,1.91-2.55,6.86-5.75,7.35a.69.69,0,0,0-.7.07c-.78.75-1.9.87-2.73,1.49-2.07.69-1.7-4-3-4.64-.8-.25-.63-.79-.47-1.35.91-1,2.29.28,1.87,1.35.51.41,1.1.65,1.16,1.42.17,2.59,7-4.33,8-5.09.34-.36.49-.92,1-1.11S1302.28,746.09,1301.87,746.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-328",
    d: "M1290.72,749.7l-1.45-.24L1289,749c-1.22-.74,0-2.45-1.29-3.28-1.72-1.5.75-3.35-.25-5.15,3.11-1.91,5.2-.68,2.38,2.39-1.36,1.1,0,1.39.74,2.21C1291.2,746.22,1292.23,749,1290.72,749.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-329",
    d: "M1287.58,749.46c-1.66-.52-1.08-2.49-1.89-3.6a1.94,1.94,0,0,1-.6-2.12c.42-2-2.64-.79-2.32-2.14,1.61-.41,5.53-1.31,4.6,1.66C1286.11,745.71,1290.47,745.94,1287.58,749.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-330",
    d: "M1288.06,748.73c.76-3.31-2.28-3.47-1.28-5.06.51-.64-.06-1.22,0-1.84-.35-1-5.64,1-4.81-.92,1.06-.23,2.14.38,3.2,0,1.82-.38,2.13-.25,3.79.56-3.42,3.88.26,3.38-.18,6.5A1.58,1.58,0,0,0,1289,749Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-331",
    d: "M1282.73,741.71c.77.68,2.31-.39,2.56.89.06.48.85,1,.38,1.51-1,.92.9,1.18.9,2.08a17.3,17.3,0,0,1,.52,3,1.87,1.87,0,0,0-.73.72c-.24-.5-.24-1.31-.88-1.5-.66-.67-.66-1.79-1.55-2.31a1.76,1.76,0,0,1-.07-2.39c-.06-1.52-2.92-1.08-2.18-2.16A1.72,1.72,0,0,1,1282.73,741.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-332",
    d: "M1283.94,745.58c.75,1,1.73,2.3,1.7,3.63-1.14-.17-3.11-3.82-2.77-5.08.18-1.49-2.17-.91-2.12-2.46.54-.53,1,.44,1.54.33.79-.06,3.24,1.58,1.9,2.13C1283.29,744.38,1283.69,745,1283.94,745.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-244",
    d: "M1284.91,748.49c.33.16.47.5.73.72v.49l-.48-.23h0C1285,749.15,1284.62,748.91,1284.91,748.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-245",
    d: "M1311.55,748.25c.32.39-.21.37,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-247",
    d: "M1313.73,747.28h-.23l.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-321",
    d: "M1314.26,740.91c0,.41-.51-.33-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-333",
    d: "M1312.28,720.17c1.4.65,2.18,2,3.36,3s.31,2.67.51,4c-.23.19-.43.12-.6-.1C1316.16,724.76,1310.75,721.37,1312.28,720.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-334",
    d: "M1315.68,726.94c.23.1.44.28.7.25v.25l-.21.21c-2.79-.19-5.5-2.26-4.2-5.37,1.83-.71,1.09,2.31,2.6,2.5C1315.41,725,1315.58,726.16,1315.68,726.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-248",
    d: "M1321.25,726.7l.48.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-248",
    d: "M1320.27,725.74l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-248",
    d: "M1320.52,726l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-248",
    d: "M1320.76,726.22l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-248",
    d: "M1321,726.46l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-248",
    d: "M1321.73,726.94l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-335",
    d: "M1319.53,735.9v.24c-1.75-.4-9.68-2.29-10.21-.39-.12.38-.57,1.33-1,1.11-.33-.9.29-1.56.59-2.3.86-1.48,2.67-.62,3.95-.44,1.12.37,2.7-.24,3.51.74A24,24,0,0,1,1319.53,735.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-336",
    d: "M1308.41,736.86h.24c-.4.63,0,.93.48,1.21-1.19.46-1.1,2.14-2.38,2.49-1.67-.22-.23-1.94.4-2.58C1307.65,737.71,1307.53,736.73,1308.41,736.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-335",
    d: "M1319.77,736.17l.27.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-337",
    d: "M1319.06,731.07l-.24,0c-.17-.15-.32-.32-.49-.46l-.23,0c-.31-.18-.67-.29-1-.48h0c-.15-.79,1.24.45,1.75-.1-.67-.91-1.9-1.32-2-2.66,1.26-.5,4.58,2.95,2.23,3.25h0l.25.47-.11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-338",
    d: "M1317.13,729.84v.25c-.21,0-.52,0-.48.31s-.22.4-.49.42c-.87.12-1.19-1-2-1.15-1.12-.86-2.53-3.82.09-2.38C1315.71,727.24,1315.9,729.25,1317.13,729.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-339",
    d: "M1316.88,729.62c-1.07,0-1.87-3.06-2.78-1.48a3.2,3.2,0,0,1-.85-1.19C1315.25,725.94,1315.82,728.46,1316.88,729.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-340",
    d: "M1315.67,727.92c-.64-.36-.81-1.33-1.72-.86-.18.08-.47-.07-.7-.11h0c-1.68-.4-1.39-2.64.06-.56,1.16.75,1-1.11,2.37,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-341",
    d: "M1321.73,732.75c-1,.47-1.11-.39-1.69-1h0c-.11-.3-.94-.39-.74-.71l0,0A3.94,3.94,0,0,1,1321.73,732.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-341",
    d: "M1321.94,733.23l-.21-.48A.63.63,0,0,1,1321.94,733.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-248",
    d: "M1316.17,727.65l.21-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-342",
    d: "M1313,727.21c.85,1.34,1.71,2.86,3.16,3.61,1.39.58,2.46,1.32,2.67,2.91-2.88.12-9.12.88-9.2-3.29-1-1.43-.37-3.62-2.21-4.64a3.16,3.16,0,0,1-1.64-2.43c-.26-.57-1.23-1.08-.81-1.79,1.92-.47,3.25,1.36,4.71,2.21,1.69,1.39.62,2.26,1.3,3.51C1311.77,727.5,1311.88,725.59,1313,727.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-343",
    d: "M1310.35,732c1.81,1.57,4.4,1.52,6.66,1.7,2-.4,2.53,1.57.83,1a2.77,2.77,0,0,0-1.48.17c-1.16-.11-2.23-.73-3.44-.74a3.93,3.93,0,0,1-2.3-.88c-.34-.36-.85,0-1.28-.15-1-.59-1.37-2-2.84-2.06-.48-.81-1.91-2.64-.6-3.22.8.21.57,1.27,1.28,1.56C1308,730.5,1309.42,731,1310.35,732Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-344",
    d: "M1317.84,734.69c.46.09,1.08-.33.44-.63-1-.32-2.11.17-3.09-.31a10.3,10.3,0,0,1,3.63,0c.54.41,1.44.42,1.56,1.46A13.13,13.13,0,0,1,1317.84,734.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-338",
    d: "M1317.61,730.33l.49.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-338",
    d: "M1317.12,730.09l.49.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-338",
    d: "M1318.33,730.59l.25.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-338",
    d: "M1318.58,730.82l.24.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-338",
    d: "M1319.29,731.07a1.5,1.5,0,0,1,0,.22l-.25-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-255",
    d: "M1319.79,731.54l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-345",
    d: "M1309.14,706.37c1,.26,3.66-1.35,3.68.41-.11.66.08,1.51-.6,1.87C1310.11,709.53,1308.47,708.91,1309.14,706.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-263",
    d: "M1303.08,709.76c-.15-.24-.31-.48-.47-.72,2.7.26,4.41,3.12,4.83,5.56l-.15.09C1305,714.07,1305,711,1303.08,709.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-263",
    d: "M1307.68,714.84l.25.24a.21.21,0,0,1-.28-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-263",
    d: "M1307.44,714.6l.24.24h0c-.21,0-.29,0-.25-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-346",
    d: "M1312.28,720.17v.72c-.5.27-.92-.25-1.41-.15a3,3,0,0,1-1.82-2s-.06,0-.06,0c-1,1.88-3.3-.87-3.35-2.2.47-1-1.36-1.62-.45-2.7,1.25-.63,5.55,5.53,7.09,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-347",
    d: "M1308.88,716.79c-1.58-.41-2.29-2.09-3.62-2.91-1.67.07-2.52-2.76-2.18-4.12,2.74.6,2.54,4,4.84,5.33A7.51,7.51,0,0,0,1308.88,716.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-333",
    d: "M1312.28,720.17a2.17,2.17,0,0,1-1.7-1.69A6.82,6.82,0,0,1,1312.28,720.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-333",
    d: "M1310.09,718l-.22-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-348",
    d: "M1304.53,706.61c-1.5.32-1.82-1.27-1.85-2.43,1.15-1.52,5.34-.2,1.85,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-349",
    d: "M1276.68,701.77l0-.24a1.31,1.31,0,0,1,1.06-.06c.82.46,1.83-.37,2.6.31a.64.64,0,0,1-.27.59c-.24.27,0,.64-.19.91-.58.58-1.22.14-1.84.11-1,0-3.7.3-2.54-1.36l1.21-.27a.21.21,0,0,1,.06.21A.25.25,0,0,0,1276.68,701.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-350",
    d: "M1286.13,703l1.45.93c-.83.79-5.13-.1-5.06-1.45l.22-.25A5,5,0,0,1,1286.13,703Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-351",
    d: "M1280.32,701.78c-.84-.12-1.92.26-2.63-.24-.58,0-1.16,0-1.74,0v-.2C1276.46,701.3,1281.72,701.05,1280.32,701.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-352",
    d: "M1286.13,703l-3.39-.77-.25-.44h0a17.89,17.89,0,0,1,2,.21c.43.25,1,.29,1.44.55C1286,702.68,1286,702.83,1286.13,703Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-353",
    d: "M1282.52,702.46l.37.06c.19,1.05-3.87.77-3-.5C1280.74,702.08,1281.63,702.35,1282.52,702.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-352",
    d: "M1282.49,701.77c-.74.42-.59-.53,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-267",
    d: "M1286.61,704.43h.21c-.27.46-1,.55-1,1.2C1283.23,706.2,1284.88,702.85,1286.61,704.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-354",
    d: "M1285.9,705.37c-.31-.78.5-.58.92-.93a1,1,0,0,1,1,.45c-.57.08-1.18-.1-1.7.28a.14.14,0,0,1,0,.22A.18.18,0,0,1,1285.9,705.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-355",
    d: "M1286.61,704.43a1.43,1.43,0,0,1-1-.22.89.89,0,0,1,1,0l0,0C1286.62,704.3,1286.62,704.37,1286.61,704.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-356",
    d: "M1291,706.36l.47,0a4,4,0,0,1,1,1.14c-.07.35-.49.27-.76.36a.46.46,0,0,1,.51.18.64.64,0,0,0,0,.69c-.44.83-1.62,0-2.07-.44C1289.87,707.26,1291.8,707.42,1291,706.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-357",
    d: "M1288.05,705.69l0,.19c1.24.82,1.25.84.34,1.78-.6.45-1.71-.16-1.9-.79A1,1,0,0,1,1288.05,705.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-358",
    d: "M1288.55,706.37c-.17-.15-.54-.11-.47-.49.61.13,4.77,1,2.89,1.68-.86.15-1.81.51-1.91-.93C1289.05,706.45,1288.7,706.52,1288.55,706.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-359",
    d: "M1288.05,705.69l-.5,0c-.48.2-1.49.26-1.43-.49a8.84,8.84,0,0,1,4,.53A7.6,7.6,0,0,1,1288.05,705.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-271",
    d: "M1285.16,702.24a.88.88,0,0,1-.71-.25A1.08,1.08,0,0,1,1285.16,702.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-360",
    d: "M1291.22,708.78l.71,0c.54.58,1.36.26,2,.72a2,2,0,0,0-.24.92l.25.25c.49,1.63-1.24,2.31-2.87,1.39-.18-.63-.89-1.1-.6-1.88a1.24,1.24,0,0,1,.89,0C1289.67,710.26,1289.65,709,1291.22,708.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-361",
    d: "M1293.39,709.28c-.54.39-2,.54-1.46-.47a1.56,1.56,0,0,1,1.46.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-362",
    d: "M1292.18,708.06c-.84-.06-.27-.54.25-.54l.72.31A.88.88,0,0,1,1292.18,708.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-356",
    d: "M1293.12,709a.57.57,0,0,1-.46-.19A.51.51,0,0,1,1293.12,709Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-356",
    d: "M1293.39,709.26l-.23-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-273",
    d: "M1294.1,709.27a.27.27,0,0,1-.21.26A.29.29,0,0,1,1294.1,709.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-273",
    d: "M1294.36,709a.3.3,0,0,1-.25.23A.26.26,0,0,1,1294.36,709Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-363",
    d: "M1297.73,709.77c-.22-.76,0-1.49-1-1.71,1.57-.3,3.14-.58,4.12,1,0,1.72-1.71.58-2.6,1.24A.53.53,0,0,1,1297.73,709.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-364",
    d: "M1299.69,709.76c.58.06.88-.36,1.21-.73,1.67,1.69,2.63.38,3.14,3.63a.81.81,0,0,1-1.18.08C1302,711.91,1298.56,711.42,1299.69,709.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-365",
    d: "M1294.59,712.19c.31-.85-.86-1.82,0-2.43.31,1.32,1.42,2,2.22,2.9a.72.72,0,0,1,.57.13c.31.16.61-.12.92,0,1.11,1.26,1.13,3.38.71,5-.27.62-.42,1.32-1.2,1.27-1.52-.22-1-2.1-1.07-3.18C1297,713.36,1293.27,713.72,1294.59,712.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-366",
    d: "M1298.7,714.37c-.31-.46-.24-1.1-.72-1.48a6.3,6.3,0,0,0-2.64-3.36c0-.75.64-.38,1-.51.56.08.85.66,1.4.75h0c1.31.78,1.35,2,1.35,3.31C1299.15,713.53,1299.19,714.15,1298.7,714.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-367",
    d: "M1295.34,709.53c1.7-.06,2.62,1.9,2.64,3.36h0a.73.73,0,0,1-1,0h0l-.24-.24c.09-.16.16-.32.24-.48l.09.07-.08-.07c.15-.22.46-.48,0-.66C1296.48,711.06,1294.88,710.34,1295.34,709.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-368",
    d: "M1291.21,711.94c1,.25,2.87.2,2.69-1.24a1.85,1.85,0,0,1,.45,1.23c-.84,1.76-.88,1.78-2.54,1.22C1291.5,712.8,1291,712.57,1291.21,711.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-369",
    d: "M1292,712.89c2,.61,1-.38,2.4-1l.24.26v.22c-.65.73,1.11,1.54-.09,2C1294,714.48,1291.48,713.67,1292,712.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-370",
    d: "M1274,700.1a9.75,9.75,0,0,1,3.11.15c-.08.53-.66.49-.94.78-.61-.07-1.35-.06-1.7-.7a1.45,1.45,0,0,1-.63-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-371",
    d: "M1275.73,702.5c-1.19.72,2,.2,1,1.74a.89.89,0,0,1-1,.45c-.27-.41-1.19-.22-1-1.07a.23.23,0,0,0,.13-.16c-.51.63-1.66.41-1.5-.54a2.16,2.16,0,0,1,2.08-.89l.47.45C1275.89,702.6,1275.82,702.6,1275.73,702.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-280",
    d: "M1274.49,700.33c.61,0,.93.56,1.46.7C1275.39,701.08,1274.49,701.09,1274.49,700.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-372",
    d: "M1273.53,702.74V703c-.55.36-1.1.66-1.46-.23A7.91,7.91,0,0,1,1273.53,702.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-290",
    d: "M1273.54,701.53c-.62,0-.25-.29.23-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-290",
    d: "M1272.8,702.25l.48-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-373",
    d: "M1259.24,711.69a1.25,1.25,0,0,1,0-1.43c.87-2.06,3.13-.87,3.81-2.25.06-.88.5-.81,1-.38a1.76,1.76,0,0,1-1.24,2.23c-.32.09-.7-.15-1,.17a4.64,4.64,0,0,1-1,1.11C1260.27,711.16,1260,712,1259.24,711.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-374",
    d: "M1265.53,706.37c-.83-.65.41-1.3,1-1,1.13.33,1.68-1.23,2.7-.88,2,2.2-2.28,2.83-3.31,4.26-1.46.58-1.65-1.55-.37-1.92C1265.71,706.66,1265.74,706.5,1265.53,706.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-375",
    d: "M1265.82,706.84c-.57.28-.17,1.07-.76,1.21-.39-.24-.91,0-1.21-.46-1-.07.13,1-1.2.95.15-.68-.58-.4-.77-.71.29-.83,1.45-.79,2-1.44l-.32-.68c.88.16,1.27,1.06,2.06.87C1265.76,706.57,1265.85,706.66,1265.82,706.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-376",
    d: "M1262.15,707.81a5.91,5.91,0,0,0-2,.46c-.73-1.1,1.65-1.22,1.68-2.16.74-.51,1.32.07,2,.28C1263.82,707.3,1262.49,707.07,1262.15,707.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-377",
    d: "M1258.52,707.61c.67-1.1,2-1.25,3.15-1.45.16,1-.85.93-1.27,1.4C1259.8,707.64,1259.05,708.14,1258.52,707.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-378",
    d: "M1258.52,707.61c.59.14,1.79-.56,2,.2l-.27.06c-.15.29-.5.5-.77.21-.64,0-1,.61-1.64.87C1257.58,708.19,1258.14,708,1258.52,707.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-379",
    d: "M1265.79,705.63l-.5.51c-.24-.27-.9,0-.76-.8s.89-.66,1.46-.66C1266,705,1266.23,705.39,1265.79,705.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-282",
    d: "M1256.33,711c.72-.18,1.44-1.68,2.12-1.09.18.25-.11.43-.29.55-.5.19-1.51,1.38-1.82.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-380",
    d: "M1260.21,705.4a2.52,2.52,0,0,0,1-.24,1.83,1.83,0,0,1,.87.12,5,5,0,0,1-2.22.79C1259.81,705.73,1260.13,705.63,1260.21,705.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-381",
    d: "M1260.45,707.32c.24-.57,1-.64,1.22-1.16a1.38,1.38,0,0,1,.67,0c.16.42-.39.4-.44.69C1261.58,707.19,1260.88,707.67,1260.45,707.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-382",
    d: "M1265.82,706.84c-.13-.14-.28-.26-.29-.47C1266.17,705.8,1266.8,707.39,1265.82,706.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-383",
    d: "M1259.43,708.08c.29,0,.88-.34.77.19l-1.33.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-384",
    d: "M1279.14,741.93c-1.29,2-3.55,3.61-4.18,5.87-1.15-.16-.67-2-1.4-2.71-1-1.19-1.48-2.93-3.11-3.47a16.11,16.11,0,0,1-4.35-4.81c-2.5-2.61-3.52-6-5.84-8.68a2.06,2.06,0,0,1-.76-1.68c-.64-2-4-4-2.47-6.22,2-2.72,2.9,1.92,4,3.15a28.76,28.76,0,0,0,6.16,11.57,1.37,1.37,0,0,1,.48.66c.18.81,1.08,1.09,1.37,1.83.1.66.71.71,1.16.95,2.58.63,5.3,1.77,8,2.7C1278.55,741.24,1279.13,741.26,1279.14,741.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-385",
    d: "M1257.55,720.17a4.83,4.83,0,0,0-.74,1.94c-.6-.79-2.33-2.17-1.59-3.16s-.32-2,.63-2.9c-.48-1.33,2.5-3.38,2.22-1.28C1257.09,717.16,1259.52,718.06,1257.55,720.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-386",
    d: "M1257.55,720.17c-.4-.13-.26-.35-.07-.53,1.44-1.67-1.53-3.52.52-5.44a3.25,3.25,0,0,0-2.15,1.85,2,2,0,0,1,1-2.67c.62.12,1-.41,1.52-.45s.25.61.66.73c.53.49,0,1.06.11,1.58a6.16,6.16,0,0,0,.24,3.84c.1,1.1,1.39,2.17.63,3.25-.91-.66-1.13-3.89-2.43-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-387",
    d: "M1259.5,726.45c1.39,1.84,3.2,3.41,3.6,5.81-1.67,0-1.16-2-2.22-2.71a2.1,2.1,0,0,1-.6-.75c-.66-.76-1.3-1.12-1-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-388",
    d: "M1259,730.33a9.45,9.45,0,0,1-2.42-4.59c.5-.36.92-.65,1.21.26.16.49.86.54,1.2.94-.49.89.69,1.64.85,2.46C1259.86,729.91,1259.79,731.16,1259,730.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-389",
    d: "M1258.75,726.94h.23a7.18,7.18,0,0,1,2,2.18h0c.55,1,.55,1-.2,1.29C1260.17,730,1257.84,727.43,1258.75,726.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-198",
    d: "M1256.57,725.74V726c-.07-.08-.14-.17-.22-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-390",
    d: "M1258.55,713.64h-.27c.64-.48,0-.51-.46-.47-.28-.25-.28-.25.23-.51,3.56-2.29,1.87,4.39,1.91,6.07.45,3,4,5.84,2.16,9-.91-1.71-1.32-3.63-2.14-5.37h0a21.69,21.69,0,0,1-1.2-7C1258.74,714.74,1259.71,714,1258.55,713.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-391",
    d: "M1259.73,712.68c-.56-.34-1.12.06-1.68,0,.22-.55.5-1,1.19-1l1.45-1C1262.2,710.68,1260.52,713.18,1259.73,712.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-392",
    d: "M1265.79,705.63c.15-.3-.18-.7.2-1,.33.09.65.35,1,.06,0-.46-.59-.2-.66-.6.45-.31,1.24.4,1.61-.43h.27c.34.26.19.68,0,1C1267.51,705.29,1267,706.44,1265.79,705.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-393",
    d: "M1268.94,702.24c.54.2,1,.82,1.65.47.74.68.12,1.28-.41,1.7a1.79,1.79,0,0,1-2-.71A2.61,2.61,0,0,0,1268.94,702.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-201",
    d: "M1269.42,701.29l.06.44-.31,0C1269.07,701.51,1269.08,701.31,1269.42,701.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-394",
    d: "M1270.12,704.21c-.36-1.1.73-.47.56-1.45,1.21.27,1.16,1.52.94,2.52C1270.91,706.46,1268.16,704.69,1270.12,704.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-395",
    d: "M1271.12,703.19a.78.78,0,0,0,0-.21c.19-.7.64-.25,1-.22.45.33,1,.19,1.46.23h0q.26.12,0,.24h0C1272.69,704.46,1271.89,704.52,1271.12,703.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1270.14,699.59h.24l-.24.23A1.92,1.92,0,0,1,1270.14,699.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-126",
    d: "M1270.88,699.6h.22c0,.08,0,.16,0,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1272.81,699.83c-.54,0-.42-.35,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-280",
    d: "M1274,700.1a1.09,1.09,0,0,0,0,.18C1273.82,700.31,1273.77,700.11,1274,700.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-396",
    d: "M1270.41,753.58c-.81.43-1.46-.72-2.07-1-1.47.25-1.95-.87-2.55-1.89l0-.48c-.62-.79-.24-1.91-1-2.66h0a13.35,13.35,0,0,1-.94-4.55c1.47-.65-.1-1.61,1-2.32,1.41.24,1.2,1.93,1.89,2.84a2.11,2.11,0,0,1-.13,2.67c-.3.61.52,1.12.3,1.77.08.4-.93.63-.17,1.14.06,0,.06.15.07.23,1.47-.77,1.2,1,2,1.32C1269.24,751.52,1270.85,752.51,1270.41,753.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-295",
    d: "M1264.57,746.31a2.2,2.2,0,0,1,.24,1.21h-.23a23.31,23.31,0,0,1-1.23-5.07c.7,0,.5.6.59.95C1264.23,744.36,1264.35,745.37,1264.57,746.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-295",
    d: "M1264.81,747.52c1.1.05.62,1.44.73,2.18A3,3,0,0,1,1264.81,747.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-295",
    d: "M1265.54,749.7a.69.69,0,0,1,.22.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-296",
    d: "M1270.41,753.58a5.39,5.39,0,0,0-1-1.46h0c-.23-.62-1.17-1.5-.22-2,.87.15.78,1.28,1.26,1.87.17.62,1,1.17.38,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-397",
    d: "M1270.88,753.8c-.08-.63-.63-1.06-.75-1.67.1-.61,1-.87,1.09-.12-.09.39.48.73.13,1.07v1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-299",
    d: "M1275.73,751.87a.73.73,0,0,1,.23.48A.69.69,0,0,1,1275.73,751.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-398",
    d: "M1274,751.64c1,2.4.12,1.73-1.37.64C1270.93,749.52,1273.57,748.69,1274,751.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-399",
    d: "M1271.11,752.13l-.48-.5c-1.56-.87.26-1.69,1.32-1.33.59.55.53,1.37.85,2v.52c-.73.28-.66-1.1-1.46-.72C1271.26,752.29,1271.18,752.28,1271.11,752.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-301",
    d: "M1274.26,755.5l-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-400",
    d: "M1273.56,751.12c-.09-.41-.52-.61-.75-.94h0a1,1,0,0,1-.24-.26h0a3.15,3.15,0,0,1-1.43-3.23c.63-.73,1.7,1.39,2,1.87.51.88,1.95,2.16.84,3.09C1273.87,751.46,1273.66,751.33,1273.56,751.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-401",
    d: "M1274,750.66c.21-.7-1.84-2.15-.75-2.39a5.59,5.59,0,0,1,1.44,2.64c.09.34-.1.67-.46.47a.69.69,0,0,1,0-.2C1274.12,751,1274.16,750.81,1274,750.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-298",
    d: "M1274.49,752.83l-.22-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-217",
    d: "M1271.35,753.08v-.48l.12-.1a4,4,0,0,1,.37.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-217",
    d: "M1271.84,753.32l.24.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-217",
    d: "M1271.11,752.13h.22l0,.23a.14.14,0,0,1,0,.24C1271.27,752.46,1271.2,752.28,1271.11,752.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-399",
    d: "M1271.36,752.6a1.92,1.92,0,0,1,0-.24l.2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-402",
    d: "M1279.14,741.93c-1.82-.88-3.9-1.11-5.65-2.13,1.8-.71,4.61,1.11,6.65,1.31.33.09.6.22.65.6a5.2,5.2,0,0,0,2,1.25c1.37.55-.39,1.55,1.12,3.83a.49.49,0,0,1-.32.14C1281.92,745.28,1282.17,742.06,1279.14,741.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-403",
    d: "M1281,742.69c2.09.26,1.27,3,2.67,4.11a5.31,5.31,0,0,1,1.46,2.66h-.24A34.1,34.1,0,0,1,1281,742.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-404",
    d: "M1273.74,744.62a8.1,8.1,0,0,1,1.24,4.12l-.2,0c-.44-.76-1.21-1.29-1.53-2.14.3-.85-1.26-2.21.06-2.5C1273.37,744.31,1273.64,744.41,1273.74,744.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-219",
    d: "M1283.71,748.49c.82.52-.09,1.81-.5,2.41C1283.15,750.05,1283.67,749.32,1283.71,748.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-307",
    d: "M1276.67,751.4a.71.71,0,0,1-.27-.48A.69.69,0,0,1,1276.67,751.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-219",
    d: "M1283.24,747.25l.23.24,0,.27A.78.78,0,0,1,1283.24,747.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-219",
    d: "M1283.48,748l.21.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-307",
    d: "M1279.82,755.75l-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-307",
    d: "M1280.07,756l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-405",
    d: "M1273.54,746.55c.24.83,1.28,1.16,1.24,2.17-1.28-.08-1.5-2.9-2.94-2.66C1268.67,743.72,1272.47,741.7,1273.54,746.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-406",
    d: "M1273.28,748.27l-.24.45c-.57-.55-.83-2-1.69-1.92-1-.34-1.07-.61-.4-1.7a.36.36,0,0,1,.4,0h0c.19.31.21.7.49,1h0C1272,747,1272.83,747.51,1273.28,748.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-299",
    d: "M1274.72,750.91a1.08,1.08,0,0,1-.2-.74A1,1,0,0,1,1274.72,750.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-311",
    d: "M1255.85,739.29a.29.29,0,0,1-.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-311",
    d: "M1255.12,739.05l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-311",
    d: "M1255.37,739.29l-.25-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-407",
    d: "M1264.33,745.1c-.54-1-.5-2.2-1.23-3.14-.65-2.29-1.12-4.65-1.7-7,.1-3,5,4.85,2,3.9.46,1.17,1.7,3,.73,4.08C1264.06,743.66,1264.41,744.35,1264.33,745.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-408",
    d: "M1259,730.33c.47.15.48-.17.49-.48,1-.39,1.59,1.32,2,2.06,0,.57-.49.82-.7,1.41-.71-.8-.87-2.31-2-2.5-.08-.09-.16-.17-.23-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-409",
    d: "M1262.37,734.71c-.33,0-.76-.31-1,.23-.45-.61-.46-2.16.34-2.27.5.55,1.18,1,.78,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-410",
    d: "M1261.18,732.51a1.93,1.93,0,0,1,0-.24.23.23,0,0,1,.27.13l-.08.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-410",
    d: "M1261.63,732.83l-.23-.07a1.49,1.49,0,0,0,0-.21l0,0C1261.68,732.5,1261.76,732.6,1261.63,732.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-229",
    d: "M1260.68,736.64l-.2-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-411",
    d: "M1258,741.23c-.08.83,0,2.17-1.18,2.11-1.14.33-3.13,1.78-4,.29-1.07-1.69,1.34-2.67,2.36-3.56.86-.19,1.65.85,2.56.91A2.83,2.83,0,0,0,1258,741.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-319",
    d: "M1258,741.22l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-412",
    d: "M1306.7,740.26c1.08-.48,1.07-2.33,2.43-2.18-.81,1.13-1.29,2.49-2.42,3.39a2.55,2.55,0,0,1-.72,1.21l-.25-.49.24-1C1305.75,740.55,1306.5,740.61,1306.7,740.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-326",
    d: "M1306.7,740.26c0,.5-.42.69-.72,1-2,1.35-2.64,4-4.11,5.82a4,4,0,0,1,.38-2.53c1.28-1.13,2-4.74,4-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-326",
    d: "M1301.6,747.5l.27-.46v.46C1301.79,747.62,1301.69,747.6,1301.6,747.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-238",
    d: "M1301.63,747.52l.23,0c-.07.09-.15.17-.23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-413",
    d: "M1290.72,749.7a4.44,4.44,0,0,0,0-3.15c1.43-.84,1.5,1.51,2,2.32-.2,6.41,6.18-3.77,8.45-2.32-1.7,3-5,4.3-7.28,6.72-.73.61-2.45.21-2.15-.93.22-.86-.83-.93-1-1.67A.92.92,0,0,0,1290.72,749.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-413",
    d: "M1302.6,744.62a2.35,2.35,0,0,1-1.21,1.69l-.14-.1c-.13-1.27.11-1.6,1.22-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-328",
    d: "M1290.73,750.67a.92.92,0,0,1,.48.72c-.65.17-.49-.48-.73-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-328",
    d: "M1291.31,752.26l-.1.16c-.16-.08-.19-.15-.06-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-328",
    d: "M1290.37,750.51l.06,0a.41.41,0,0,1,0,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-413",
    d: "M1301.39,746.31l-.24.24h0c-.05-.21,0-.29.24-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-414",
    d: "M1292.42,748.73c-1-.51-.39-2.12-1.69-2.18a2.07,2.07,0,0,0-1.76-1.73c-2-1.08,3-3.68,2.51-4.79-2-1.42-5.47,2.83-11.14-.41-1.1-2.83,1.84-2.4,2.6-4.41a2.61,2.61,0,0,1,2.11-.91c1.92,2.19-.38,2.68-1.87,3.51,1.47,3,5.54,1.54,7.71.08,1.51-.42,1.4-5.41,2.52-4l0,0c-.12-1.16,1.09-1.65,1.41-2.62.88-2.26,1.82-4.54,2.85-6.75.22-2-1.7-5.27,2.31-4.19.7,1.32-1.88,1.11-1.1,2.56.34.63,0,1.33-.06,2,0,1.68-.18,3.64-1.23,5-.25.23-.51.32-.09.72s0,1,0,1.49c-1.32,1.15-1.83,2.9-3.12,4.08-.35.33-.46.77.17,1,1.59.71-1.92,4.06-2.62,4.76C1288.83,744.23,1295.11,746.4,1292.42,748.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-415",
    d: "M1280.56,739.53c3.31,1,6.91,1.64,10.12-.4,1.39-.93,1.89.82,1,1.75-.47.38-1,.71-1.46,1.07a2.53,2.53,0,0,1,.78-1.5c-1.76-1.11-3.7.93-5.62.77-1.61,0-5.67,0-5.69-2.09C1280.25,738.72,1280.32,739.29,1280.56,739.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-413",
    d: "M1290.48,745.82a1,1,0,0,1,.25.73A1,1,0,0,1,1290.48,745.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-413",
    d: "M1290.24,745.58l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-416",
    d: "M1279.83,739.05c1,1.93,3.67,1.82,5.57,2.18-1.18.55-2.28.1-3.4-.24-.85.78-1.61.06-2.4-.15-1.07-1.1-3-.82-3.84-2.08.71-2.5-1.34-2.41-.84-3.66,1.42-.73,2.39,1.72,4.25.42,1.71-.54,3.06.66,1.36,1.9C1280.08,737.9,1279.66,738.33,1279.83,739.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-329",
    d: "M1279.59,740.49c.82.11,1.53.69,2.41.5.08.41.49.48.73.72h-1.21c-.87-.53-3.35-.3-3.35-1.49C1278.73,739.83,1279.13,740.33,1279.59,740.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-243",
    d: "M1285.64,748.49a5.45,5.45,0,0,1-1.45-2.66A3.78,3.78,0,0,1,1285.64,748.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-243",
    d: "M1283.94,745.58c-.31-.35-.62-.71-.24-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-243",
    d: "M1283.7,744.37l.49-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-417",
    d: "M1278.13,740.26c1,.82,2.36.73,3.39,1.45-3.6-.36-7.13-2-10.62-2.7-.73-.7.49-1.16,1.1-1C1273.85,739.13,1276.63,738.73,1278.13,740.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-244",
    d: "M1284.91,748.49a3.25,3.25,0,0,1-1.22-1.69h.26A3.48,3.48,0,0,1,1284.91,748.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-418",
    d: "M1315.43,726.7c-1.85-3.6-1.3,0-2.19-1.41-.22-.81,0-1.69-.46-2.47.53-1.92,1.47.79,2.18,1.24a2.3,2.3,0,0,1,.72,2.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-419",
    d: "M1313.26,722.1a1,1,0,0,1-.48.72c-.62-.86-2.11-1-1.71-2.41.61-.37.79.37,1.21.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-420",
    d: "M1311.07,720.41c.4.64.81,1.28,1.22,1.92-1.44.3-2.42-.52-3.38-1.37s-2.24-1.17-3.25-2c-1.18-1.09-8.58-5.36-4.27-6,1.41,0,1.5,1.45,2.39,2.13.91.21,2,0,2.2,1.41.24,1,2.79,4.14,2.66,1.45h0C1309.65,718.54,1310,719.84,1311.07,720.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-421",
    d: "M1309.14,720.64a10.19,10.19,0,0,0,2.9,1.7c.59,1-.26,2.23.47,3.16-1.84.39-1.24-2.07-2.14-3-.65-.75-1.88-.67-2.35-1.67C1308.26,720.11,1308.7,720.36,1309.14,720.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-333",
    d: "M1315.43,726.7l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-422",
    d: "M1309.38,732.77a2,2,0,0,1,2.09.43c1.13.86,3,.2,3.9,1.47-2,.22-4.12-.59-6.07-.47a.53.53,0,0,1,.07-.61C1309.6,733.33,1309.17,733,1309.38,732.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-423",
    d: "M1308.41,736.86c-.49.38-.39,1.14-1,1.45-.58-.69.25-1.69.3-2.47.38-.42.52-1.39,1.29-1.24l.14.11C1308.91,735.43,1308.66,736.15,1308.41,736.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-423",
    d: "M1309.38,734.14l.22.08-.43.49C1308.84,734.55,1309,733.94,1309.38,734.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-424",
    d: "M1306.71,739.26c-.27.43-.49.84-1,1h0c-2.79,2.93-5.14,6.37-8.8,8.41-.76.16-1.67.72-2.18-.21s.52-1.32,1-1.8c.72-.69,1.15-1.68,2-2-1.74,1.13-3.15,2-4.83.21-2.09-1.77-2.09-1.77-.26-3.87,2-2.72,4.56-5.11,5.75-8.37,1.59-1.76,2,2,3.91,2.12,1.26.66,2.08,2,3.42,2.56S1307.06,737.87,1306.71,739.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-425",
    d: "M1306.71,739.26a1.4,1.4,0,0,0-1.23-1.55c-1.43-.2-2.16-1.92-3.37-2.52-1.88.12-2.25-3.75-3.39-2.43-1.1-.41.25-3.61,1-2.13.66,2.26,2.78,2.57,4.38,3.76a5.21,5.21,0,0,0,2.26,1.85c.83.19,1,1.29,1.08,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-426",
    d: "M1305.75,740.27l.46-.26a1.49,1.49,0,0,1,0,.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-card-253",
    points: "1319.07 730.57 1319.02 730.53 1319.06 730.58 1319.07 730.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-427",
    d: "M1313,727.21c-1.71-.72-.71.46-1.28,1.31-.66.1-2.55-1.9-1.5-2.39.41-.23.06-.74.12-1.11C1310.65,724.36,1313.14,726.74,1313,727.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-339",
    d: "M1313,727c-.66-.69-2-.65-2.18-1.72-.55-.91.47-1.06,1-.48a1,1,0,0,0,.48.73c.1.64.72.92,1,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-254",
    d: "M1316.15,730.82a1.88,1.88,0,0,1-1.69-1.45A4.47,4.47,0,0,1,1316.15,730.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-428",
    d: "M1306.47,723.55c-.66.17.4,1.64,1,1.45.43.91,3.71,3,1.49,3.35a10.67,10.67,0,0,1,1.71,2.09c-.14.42-.77-.23-.82.36-1,.15-1.41-.67-2-1.23,0-1-1.46-1.3-1.09-2.37.53-1.13-1.82-.93-1.89-2.06.59-1.62-.6-2.49-1.46-3.5a.59.59,0,0,1,.08-.34c.68-.29,1.27-.33,1.51.56h0c.45.59,1.14,1,1.45,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-429",
    d: "M1305,721.86c-.4-.42-1-.3-1.44-.49-.86.31-3.29-3.44-1.95-3.71,1.22.12,1.63,1.68,2.59,2.35.69,1.3,3.77,1,3.43,2.6C1306.74,722.55,1305.9,721.54,1305,721.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-430",
    d: "M1308.16,729.37c.86.78,2,1.39,2.19,2.65-1.37-.33-2-2-3.4-2.41-.69-.35-.78-1.06-1-1.68C1306.41,727.29,1307.93,728.87,1308.16,729.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-254",
    d: "M1318.58,733.71c-1.95,0-4,.25-5.82-.46A29.57,29.57,0,0,1,1318.58,733.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-431",
    d: "M1310.58,725h-.25c-.61-.46-1-1.12-1.67-1.48h0l-.24-.23h0c-.1-.06-.12-.26-.06-.3C1309.46,721.8,1311.13,723.74,1310.58,725Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-254",
    d: "M1315.43,731.3c-.33,0-.7.07-1-.35a1,1,0,0,1,1,.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-429",
    d: "M1308.42,723.06v.25a2,2,0,0,1-.75-.7C1308.1,722.3,1308.46,722.52,1308.42,723.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-429",
    d: "M1308.66,723.54a1,1,0,0,1,.72.5A.87.87,0,0,1,1308.66,723.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-429",
    d: "M1308.41,723.31l.24.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-429",
    d: "M1305.49,722.34l-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-429",
    d: "M1305.26,722.1l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-card-254",
    points: "1315.43 731.3 1315.47 731.34 1315.43 731.3 1315.43 731.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-432",
    d: "M1309.38,734.14a5.77,5.77,0,0,1-4.22-2.89c0-.51.07-1.08-.71-1.11a1.48,1.48,0,0,1-.82-1.23c-.1-1.16.74-2,1.52-.8.42,1,1.24,1.67,1.54,2.71,1.38.26,1.47,1.82,2.64,2.3C1309.84,733.24,1309.57,733.81,1309.38,734.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-433",
    d: "M1305.74,729.12c-.16.41-.34.23-.47,0-.86-1.69-3.24-2.1-1.9-4.54.6-.36.74.11.9.51.33.84.23-.31.42-.09.43-.21.56.31.82.5C1306.4,726.62,1305.33,727.89,1305.74,729.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-434",
    d: "M1307,729.61c.56-.43,3,1.29,2.41,1.95A8.72,8.72,0,0,1,1307,729.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-435",
    d: "M1307.94,732a5.6,5.6,0,0,1-1.25-1.18c.9-.36,1.85.92,2.57,1.38.29.28-.18.26-.36.31A.65.65,0,0,1,1307.94,732Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-436",
    d: "M1307.94,732c.43.22,3.2,1.57,1.66,1.68C1309.23,733,1307.49,733,1307.94,732Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-432",
    d: "M1305.73,728.89c-.39-.62-.19-1.29-.21-1.95.56-.07.57.7.23,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-437",
    d: "M1305.75,727.91l-.06-.92.19-.09c.49.28.41.63.13,1A.57.57,0,0,1,1305.75,727.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-438",
    d: "M1306,716.54c-.6-.46-1.15-1-2-.77-1.18-.12-.32-2.56-2.53-2.84-.94.14-1.86-.93-2.49-1.54-.57-.82.44-1.55,1-.67,1.46.44,2.56,1.66,4.11,1.94.41.4.82.8,1.22,1.22C1305.22,714.88,1306.64,715.61,1306,716.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-card-420",
    points: "1308.64 717.99 1308.61 717.94 1308.65 717.98 1308.64 717.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-346",
    d: "M1305.25,713.87l-.23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-346",
    d: "M1305,713.63l-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-346",
    d: "M1304.77,713.38l-.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-346",
    d: "M1304.53,713.14l-.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-364",
    d: "M1304.28,712.89l-.23-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-439",
    d: "M1286.6,704.19c-2.8.46-5.5-.76-8.31-.16-.76-.14-1-.88-.16-1,.57.09,1.14.43,1.71,0a.63.63,0,0,1,.6-.14A12.92,12.92,0,0,1,1286.6,704.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-440",
    d: "M1278.13,703l-.47.5c.39.65-.86,1.19-1.22.68.36-.75-.21-.93-.69-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-265",
    d: "M1280.3,703l-.46,0c-.18-.19-.67,0-.59-.48,0-.27.15-.63.6-.49C1279.74,702.43,1280.69,702.75,1280.3,703Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-351",
    d: "M1278.62,701.77c-.25.22-1,.4-1.07.06A.93.93,0,0,1,1278.62,701.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1276.68,701.77c.32.41-.21.39,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1275.73,702.5l.22,0C1276,702.71,1275.81,702.62,1275.73,702.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-209",
    d: "M1277.87,701.76h-.22a.93.93,0,0,1,0-.23C1277.87,701.51,1278.19,701.63,1277.87,701.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-349",
    d: "M1280.3,703c0-.08,0-.15,0-.23.86-.1,1.75.25,2.58-.21.35.06.45.34.06.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-349",
    d: "M1277.87,701.76a1.62,1.62,0,0,0,0-.22,1,1,0,0,1,.75.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-441",
    d: "M1286.61,705.62l.94,0c-1,.09-.36,2.23-1.79,1.18-1-1.3-2.63.09-3.57-1,.23-1,1.45-.69,2.19-.83a2.2,2.2,0,0,0,1.76.38l0,0C1286.25,705.55,1286.48,705.49,1286.61,705.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-355",
    d: "M1284.16,704a2.24,2.24,0,0,1,1.27.25c-.65.88-1.72.77-2.66.92-1.07-.45-2.27-.16-3.36-.53C1279,702.79,1283.31,704.42,1284.16,704Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-442",
    d: "M1282.71,704.71l2.2,0-.24.46c-.79.2-1.6.33-2.4.52-1.12,1.21-3.83-.58-1.32-.88A5,5,0,0,0,1282.71,704.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-443",
    d: "M1288.55,706.37c.89-.1.76,1,1.42.93a1.24,1.24,0,0,1,1,.26c-.74,1.06-2.43,1.82-2.66,0-.08-.32-.42-.69.3-.77C1288.92,706.77,1288.6,706.52,1288.55,706.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-444",
    d: "M1289.26,708.3c.55.07,2-.39,2,.48C1290.1,709.53,1289.51,709.39,1289.26,708.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-445",
    d: "M1292,712.89c.41,1,1.57.23,2.13,1,.45.47.68-.1.28-.47,1.29-.49,2.14,1.07.58,1.37-2.08,1.39-3.52-1.7-5-2.79-1.23-1.11-2.92-1.34-4.21-2.32-.63-1.52-.42-2.75,1.6-2.53.13,1.42,1.12,2.17,2.21,2.84S1291.09,711.93,1292,712.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-368",
    d: "M1291.2,711.93c-1.11-1.59-5-2.4-3.9-4.8a10.94,10.94,0,0,0,1.25.69h0c.2.11,0,.32,0,.49.27.58,1.13.63,1.63,1C1290.35,710.29,1291.2,710.91,1291.2,711.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-446",
    d: "M1286.84,707.1c-.25.23-.4.57-.73.71-1.25-.44-2.48-1-3.88-.52a.76.76,0,0,1-1-.7c.52-1.1,1.9,0,2.75-.69,1.17-.29,1.87.57,2.88,1A.91.91,0,0,1,1286.84,707.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-447",
    d: "M1288.55,707.82l-.48-.23.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-267",
    d: "M1286.61,705.62a.75.75,0,0,1-.49-.21A.73.73,0,0,1,1286.61,705.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-356",
    d: "M1290.21,709.3c-.66-.09-2.32-.19-1.88-1.23l.22,0c.09-.1.17-.1.24,0l.47.22a1.33,1.33,0,0,0,2,.5C1291.55,709.94,1291,709.67,1290.21,709.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-448",
    d: "M1292.88,710.83c-.1.43-.44.5-.69.67C1291.23,711.62,1292.17,710.33,1292.88,710.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-449",
    d: "M1290.48,710.25c0-.1-.11-.19,0-.26l1,0A1.89,1.89,0,0,1,1290.48,710.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-450",
    d: "M1293.66,710.46c-.07.19.07.45-.17.61-.16-.27,0-.44.16-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-451",
    d: "M1293,710l.14-.12C1293.32,710.06,1293.19,710.17,1293,710Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-279",
    d: "M1299.69,710.48c-1.8,0,.6,2.54-1,2.7-.45-1,0-2.22-.74-3.18,1,.07-.46-1.06.58-1.27a1.89,1.89,0,0,0,1.11,1A.83.83,0,0,1,1299.69,710.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-279",
    d: "M1298,710l-.25-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-279",
    d: "M1299.93,710.72l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1295.08,714.35c1-.53-.13-.76-.72-1-.31-.42,0-.7.23-1,0,.34.14.63.52.73,2.8.4,1.61,3.53,2.28,5.27.22.55,1.09.32,1-.23-.26-.77.63-1.22.5-1.89a9.82,9.82,0,0,1-.13-2.48c.49,0,.5.4.6.75,0,1.72,1.17,3,1.53,4.58s-2,1.43-3.12,1.75c-.49.22-.69-.33-1-.6C1294.34,716.22,1298,718.25,1295.08,714.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1297,712.9h1c0,.31-.07.62-.11,1A3.22,3.22,0,0,1,1297,712.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1296.78,712.66l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-452",
    d: "M1299.41,717.06c-.25-1.28-.54-2.59-.67-3.88,1.36-.76,1.68,1.1,1.16,2C1300.39,715.94,1300.43,716.74,1299.41,717.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-453",
    d: "M1297,712.18c.52.09.27.46,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-454",
    d: "M1282.71,704.71c-2,1-4.34.57-6.48.47-1.63-1,2.61-1.77,3.14-.76A11.37,11.37,0,0,1,1282.71,704.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-455",
    d: "M1275.93,704.46a.58.58,0,0,0,.76.4,6.18,6.18,0,0,1,3.37.51v.26c-.64.73-1.53.19-2.27.45-.81-.25-3.09-.32-2.08-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-454",
    d: "M1275.71,704.44v.24c-2.81,1.81-3.94-.79-1.82-1.09l.13-.09,1,0h0C1274.71,704.2,1276,703.68,1275.71,704.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-372",
    d: "M1274,703.71c-.66.14-.75.85-1.2,1.21-2.28.36.11-2.58,1.2-1.42,0,.07,0,.14,0,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-372",
    d: "M1273.52,703.22V703C1273.78,703,1273.74,703.2,1273.52,703.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-456",
    d: "M1260.7,711.69c.14-.32.59-.63,0-1,.08-.24.73-.22.49-.48s0-.44.23-.52c.52-.44,1.07-.28,1.7-.24.25-.33.54-.53,1-.3.11,1.33-2.08,1.54-2.73,2.58C1261.19,712,1260.89,711.89,1260.7,711.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-457",
    d: "M1264.09,709.27a2.51,2.51,0,0,0-1,.23c.3-.61.87-1.12.74-1.91h.24c.23.17.62.1.72.47l.74.5C1265.36,709.4,1264.66,709.2,1264.09,709.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-457",
    d: "M1262.63,709.5a4.19,4.19,0,0,1-1.22.24C1261.9,709,1261.9,709,1262.63,709.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-391",
    d: "M1261.18,710.26c0,.07.09.15,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-458",
    d: "M1264.09,709.27c.34-.53,1-.37,1.46-.71s.5-1.11,1.26-1.06c.44-1.49,3.56-.88,2.38-2.82l.11-.06c.42.67,1.25.37,1.79.78,1,1.94-5,4.66-6.6,5-.89.6-2,.9-2.62,1.8-.41.8-1.83.46-1.17-.48C1261.73,710.84,1263,710.12,1264.09,709.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-459",
    d: "M1266.52,705.91c.93-.31,1.36-2.38,2.51-1.56C1268.65,705,1267.35,706.41,1266.52,705.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-373",
    d: "M1264.81,708.06l-.72-.47a1,1,0,0,1,1,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-394",
    d: "M1268.93,704.67v-.26c.27-.16.47-.14.53.21l-.06.08A2.42,2.42,0,0,0,1268.93,704.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-373",
    d: "M1262.15,707.81c-.12-.76,1.2-.79,1.68-1.17C1263.62,707.53,1262.69,707.39,1262.15,707.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-281",
    d: "M1260.45,707.32l.45.08a.47.47,0,0,1-.43.41c-.27-.32-.68,0-1-.26C1259.77,707.3,1260.12,707.36,1260.45,707.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-377",
    d: "M1261.9,706.85c0-.3.28-.47.44-.69C1263,706.38,1262.26,706.74,1261.9,706.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-281",
    d: "M1260.21,708a.66.66,0,0,1-.2-.06.37.37,0,0,1,.19-.11A1,1,0,0,1,1260.21,708Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-460",
    d: "M1260.69,730.09c.63.21.25-.65.25-1,1.2.69,1,2.36,2.17,3.15.57,1,9.6,11.45,5.24,9.54-2.59-2.87-3.67-6.7-6.46-9.43a1.67,1.67,0,0,1-.79-1.09c-.25-.32-.63-.58-.51-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-461",
    d: "M1262.12,727.71l0-.53c1-.24,1.43,2.5,2.37,3.12,1.38,2.71,4.83,4,4.88,7.37-.88.29-1.88-1.66-2.44-2.24h0a8.5,8.5,0,0,0-.72-1h0a5.23,5.23,0,0,0-.5-.73h0C1264.43,731.79,1262.83,730,1262.12,727.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-462",
    d: "M1273.31,746.3a23.45,23.45,0,0,0-2.39-3.15c.13-1,1.08-.4,1.64-.26a2,2,0,0,1,.75,1.2c-.62.83.88,1.55.23,2.46A1.37,1.37,0,0,1,1273.31,746.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-463",
    d: "M1269.41,741.47c-.59-.73-1.53-1.29-1.17-2.47a7,7,0,0,1,1.44,1.49C1269.93,740.82,1269.94,741.43,1269.41,741.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-464",
    d: "M1269.67,741.21c0-.24,0-.48,0-.72.81.74,2.4,1.32,1.47,2.67C1270,743,1269.84,742.1,1269.67,741.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-465",
    d: "M1271.35,742.68c-.1-.56-.54-.94-.73-1.46a4.46,4.46,0,0,1,1.94,1.68C1272,743.58,1271.74,742.82,1271.35,742.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-466",
    d: "M1268.78,737.58h.63c.5-.42,1.62.34,1.45,1-.2.17-.38.43-.68.16C1269.59,738.5,1268.74,738.57,1268.78,737.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-467",
    d: "M1270.18,738.74l.68-.16c0,.14,0,.29,0,.43C1270.54,739.52,1269.8,739.51,1270.18,738.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-466",
    d: "M1270.12,738.91a.81.81,0,0,0,.47.4C1270.44,740.2,1269.26,739.26,1270.12,738.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-386",
    d: "M1260,722.34a1.65,1.65,0,0,1,.51,1.21A1.39,1.39,0,0,1,1260,722.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-468",
    d: "M1266.25,734.45a1.14,1.14,0,0,1,.72,1A1.47,1.47,0,0,1,1266.25,734.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-468",
    d: "M1265.27,733a.78.78,0,0,1,.49.74A1,1,0,0,1,1265.27,733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-468",
    d: "M1265.76,733.73a.81.81,0,0,1,.5.73A1,1,0,0,1,1265.76,733.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-464",
    d: "M1269.67,740.48a.89.89,0,0,1-.52-.68A.84.84,0,0,1,1269.67,740.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-385",
    d: "M1258,719.68a.31.31,0,0,1,.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-385",
    d: "M1257.55,720.17l.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-385",
    d: "M1257.79,719.92l.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-468",
    d: "M1267,735.43l.23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-462",
    d: "M1273.53,744.37l-.22-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-462",
    d: "M1273.74,744.62l-.21-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1258.76,715.36c.86,1,.51,2.77.29,4A5.62,5.62,0,0,1,1258.76,715.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1258.55,713.64c1,.4,1,.6.23,1.66C1258.47,714.71,1259.17,714.09,1258.55,713.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-469",
    d: "M1257.92,717.23c-.1,0-.12,0-.05-.09s-.11-.11.05-.09S1258,717.18,1257.92,717.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1258.47,713.17l.42.07c-.05.2-.22.12-.35.14A1.72,1.72,0,0,0,1258.47,713.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1259.3,720.21a.45.45,0,0,1,.15.18A.43.43,0,0,1,1259.3,720.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1259.07,719.72a.49.49,0,0,1,.14.18A.28.28,0,0,1,1259.07,719.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-197",
    d: "M1258.26,713.63l0,0S1258.3,713.64,1258.26,713.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-460",
    d: "M1261,729.12c-.09-.16-.18-.31-.26-.47A.72.72,0,0,1,1261,729.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-470",
    d: "M1258.73,727.68c2.53,2.51.61,2.6-.2,0C1258.6,727.56,1258.67,727.56,1258.73,727.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-460",
    d: "M1259.48,729.39c.24.07.45.08.46-.26a1.67,1.67,0,0,1,.51.72c-.08.21-.33.1-.48.23l-.49-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-284",
    d: "M1258.73,727.68h-.2c-.47-.35-.52-1,.22-.74A1,1,0,0,0,1258.73,727.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-460",
    d: "M1260.45,729.85l.24.24c-.21.06-.31,0-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-469",
    d: "M1259.5,718c.08-1.54.67-3,.46-4.6l.18,0a3.38,3.38,0,0,1-.29,4.78A.57.57,0,0,1,1259.5,718Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1259.5,718h.23c1,1.15,2,2.33,1.83,4-.52.35-.54-.34-.86-.4a14,14,0,0,0-.73-1.45h0c-.15-.13-.09-.36-.24-.49a1.85,1.85,0,0,1,0-.23c-.15-.13-.08-.36-.23-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1262.39,727.19h-.23c-.17-1,.07-2.09,0-3.13a.18.18,0,0,1,0-.31C1263.21,723.64,1263.55,727,1262.39,727.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-469",
    d: "M1262.15,723.79v.26a12.16,12.16,0,0,1-1.44-2.43,1.61,1.61,0,0,1,.73.48C1262.13,722.14,1262.74,723.27,1262.15,723.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-469",
    d: "M1260,720.17a1.66,1.66,0,0,1,.72,1.45A2.1,2.1,0,0,1,1260,720.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-469",
    d: "M1259.73,712.68l.47-.27a.54.54,0,0,1-.24,1A1,1,0,0,1,1259.73,712.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-469",
    d: "M1259.49,719l.23.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-469",
    d: "M1259.73,719.68l.24.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-456",
    d: "M1260.21,712.68c0-.09,0-.18,0-.27.18-.23,0-.68.49-.72C1260.68,712.06,1260.83,712.88,1260.21,712.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-287",
    d: "M1269.45,704.62a2.24,2.24,0,0,0-1.48-.2l.24-.72c.68,0,1.24.44,1.91.51A.65.65,0,0,1,1269.45,704.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-472",
    d: "M1270.88,705.9c.2-.39.65-1.47,1.2-1.23a.53.53,0,0,0,.7,0l.27,0c.64.87,1.75-.28,2.66,0l.24.72C1274.51,706.49,1272.57,706.13,1270.88,705.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-290",
    d: "M1272.08,704.67l-.73.46v-.48c.34-.33-.26-.65,0-1v-.21a.52.52,0,0,1,.48.25h0a2.72,2.72,0,0,1,.24.24C1272.08,704.19,1272.07,704.43,1272.08,704.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-473",
    d: "M1271.35,703.67c.14.32.34.65,0,1C1271.33,704.33,1271.06,704,1271.35,703.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-290",
    d: "M1271.12,703.19l.23.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-372",
    d: "M1272.07,704l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-372",
    d: "M1271.83,703.71l-.25-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-474",
    d: "M1264.09,738.81c-.21-1.2-1.1-2.25-1.3-3.37,2.18-.9,2.49,2.86,3.33,4.15-.13.75.49,1.07.74,1.68a16.86,16.86,0,0,0,1,2.57c.3.72,1.4,3.2-.32,2.39-.7-.36-.35-1.33-.77-1.85h0c-.12-.15-.08-.37-.24-.5h0a33.79,33.79,0,0,0-1.66-3.22A1.26,1.26,0,0,1,1264.09,738.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-475",
    d: "M1264.09,738.81c.79,1.38.85,2.92,1.41,4.4l-1.41-.29c-.08-1.95-1.31-3.42-1.58-5.32C1263.5,737.35,1263.48,738.41,1264.09,738.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-476",
    d: "M1269.17,750.19c0,.26-.11,1.25-.48,1h0c-.49-.8-.58-1.88-1.78-2.15-.61-.14-.09-.88-.4-1.24l0-.48c-.07-.08-.14-.17-.22-.25h0c-.15-.12-.1-.35-.24-.48,0-1.27,1.09.21,1.49-.33C1268.33,746.38,1269.68,749.54,1269.17,750.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-477",
    d: "M1266.51,747.76c.46,1.37,2.43,1.66,2.18,3.39-.92-.8-1.82-3.27-1.55-.24a5.34,5.34,0,0,1-1.14-3.1C1266.13,747.32,1266.45,748.84,1266.51,747.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-478",
    d: "M1267.49,746.31c-.52,1.82-.64-.31-1.45,0,0-.37,0-.72.44-.87.33,0,.22-1.06.5-.56v0c.17.12.13.35.25.5v0c.17.13.13.35.25.5h0A.3.3,0,0,1,1267.49,746.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1265.75,742.44a1.54,1.54,0,0,1,.75,1.46A5.32,5.32,0,0,1,1265.75,742.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-407",
    d: "M1264.57,746.31a1.77,1.77,0,0,1-.24-1.21A1.77,1.77,0,0,1,1264.57,746.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-476",
    d: "M1269.17,751.4l.24.47c-.17.21-.27-.07-.25-.23A.13.13,0,0,1,1269.17,751.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-477",
    d: "M1266,746.55l.24.48A.74.74,0,0,1,1266,746.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1267,744.88l-.22,0c0-.15,0-.3,0-.45A.74.74,0,0,1,1267,744.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1266.49,743.89a.76.76,0,0,1,.24.5A.65.65,0,0,1,1266.49,743.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-477",
    d: "M1266.27,747c.07.09.15.17.22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-477",
    d: "M1268.69,751.15h.24a1.34,1.34,0,0,0,.11.14l-.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-477",
    d: "M1269.17,751.4v.24l-.24-.24c.08-.1.17-.11.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-477",
    d: "M1269.18,751.86h.23a1.93,1.93,0,0,1,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-476",
    d: "M1269.44,752.12l.21.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-476",
    d: "M1269.65,752.37l.23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-136",
    d: "M1269.92,752.85l.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-136",
    d: "M1270.16,753.09l.2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-480",
    d: "M1269.17,750.19c-.26-1-1-1.83-1-2.92.89-.21.77.89,1.38,1.05a3.87,3.87,0,0,1,.87,2.84l.21.24c0,.36.08.89-.49.73h0C1269.72,751.52,1269.58,750.8,1269.17,750.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-397",
    d: "M1269.89,751.65a.7.7,0,0,1,.24.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-476",
    d: "M1269.17,751.39h-.23a.88.88,0,0,1,0-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-397",
    d: "M1269.7,751.41l.18.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-481",
    d: "M1272.07,749a3.24,3.24,0,0,1,.51.93c-.52.76.46,1.56.22,2.42-.59-.5-.47-1.35-1-1.91-1.41-.08-.9-3.33,0-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-481",
    d: "M1272.57,749.92l.24.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-481",
    d: "M1272.81,750.18l.2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-299",
    d: "M1273.28,750.68c.07.09.15.17.22.25C1273.43,750.85,1273.35,750.77,1273.28,750.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-299",
    d: "M1273.56,751.12l.22.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-299",
    d: "M1273.78,751.39l.23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-482",
    d: "M1271.33,749l.51,1.44c-.07.2.07.55-.35.48s-.86.19-.87-.47c-.73-1.66-2.13-3.49-2.11-5.27C1269.48,744.19,1271.26,748.28,1271.33,749Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-483",
    d: "M1268.69,745.1c.41,1.85,1.65,3.42,1.93,5.33l-.24.24c-.62-1.69-2.23-3-2.18-4.85C1268,745.58,1268.32,744.78,1268.69,745.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-483",
    d: "M1270.62,751.4l-.21-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-484",
    d: "M1271.33,749c-.49-1.51-1.74-2.66-1.61-4.3-.14-.78-1-1.46-.41-2.27,1.48-.43,1.23,1.67,1.8,2.44.11.08.09.22,0,.25-.12.6-.5,1.23.24,1.7l0,.49c.38.35.32,1,.48,1.43C1271.44,748.35,1271.34,748.59,1271.33,749Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-299",
    d: "M1274,750.66c.07.17.13.34.2.52C1274.16,751,1274.1,750.83,1274,750.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-406",
    d: "M1271.58,747.53l-.21-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-484",
    d: "M1272.07,749l-.22-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-299",
    d: "M1273.79,750l.18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-485",
    d: "M1271.11,744.85a16.35,16.35,0,0,1-1.46-2.4c-.15-.13-.42-.21-.24-.5v-.48l.26-.26c.65.88,1.36,1.73,1.94,2.67C1270.82,743.89,1271,744.39,1271.11,744.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-309",
    d: "M1271.84,746.07a.89.89,0,0,1-.48-.73C1271.69,745.09,1271.7,745.87,1271.84,746.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-485",
    d: "M1271.11,745.1v-.24l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-485",
    d: "M1271.58,745.34h-.22a1.93,1.93,0,0,1,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-404",
    d: "M1273.31,746.3l.22.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-409",
    d: "M1262.89,735.42v.48a1.08,1.08,0,0,1-.52-1.19l.09-.07C1262.92,734.72,1263.06,735,1262.89,735.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-486",
    d: "M1262.89,735.42c-.61-1-.86-2.28-1.7-3.15,0-.38-.47-.85.22-.94a1.48,1.48,0,0,0,0,.21,2.62,2.62,0,0,1,.22.25c0,.08,0,.16,0,.24a2.18,2.18,0,0,1,1.08,1.06c.28.77,1.34,1.24.88,2.29C1263.41,736,1263.14,735.48,1262.89,735.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-410",
    d: "M1261.41,731.33a1.08,1.08,0,0,0-.25.71c-.57-.55-.71-1.35-1.19-2l.48-.23.24.24C1260.74,730.61,1261.22,730.88,1261.41,731.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-426",
    d: "M1302.35,743.64c.44-.46.6-1.17,1.38-1.34.62-.59.93-1.89,2-2C1304.64,741,1303.71,744.52,1302.35,743.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-413",
    d: "M1303.08,743.64h.23a1.31,1.31,0,0,1-.71,1C1302.09,744,1302.67,743.83,1303.08,743.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-487",
    d: "M1303.08,743.64a1.33,1.33,0,0,0-.5,1c-.88.22-1.06.94-1.2,1.69-2.86,1.41-5,3.91-7.74,5.39-1.13.5-1.78-2.13-1.22-3a4.59,4.59,0,0,0-2.53-5c.78-.72,1.2-1.69,2-2.31.59,1-1.37,1.51-.21,2.36,1,1.21,2.93,2.47,2.25,4.25a1.58,1.58,0,0,0,.1,1.39c.64-1.06,2-.37,2.7-1.22C1299.2,747.31,1300.87,743.87,1303.08,743.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-488",
    d: "M1298,723.07c.86,1.07-1.45,6.31-2.42,7-.69,1.09-1.79,1.93-2.07,3.29,0,.24-.38.25-.59.34-.54,2.76-2.11,5.29-5.12,5.46-1.48-1.58,1.76-1.31,1.94-3.29,1.09-1.87,1.6-4.08,3-5.75.58-.92,1.63-1.44,2-2.61-1.06-.14-2.34,1.55-3.24.26.29-1-.35-1.73-.64-2.55-1.49-6.38,7.42-6.89,4.62,0C1296.64,724.89,1296.65,723.2,1298,723.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-489",
    d: "M1291.69,727.67c1.45.76,1.52-1.2,4-.74.37-.07.34.6.17.76-.84.39-1.16,1.28-1.81,1.83s-.93,1.29-1.45,1.84c-.55.32-.87.66-.57,1.34-.16.85-1.44.82-.3,1.87-.09.39-.4.3-.59.4-1.58.62-.61,3.2-2.69,3.16-.72.07-.8.34-.65.92-1.94,1.79-7.45-1.38-2.66-2.67,3.19-1.75,4-5.48,5.74-8.39C1291,727.6,1291.27,727.37,1291.69,727.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-490",
    d: "M1300,720.43c1.55-1.45-1.35-2.8-.13-4,.88-.37,2.28.94,1.5,1.79.21,1,1.21,1.79,1.11,2.91.58,1.57-1.7,2.57-1.2,3.63.9,1.39,2.2,2.5,2.76,4.1.34.86,1.35,1.18,1.48,2.14.82,1.58,2.53,2.05,3.74,3.14a2.59,2.59,0,0,1-.26.46.21.21,0,0,0-.16.13c-2.2-.52-5-1.58-6.48-3.67-2.82-2.64-3.92-4.32-3.88-8.26,0-.54-.66-1.47.73-1.18.17,0,.15-.33.25-.49S1299.93,720.77,1300,720.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-491",
    d: "M1298,723.07a17.13,17.13,0,0,1-1.92,2.72c-.62.83-1.28-.29-2.06-.38,2.11-.8,2.3-4,.11-4.76-.1-.15-.32-.22-.35-.39l.08,0c-.09-.05-.1,0-.1.08-.71.06-1-.57-1.22-1-1-.92-.75-2.48-1.77-3.42-.55-1.74-2-1.06-3-2.37-1-1.11-3.14-.38-3.37-2.31.09-3.49,6.81,1.62,7.54,3.06.94,1.75,1.3,3.77,2.85,5.16a6.88,6.88,0,0,1,1.58,2.57c0-1,.17-1.57.92-1.77l.48.73v.73c.22.19,0,.52.22.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-492",
    d: "M1307.19,737.83c-.58-1.51-2.48-1.52-3.28-3-2.38-1.74-3.23-.9-4.7-4.36-.9,2.58-1.92,6-4.37,7.33-1.59-.25-2-.9-.8-2.17,1.44-1,1.44-3.22,3.22-3.64.61-1.35,1.06-3.47,2.87-1.85.47.63.81,1.38,1.62,1.63,1.64,1.05,2.68,2.81,4.53,3.57C1307.59,736,1307.75,736.46,1307.19,737.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-493",
    d: "M1296.78,748.25c-.17.28-.37.61-.7.62-1.3,0-1.41,1.32-2.35,1.79-1.27-1.39.47-3-.48-4.28-1.66-2.2-2.9-2.18-1.31-4.91.47-.3.93-1.3,1.45-1.21-.11,1.06-2.56,2.56-1.19,3.35,3,2.19,2.79,2.3,5.91.15,1-.55,1.64.77.52,1.11-1.47.52-2,2.13-3.3,2.9C1294.26,748.77,1296.24,748.55,1296.78,748.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-494",
    d: "M1298.5,723.29c.19,3.32,2.28,5.38,4.42,7.66,1.33,2.34,4.22,1.95,5.91,3.82a2.9,2.9,0,0,1-.68,1.13c-3.9-.65-6.33-4.26-9.28-6.64-.55-.45-.47-1.14-.44-1.79A26.49,26.49,0,0,0,1298.5,723.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-495",
    d: "M1298.48,725c.57,1.54-.17,3.36,1.32,4.58,1.32,1.86,3.6,2.67,4.82,4.59,2,1.34,4.83.37,2.79,3.9l-.22-.23c.19-2.37-3.1-2.47-4.06-4.38-.57-1-1.78-1.17-2.47-1.91h0c-2.59-3.72-1.94.36-3.4.49-.24-.54.26-1.2-.3-1.72C1297.5,728.68,1298.65,726.94,1298.48,725Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-496",
    d: "M1290,730.33c.37.88-1.07,1.24-.56,2.25-1.6,1.59-1.4,3.59-4.28,3.8.8-.94-.92-.9,0-1.93a.82.82,0,0,1,.06-.51c1.16-.86,1.26-2.44,2.3-3.38C1288.11,730,1289.59,729,1290,730.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-497",
    d: "M1283.46,737.11c-.18,2.45,2.27,1.36,3.67,2.09,1.17,0,2.11-1,3.23-1.2,1.13-.49.87-2.12,2-2.73.13-.48-.16-1.32.57-1.55.39,3.56-2.74,5.59-5.82,6.18a2.2,2.2,0,0,1-2.29-.06,1.1,1.1,0,0,0-.7-.14c-1.23.26-.26-1.06-1.09-1.4a5.48,5.48,0,0,1-1-.68C1282.56,737.61,1283,737.21,1283.46,737.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-498",
    d: "M1287.82,731.06c-1.49,2.38-2,3.12-4.6,4.36-.41.59-1.07.24-1.63.15-1.92.1-1.62-1.56,0-1.92,1.6.21,1,1.14,2.66,0-.24.14-.59.62-1.18.29-.74-1.53,2.24-1.84,2.81-3,.84-.61,1.55-2.29,2.79-1.71C1288.89,730,1288,730.39,1287.82,731.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-499",
    d: "M1282.49,735.41h.73c.13,2.28-3.24,1.21-2.66,4.11-.53-.46-2.18-.91-1.27-1.59.74-.62,1.14-1.55,2-2C1281.35,735.42,1282.1,735.28,1282.49,735.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-500",
    d: "M1294.84,737.84c.77-1.05,1.88-1.88,2.18-3.24.92-.52.83-1.78,1.7-2.33-.41,3.09-3.1,5.65-5.33,7.74C1293.61,739.11,1294.35,738.56,1294.84,737.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-497",
    d: "M1292.91,733.72c.22-.37.52-.71.38-1.21s.61-.83.64-1.34c.1-1,1.12-.47,1.64-1.08.31,1.84-1.27,2.83-2.18,4.11h0A1.26,1.26,0,0,0,1292.91,733.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-501",
    d: "M1299.45,721.17c.21.43,1.07,1,.46,1.39s-.93-.27-1.3-.71c-.25.29,0,.68-.14,1C1298.06,721.65,1298.06,721.65,1299.45,721.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-496",
    d: "M1285.16,736.39a1,1,0,0,1-1,.48A1.51,1.51,0,0,1,1285.16,736.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1298,722.34a1,1,0,0,1-.22-.72A1,1,0,0,1,1298,722.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-500",
    d: "M1293.39,740.26h-.24l.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-487",
    d: "M1292.9,740.5l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-487",
    d: "M1292.66,740.74l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-487",
    d: "M1292.42,741l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-487",
    d: "M1292.18,741.23l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-502",
    d: "M1277.64,740c-9.53-2.3-5.31-.9-10.85-6.78-.63-.44-2.2-1.94-1.09-2.56,2,.62,3.31,2.58,5.14,3.58a.78.78,0,0,1,.36.59,5.29,5.29,0,0,0,3.68,3.35c.38,0,.83-.1,1.07.36,1,1.05,2.76.72,3.64,1.93l-1.46-.23C1278,740.1,1277.77,740.17,1277.64,740Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-503",
    d: "M1276,738.56c-2.23.42-3.48-.92-4.83-2.48-.95-.59,0-1.89.75-1.09.55,1,1.81,1,2.6,1.67-.34-.72-.7-1.43-1.69-1.42-.73.17-1.44-.61-.67-1.13,2.64-1.48,2.52,1.67,4.23,2.66.36.21.49.46.17.73S1276.56,738.44,1276,738.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-504",
    d: "M1275,735.17c-.76-.69-1.56-1.25-2.66-.73-.63-.53-.26-1.13-.12-1.71,1.17-1.85,3.66-.37,4.82.74.18.71-.64.9-1.17.86.34.73,3.35.29,3.25,1.57a.63.63,0,0,0-.24,0C1277.79,737.83,1276.4,735.25,1275,735.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-505",
    d: "M1279.1,735.9a23.42,23.42,0,0,1-4.66-1.7c.54-.38,1.06-.18,1.53-.23,1.1.4,2-.18,3-.56,1,.11,2.17-.66,3,0,.25.5-.28.41-.45.59h0c-1.19.12-1.58,1.14-2.18,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-506",
    d: "M1279.34,735.89c.07-1.41.45-1.75,2.18-1.93-.24.36-.78.36-1,.81.5.68,1.39.16,1.93.64l-.72.25c-.13.15-.36.09-.49.24h-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-507",
    d: "M1266,732.27c1.74,1,3.57,2.42,4,4.52.18.91,1.42,1,1.87,1.77l-1-.24h0a8.87,8.87,0,0,1-1.22-.72h-.24a3.68,3.68,0,0,1-1.41-2.41c-1.44-2-3.73-3.64-4.65-6.06-.11-.06-.11-.24,0-.28C1265.14,728.55,1265,731.28,1266,732.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-329",
    d: "M1277.64,740l.49.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-508",
    d: "M1309.14,720.64c-1.12-.19-2.19,1.53-3.29.38-1-1.62-3.75-2.1-3.59-4.25.59-.37,1,.23,1.54.25C1305.48,718.37,1307.44,719.39,1309.14,720.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-509",
    d: "M1303.8,717c-.54.24-1-.16-1.48-.23-.52.47-.89-.09-1.33-.19a3,3,0,0,1-.81-2.73c.58.35,1.44.46,1.18,1.49C1302,715.92,1303.07,716.4,1303.8,717Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-510",
    d: "M1301.37,712.67c.6-.81,3.32,1.73,2,2.66C1303,714.56,1301.09,713.19,1301.37,712.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-509",
    d: "M1300.91,712.66c.39-.1.28.32.49.48-.1.94-.81.4-1.25.51-.16.39-.72-.67-.45-.88C1300.05,712.24,1300.51,712.71,1300.91,712.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-511",
    d: "M1299.92,713.64h.23c.06.4.16.8.24,1.2C1299.72,715,1300,714,1299.92,713.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-438",
    d: "M1303.09,715.08l.23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-512",
    d: "M1306.73,721.12c.58-.11.29-.61.42-1,.46.32.87.7,1.29,1,1-.21,1.31.84,2.15,1,0,.62-.41.6-.79.48-.77-.26-1.67,0-2.35-.49h0C1307.19,721.79,1306.5,721.79,1306.73,721.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-513",
    d: "M1308.41,721.61c.7.21,1.45,1,2.18.49,1.11.28.32,2,1.2,2.67-1-.06-1.34-.68-1.62-1.51S1308.05,722.94,1308.41,721.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-494",
    d: "M1309,734.64v-.08c.07,0,.09,0,.1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-514",
    d: "M1302,738.55c-.19.78.09,1.15.8,1.25,1,.38,0,1.86-.69,2.15s-1.42.63-1.68,1.46c0,.08-.2.14-.31.14-.4-.09-.11-.69-.22-1-.11-.87-1.61-1.51-2-.54a5.21,5.21,0,0,1-3.18,2.11c-.79-.79-2.78-.92-1.75-2.43,1.68-2.7,4.24-4.87,5.8-7.53.41,0,.46.32.61.61C1300.3,736.15,1302.36,736.64,1302,738.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-515",
    d: "M1308.41,721.61c1.57,1.73,2.68.27,2.42,3.64l-.25-.23c0-.89-.84-1.27-1.18-1.95-.09-.18-.64.15-1,0a1.13,1.13,0,0,0-.72-.5l-.25-.47C1307.92,722.23,1308,721.66,1308.41,721.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-516",
    d: "M1305.27,725.22c-.54-.26-1.12-.34-1.31-1,0-.81-1.43-2.12-.35-2.63a5.37,5.37,0,0,1,2.57,3.14C1305.22,724.44,1305.22,724.44,1305.27,725.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-437",
    d: "M1305.69,727l-.17,0c0-.48,0-1,0-1.45.58.26,3.91,1.77,1.66,1.79C1306.64,727.3,1306.2,726.73,1305.69,727Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-517",
    d: "M1308.16,729.37a4.43,4.43,0,0,1-1.94-1.46h0c-.43-.65.14-1.36.72-.72h0C1307,728.14,1308.59,728.43,1308.16,729.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-516",
    d: "M1303.09,720.88l.5.49a1.49,1.49,0,0,0,0,.21C1303.19,722.06,1302.56,721.19,1303.09,720.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-437",
    d: "M1305.5,725.48l-.21-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-518",
    d: "M1301.16,716.27c2,1,3.39,2.88,5.06,4.39-.86.45-1.61-.15-2.4-.28a19.71,19.71,0,0,1-2.19-2.63v0C1301.41,717.26,1300.61,717,1301.16,716.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-519",
    d: "M1303.82,720.38a3.1,3.1,0,0,1,3.62,1.72A10,10,0,0,1,1303.82,720.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-520",
    d: "M1301.66,719.21c-.26-.27-.62-.51-.3-1,.22.33.57.58.69,1A.26.26,0,0,1,1301.66,719.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-521",
    d: "M1301.66,719.21l.39,0c.11.22.21.44.32.65a.37.37,0,0,1-.3.33,1.72,1.72,0,0,1-.42-.8A1.48,1.48,0,0,1,1301.66,719.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1302.07,720.22l.3-.33v0c.11.17.37.35.22.58A.33.33,0,0,1,1302.07,720.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1303.09,720.88l0,.25c-.33.07-.34-.14-.32-.37l.11-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1302.64,720.36l.21.28c-.17.1-.33,0-.27-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-521",
    d: "M1302.57,720.17l-.2-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-428",
    d: "M1306.94,727.2c-.68-.2-.74.22-.72.72l-.21,0a2.07,2.07,0,0,0-.23-1C1306.3,726.52,1306.37,726.53,1306.94,727.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-428",
    d: "M1306.22,727.91c.08.09.16.17.23.26C1306.38,728.08,1306.3,728,1306.22,727.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-523",
    d: "M1304,728.9c-.54-.93-2.08-2.25-1.34-3.38.3-.16.47,0,.49.26a5.9,5.9,0,0,0,.87,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-524",
    d: "M1305.51,731a2.54,2.54,0,0,1-.77-1.18C1305.85,730,1305.86,730.06,1305.51,731Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-525",
    d: "M1302.58,720.43c.41.3.42.86.75,1.19h0c.28.54.42,1.16.73,1.7h0c.21.2,0,.55.24.74h0c.13.14.08.4.26.5a5.38,5.38,0,0,1,.52,2.6c-1-.71-1.07-1.76-1.5-2.62-.81-.28-1.52-3.32-1.25-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-526",
    d: "M1302.57,721.43l.06.44a.72.72,0,0,1,.22.48.89.89,0,0,1,.25.72.71.71,0,0,1,.23.48c.66,1.06-.31,2.51.45,3.67-.62-.41-.59-1.18-.94-1.74-.83-.34-.77-1.12-.68-1.74C1302.45,723.16,1301.84,721.3,1302.57,721.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-527",
    d: "M1300.91,712.66c-.28.74-1.33-.5-1,1a1.9,1.9,0,0,0-.94-.49c-.15-.72-.45-1.44,0-2.16v0C1299.58,711.56,1300.26,712.09,1300.91,712.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-509",
    d: "M1300.66,712.41a1.75,1.75,0,0,1-1.21-1A1.87,1.87,0,0,1,1300.66,712.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-420",
    d: "M1301.39,713.14l-.25-.47h.23C1301.38,712.82,1301.38,713,1301.39,713.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-509",
    d: "M1300.9,712.65l-.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-279",
    d: "M1299.21,711.2,1299,711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-528",
    d: "M1279.37,704.42c-.76.06-1.47-.33-2.23-.25,1.51-1.29,4.91-.55,7-.21C1282.73,704.83,1281.31,703.32,1279.37,704.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-349",
    d: "M1278.1,703.74a.88.88,0,0,1-.7.18l.26-.43A.56.56,0,0,1,1278.1,703.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-371",
    d: "M1277.16,704a1.36,1.36,0,0,1,0,.2l-.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-529",
    d: "M1277.67,705.67c1.54,0,3.07,0,4.6,0,.52.35,1.12.16,1.68.23-.63.8-1.82.29-2.67.71C1280,707.16,1278.18,707.13,1277.67,705.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-267",
    d: "M1283.46,705.4a1.29,1.29,0,0,1,1-.22C1284.16,705.41,1283.88,705.69,1283.46,705.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-447",
    d: "M1288.79,708.08l-.24,0v-.24C1288.74,707.8,1289.13,707.88,1288.79,708.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-530",
    d: "M1285.9,709.5a15.87,15.87,0,0,1,7.2,5.06c.51.66,1.14-.25,1.75-.2,2,1.79-1.57,2.22-2.39.89a10.8,10.8,0,0,0-7.06-5h0c-.46-.41-.93.06-1.39,0-1.22-.58-2.8.65-3.74-.56-.69-1.22-6.17-2.19-2.46-3.11C1283.71,709.1,1283.9,704.78,1285.9,709.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-531",
    d: "M1285.9,709.5c-1.41-.18,0-2.23-2.92-1.8-.84,1.15-6.93-.91-4.61-1.32,1,.08,2-.25,2.91.23a1.22,1.22,0,0,0,1.14.14c1.38-.33,2.87-.31,3.69,1.06C1285.25,708.07,1286.19,708.91,1285.9,709.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-532",
    d: "M1294.84,714.6c0-.08,0-.16,0-.24a1.38,1.38,0,0,1,1.44,1.44.51.51,0,0,1-1-.23c-.16-.17-.33-.32-.48-.49h0A.32.32,0,0,1,1294.84,714.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-447",
    d: "M1288.33,708.07l.48.94C1288.1,709.2,1287.25,708.17,1288.33,708.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-533",
    d: "M1297.27,720.16a.92.92,0,0,1-.23.67c-1,.8.94.83.09,1.56a.58.58,0,0,1-1.09-.12c-1-2.54-3.92-4-3.86-6.95,1,.76,4,.9,3.89,2.41a4.52,4.52,0,0,1,.72,1.46,2.73,2.73,0,0,0,.23.25c0,.08,0,.16,0,.24.15.13.08.36.24.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-534",
    d: "M1301.16,716.27a6.67,6.67,0,0,0,.48,1.45c-.8-.5-2.07-1.91-2,0-.66-.52-.09-1.4.49-1.68-.06-.51-.74-.83-.47-1.46h.24l.45.28h0A5.86,5.86,0,0,1,1301.16,716.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-535",
    d: "M1295.82,717.5c-.9-.8-.26-1.38.47-1.7.85-.65.66,2.08-.22,1.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-536",
    d: "M1298.94,718.86c-.08.09-.27,0-.16-.08A.11.11,0,0,1,1298.94,718.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-491",
    d: "M1297.27,720.16l-.24-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-491",
    d: "M1297,719.44l-.23-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-537",
    d: "M1299.71,714.57c.14.5,1,.76.47,1.46h0C1299.54,716,1298.73,713.73,1299.71,714.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-534",
    d: "M1299.47,715.32a2.13,2.13,0,0,1,.71.72C1299.68,716.05,1299.44,715.81,1299.47,715.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-534",
    d: "M1299.26,714.83c0,.09.11.17.17.26C1299.37,715,1299.31,714.92,1299.26,714.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-538",
    d: "M1278.37,706.38c-1.32.87-2.85-.35-4.27.46-1.21-.41-2.7.49-3.7-.23l.48-.71c1.07-.77,2.16.13,3.32-.28a5.77,5.77,0,0,1,4,.25C1278.84,705.88,1278.25,706.24,1278.37,706.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-371",
    d: "M1274,703.71l.19.09a.19.19,0,0,1-.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-290",
    d: "M1272.78,704.68a.44.44,0,0,1-.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-539",
    d: "M1262.87,710.74c1.14-1.16,2.69-1.09,4.12-1.66a.87.87,0,0,1,.15,1.11c-1.28,1.48-.81,3.81-1.46,5.55a26.77,26.77,0,0,0,1,6.66.63.63,0,0,1-.44.51c-3.14,0-2-4-2.66-6.1a4.08,4.08,0,0,1,.37-2.64c.37-.57-.21-1.26.09-2C1262.63,712.68,1261.25,711.76,1262.87,710.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-540",
    d: "M1260.21,712.68l.48-.27.24,0c1.33,2.51,0,5.42,1.34,8,.06,1.45,2.74,3,1.44,4.09-.7.26-1.13-.32-1.56-.78v-.24c-.25-.47-.48-1-.73-1.45h0c-.08-1.52-1.66-2.51-1.7-4.11a4.14,4.14,0,0,0,.26-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-541",
    d: "M1264.1,723.81c-.57,0-1.19,0-1.12-.87-.31-.7-1-1.18-1-2.09a11.45,11.45,0,0,1-.8-5.57c.27-1.06-.91-1.85-.26-2.84l.49-.26a1.82,1.82,0,0,1,1.11,2.36c-.51,1.33-.08,2.65,0,4,.08.74.45,1.43.53,2.19C1262.79,721.79,1265.9,723.57,1264.1,723.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-542",
    d: "M1267,710a1.38,1.38,0,0,1,0-.92c1-.89,2.62-1.57,3.41-2.21v-.26h.47c.86,1-.75,1.28-1.19,1.86C1269,709,1268,710.41,1267,710Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-543",
    d: "M1262.86,711c-.25.28-.78.49-.23,1-.79,1.31-1.35-.9,0-1C1262.73,710.87,1262.8,710.87,1262.86,711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-541",
    d: "M1261.9,711.47v.46l-.12.07-.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-538",
    d: "M1270.4,706.87c0,.08.07.15,0,.21A1.48,1.48,0,0,1,1270.4,706.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-541",
    d: "M1261.42,712.18l.24-.25C1261.74,712.13,1261.62,712.24,1261.42,712.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-541",
    d: "M1262.86,711h-.21l.22-.22A1.69,1.69,0,0,1,1262.86,711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-544",
    d: "M1263.62,735.38a23.47,23.47,0,0,0-1.46-2.65h0c-.17-.11-.12-.35-.26-.48h0a.13.13,0,0,1,0-.23c0-.15.19-.38.31-.2,1.74,2.34,3.67,4.52,4.25,7.41.3.3.51.76,0,1s-.48-.44-.72-.68h0C1264.91,738.25,1264.36,736.75,1263.62,735.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-545",
    d: "M1265.77,739.54l.65.6c-.13-1-.84-1.69-.39-2.55a4.41,4.41,0,0,0,1.66,2.46c-.18,1,.69,1.69-1,1.92C1266.33,741.17,1265.61,740.52,1265.77,739.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-546",
    d: "M1270.12,744.61l0,.24c.28,1.46-1.12.1-1.52-.58a2.19,2.19,0,0,1-.38-.87c-.17-.54-.76-.92-.61-1.58s.9-.72,1.28-.1h0a1.88,1.88,0,0,1,.24.25h0a17.7,17.7,0,0,1,.75,2.16C1270.05,744.26,1270,744.48,1270.12,744.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-547",
    d: "M1268.44,741.23a1,1,0,0,0-.51.76c-.36,0-.57-.12-.46-.52s-.49-1.28.22-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-463",
    d: "M1269.4,742.46c-.08-.16-.16-.33-.25-.49l.26,0,.24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-410",
    d: "M1261.64,731.79l-.22-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-410",
    d: "M1261.89,732a.93.93,0,0,1,0,.23l-.25-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-463",
    d: "M1268.92,741.72l-.23-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-463",
    d: "M1269.16,742l-.24-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1263.36,728.88v.24a.92.92,0,0,1-.48-.72l.17,0C1263.29,728.44,1263.47,728.57,1263.36,728.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1262.87,728.4a1.08,1.08,0,0,1-.25-.73l.18,0C1263.13,727.86,1263.12,728.13,1262.87,728.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1262.62,727.67l-.23-.48h0C1262.79,727.19,1262.8,727.41,1262.62,727.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1263.61,729.85l.23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1263.85,730.09l.23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-417",
    d: "M1269.65,737.6a.88.88,0,0,1,.73.48A.94.94,0,0,1,1269.65,737.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-417",
    d: "M1270.38,738.08l.49.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-548",
    d: "M1262.63,727.67c-.08-.16-.15-.33-.23-.49.44-.95,0-2,.23-2.9h.72c1.76,2,2.25,2.29,4.83,1.61.44.28,1.3.08,1.37.79-.32,2.19-5.86-.45-5.33,1.69.13.36.21.71-.13,1a4.74,4.74,0,0,1-1.21-1A1.06,1.06,0,0,0,1262.63,727.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1261.42,722.1l.25.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1261.91,723.06l.24.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-549",
    d: "M1266.73,742l.26-.5c1,1,2.1,2.8,1.24,4.1-.19,0-.18-.17-.25-.28a1.23,1.23,0,0,0,0-.19c-.19-.31-.31-.67-.48-1-.11-.51-.55-.89-.52-1.45A.9.9,0,0,1,1266.73,742Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1269.16,748.24c.09.32-.2.64-.34.22a8,8,0,0,0-1.33-2.15c0-.16,0-.32,0-.47.26,0,.44.4.77.22C1268.71,746.71,1268.64,747.64,1269.16,748.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1268,745.29l.25.28,0,.25A.81.81,0,0,1,1268,745.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1267.46,745.84a.78.78,0,0,1-.25-.5A.75.75,0,0,1,1267.46,745.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1267.22,745.36a.8.8,0,0,1-.25-.5A.73.73,0,0,1,1267.22,745.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1267.48,744.11l.24.5A.87.87,0,0,1,1267.48,744.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1267.72,744.61l.24.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-545",
    d: "M1265.56,739.28l.21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1266.27,741.22l.2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1266.77,742.38l.19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1267,743.11l.18.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-479",
    d: "M1267.24,743.61l.2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-550",
    d: "M1268.45,745.1c0-.08,0-.16,0-.24-.53-1.08-.81-2.32-1.44-3.39h.48a11.1,11.1,0,0,1,1.43,2.41c0,.39.37.91,0,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-551",
    d: "M1269.38,744.63a5.88,5.88,0,0,0,.51.72h0a.28.28,0,0,1,0,.44,3.85,3.85,0,0,1,1.16,2.46c-1.1-.79-1.42-2.11-2.16-3.15C1269.07,744.94,1268.93,744.51,1269.38,744.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-480",
    d: "M1269.16,748.24l-.22-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-552",
    d: "M1269.92,745.8l0-.44.26-.51C1270.42,745.25,1270.48,745.6,1269.92,745.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-552",
    d: "M1270.12,744.61l-.22-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-410",
    d: "M1261.91,732.26a.77.77,0,0,1,.26.48A.68.68,0,0,1,1261.91,732.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-410",
    d: "M1262.16,732.73l.22.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-553",
    d: "M1292.91,719c.35.38.31,1.08,1,1.22v.24c-.95,0-1.3,1-2.06,1.27a.32.32,0,0,0-.1.31c.29.51,0,.82-.35,1.09s-.12.7-.39,1a1.1,1.1,0,0,0-.31.69c-.73,2.16-3.52.58-5.16.72,1.11,1.11,1.58.85,1.36,2.63.44,2.71-3.68,3-5.4,4.26-4.65,1.28-1.25-4.31,1.06-4.89.7-.69.28-1.74-.73-1.58a3.44,3.44,0,0,1-2.31-1.52c-.15-1.12.93-1.58,1.35-2.4.22-.42,1-.46,1.48.07.26.53-.32.88-.3,1.35s.39,1.12.87.55a2.11,2.11,0,0,1,1.94-.19c7,2.11,6.61-5,2.4-2.91-.43.54-1.41,1.11-2,.5-.07-1.49,1.52-1.87,2.32-2.82C1289.78,715.77,1290.76,718.72,1292.91,719Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-554",
    d: "M1286.14,729.62c1.3-1.46-.83-.55,0-1.63.16-.44.7-1.23,0-1.47s-1.08-.86-1.85-.81a.38.38,0,0,1-.43-.33c1-1.25,3.27.06,4.67,0,1.31.31,1.47-.36,2.21-1.33h.24c.3.74.34,1.61,1.09,2.13.49.42-.2,1.05-.37,1.5-.84.62-.64,2.06-1.69,2.66h0l-.73-.24c-.65-1.81,4.15-4.19-1.47-3.73-.07.39.31.67.12,1.07a.66.66,0,0,1,1.22.48C1288.83,728.67,1286.86,730.34,1286.14,729.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1293.88,720.41l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-496",
    d: "M1290,730.33l.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-556",
    d: "M1302.37,721.38c.3,2.5.24,5,1.41,7.27-.75-.59-1.07-1.59-2-2-.22-.1-.14-.44-.15-.68.13-.47-.2-.8-.38-1.18s-.38-.6-.07-1c.4-.52-.25-1-.13-1.47.36-.3.58.18,1,.14a8,8,0,0,0,.12-1.38c.1-.1.16-.08.19,0h0A.14.14,0,0,1,1302.37,721.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-557",
    d: "M1301.19,723.81c.48.47,1.16,1.64.45,2.13C1300.89,725.43,1299.14,722.63,1301.19,723.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-521",
    d: "M1302.33,721.15l-.19,0,0-.7.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-520",
    d: "M1301.65,719.42a.78.78,0,0,1,.19.53A.62.62,0,0,1,1301.65,719.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-558",
    d: "M1282.25,722.11c-1.37,0-1.49.16-1.49,1.7-.31.17-.73-.45-.94.05s.27.59.54.82c.82,1.05,2.2.51,3.1,1.3-.57.66-.94,2.18-2.13,1.64-.58-.33-.23-1.09-.68-1.47a2.16,2.16,0,0,0-1.4-.76c-.17.5.15.79.46,1.08,2.1,1.43-1.5,4.19-3,2.92a1.16,1.16,0,0,1-.65-1.19c.27-1.93-1.78-3.23-1.35-5.2,1.17-1,1.45,1.61,2.21,2.24.44-2-4.86-6.36-.74-6.62.93,1.33,1.31,5,3.58,3.07a3.86,3.86,0,0,1,2.62-1.31c.95.29,1.77-.87,2.76-.25.47-.55.89-1.5,1.45-2,.78-.73.2-2.41-.93-2-.71-.32-1.64-.28-2.26-.72.13-1.77,3,0,3.9-1.6.17-.21.61-.29.77-.08.72.91,2.25.57,2.74,1.8.06.13.25.19.38.29h.24c.18.11.09.36.24.48s0,.53.25.73h0a.14.14,0,0,1,0,.24c.44.5.44,1.25,1,1.69-.41.36-.7.9-1.36.89C1288.74,713.25,1285.21,725.06,1282.25,722.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1291.21,715.81c-.67-.06-1-.89-1.7-.85-1.45.28-1.06-1-1.81-1-.25.09-.47.26-.4.53-.2,1.46-2.86,0-3.85.77-.2.83-2.4.91-1.89-.18.81-.26.58-1.16,1-1.66.89-.64,1.7-.94.87-2.2-1.21-1.29,1.37-2.17,2-1-1.45.21-.11,2.42.82,2s1.2.06,1.67.64C1289.77,715.45,1289.81,712.22,1291.21,715.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1285.4,710.24a7.77,7.77,0,0,1,6.39,4l-.1.12c-1.15-.72-1.59-2.37-3.14-2.42h0C1288.08,710.8,1286.3,711,1285.4,710.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1295.09,716.78a3.48,3.48,0,0,1-3.4-2.42c.59-.42.73.76,1.22,1C1293.54,715.89,1295.34,715.63,1295.09,716.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1291.94,717a1,1,0,0,1-.25-.73A1,1,0,0,1,1291.94,717Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1291.69,716.29l-.24-.48C1291.8,715.84,1291.65,716.11,1291.69,716.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1293.87,720.17v-.25h0c0,.09.08.17,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1291.94,717.26V717C1292,717.11,1292,717.19,1291.94,717.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-414",
    d: "M1300.66,731.54l.72.49C1300.87,732.27,1300.66,732.06,1300.66,731.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-414",
    d: "M1299.93,730.58l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-414",
    d: "M1300.41,731.3l.25.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-559",
    d: "M1287.82,727.43c-.2-.84-1.49-.72-1.32-1.72,1.28.83,4-.61,4.42.66.6,1.58-1.13,2.32-1.65,3.72-.76-.1-1,.67-1.45,1a13.33,13.33,0,0,0,1-3.15C1288.81,727.05,1288.14,727.59,1287.82,727.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-414",
    d: "M1285.16,734.45l.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-560",
    d: "M1286.14,729.62a.88.88,0,0,1,1,.49,3.17,3.17,0,0,1-1,1,1,1,0,0,1-.64-.16s-.11,0-.11,0c-.77.2-.26,1.14-1,1.31a2.58,2.58,0,0,0-2.36.78c-.73,0-2.61.7-2.47-.56,2.33-.33,4.41-1.9,6.58-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-561",
    d: "M1283,733.72c1.11,0,1.53-1.27,2.79-1.08-.68,1-3.09,2.81-4,2.05-.18-.37.34-.47.5-.72S1282.64,733.53,1283,733.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-505",
    d: "M1285.61,730.8l.52.27a9.13,9.13,0,0,1-2.91,2.17c-.91.49-.6-1,.09-1.06a3.57,3.57,0,0,0,1.37-.32C1284.57,731.34,1285.07,730.69,1285.61,730.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-562",
    d: "M1287.57,729.11c.34-.2.72-1,1.15-.73.24.31,0,.5-.19.73h0c-.31.16-.54.47-.92.53C1287.38,729.49,1287.55,729.29,1287.57,729.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-506",
    d: "M1282.73,733.24h.49l-.24.48a2.93,2.93,0,0,1-1.46.24C1281.92,733.66,1282.14,733,1282.73,733.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-563",
    d: "M1287.57,729.11c.18.17.08.35,0,.53l-.51.47a.46.46,0,0,1-.46-.46h0A9.51,9.51,0,0,1,1287.57,729.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-506",
    d: "M1283.22,733.24l.48-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-416",
    d: "M1281.28,735.9l.49-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-490",
    d: "M1299.54,722.14a.11.11,0,1,1-.21,0C1299.35,722,1299.55,722,1299.54,722.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-564",
    d: "M1264.09,729.36c-2.29-4.39,1.86-1.67,4.36-2.17.12.74-.82.57-1.27.67-2.47.35-.54,1.75-1.4,3-1,.16-1.31-.83-1.69-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-565",
    d: "M1272.56,732.75a14,14,0,0,0-.24,1.69,1.19,1.19,0,0,0-.48.49h0c-1.19.75-2.95-1.91-4-2.62-.63-.33-2.71-1.23-1.22-1.92,2,0,3.15,3.63,5.24,2.62C1272.07,732.84,1272.23,732.55,1272.56,732.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-548",
    d: "M1264.33,729.85l1.21,1,.48,1.45A6.71,6.71,0,0,1,1264.33,729.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-564",
    d: "M1266.26,730.82v.48a1.17,1.17,0,0,1-.48-.48A.33.33,0,0,1,1266.26,730.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-566",
    d: "M1271.84,734.93c1.94-1.47,4.69,2.65,3.19,2.85-.92-.27-1.57-1.2-2.57-1.43-.71-.29-.76-.49-.62-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-567",
    d: "M1272.56,732.75c-1.4,2.4-3.67-.41-5.08-1.45-2.31-1.5-1.19-3.31,1-4.11h0c.18-.23.53,0,.72-.25l.24-.24h0c.4-1.61,2.95-2,2,.17-1.23,1.4-3.77,1.06-2.24,3.57.51.73,1.6,2,2.52,1.66.65-.89,2-1.24,2-2.67,0-.5-.34-1.26.47-1.59,1.82,1.15,1.1,4.43-1.15,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-568",
    d: "M1273.05,732.27c.7-.71,1.78-.94,1.69-2.18l.15-.09c1.24,1.11,5.24-1.46,4.46.39-.79.83-.37,1.49.25,2.14,0,.67-2.3,1.69-2.68,1-1.61.49-1.66-1.43-2.59-1.16C1273.89,732.58,1273.47,732.33,1273.05,732.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-569",
    d: "M1278.85,733.74c-.32.63-3.72,1.19-2.88.23.86.1,2.33-1.39,2.89-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-505",
    d: "M1277.41,733.5a.63.63,0,0,1-.5.2c0-.07,0-.15,0-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-570",
    d: "M1280.29,733c.48-.08,1-.55,1.46-.2h0c.63.86-.9.76-1.4.92C1279.91,733.66,1279.72,732.8,1280.29,733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-560",
    d: "M1280.13,733a.87.87,0,0,0,.22.67l-1.5,0v0C1279,732.9,1279.6,733.07,1280.13,733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-571",
    d: "M1281.72,733.43l0-.66c.44-.13,1.07-.16,1,.47h0c-.2.24-.54,0-.74.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-548",
    d: "M1264.09,729.36l.24.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-511",
    d: "M1300.63,715.13l-.23-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-572",
    d: "M1298.49,736.78c.19.49.16,1.33,1,.75,1.06.15,1.14,2.31.48,3-.51.56-1.12.44-1.26-.31s-.87-.54-1.11-1c0-.08-.35,0-.4.17-1.34,1.73.5,2.33-.89,3-.93.57-1.21,1.31-2.15.2-.89-.46-.84-.43-.35-1.2,1.05-1.27,1.79-3.33,3.55-3.66C1297.92,737.72,1297.87,737,1298.49,736.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1304.3,724a1,1,0,0,1-.24-.74A1,1,0,0,1,1304.3,724Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1303.54,722.1l-.21-.49.16.07C1303.51,721.82,1303.52,722,1303.54,722.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1304.06,723.31a.79.79,0,0,1-.24-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1304.54,724.52a.72.72,0,0,1-.24-.49A.74.74,0,0,1,1304.54,724.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-433",
    d: "M1304.73,724.75l-.17-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1303.77,722.58l-.19-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1303.33,721.62l-.23-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1303.55,723.83l-.22-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1303.31,723.35l-.21-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1303.06,722.63l-.21-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1302.82,722.13l-.19-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-522",
    d: "M1302.37,721.38v-.24l.21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-573",
    d: "M1284.19,709.76c-1.51.93.25,1.91.8,3-1.85,1.19-4.8,1.6-6-.55-.44-1.29-.61-2.85-2.42-2.52-2.57.16-8.17.09-3-2.64,1,0,2.16-.48,3.12.34,1.15.68,3,.3,3.68,1.68S1283,709.21,1284.19,709.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-574",
    d: "M1276.68,707.34a22.08,22.08,0,0,1-3.15,0c-1,.19-2.31,1.3-3.15.23C1270.91,706.33,1277.07,705.45,1276.68,707.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1295.09,716.78c-.51-.78-1.6-.73-2.18-1.45a6.19,6.19,0,0,0,2.42.24l.24.24h.72c-.25.47-.79.8-.7,1.44A1,1,0,0,1,1295.09,716.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-575",
    d: "M1276.68,707.1a5.22,5.22,0,0,0-2.91-.73,5.89,5.89,0,0,1,4.11.25,1.77,1.77,0,0,1,0,.23A2.42,2.42,0,0,1,1276.68,707.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1292.18,714.36h-.48v-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1294.84,714.6v.48A.29.29,0,0,1,1294.84,714.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1294.85,715.08l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1292.91,715.32l-.25-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1292.66,715.08l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-278",
    d: "M1295.82,717.5l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-575",
    d: "M1273.77,706.37l-2.9.73v-.48A5.51,5.51,0,0,1,1273.77,706.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-576",
    d: "M1266.54,722.36c-1.34.18-.47-1.14-1-1.85a1.7,1.7,0,0,1-.19-1.5c-.07-1.75-.52-2.87.2-4.66.05-.16.11-.34,0-.46-.43-.5,0-.91.11-1.35.6-1.25-.47-1.9,1.28-2.54,1.69,1.77-.78,3.34-.48,5.3a1.11,1.11,0,0,0,.71,1c.41,1.2-.69,2.63.52,3.87.77,1.24,2.14,0,3,.93,0,.93-1.43.81-2.06,1.09C1267.94,722.17,1267.3,723,1266.54,722.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-543",
    d: "M1262.63,711.93c.71-.06,1.64.16,1.7-.92.33.16.29.33.25.48-.49.89.25,1.84-.19,2.71-1.24,2.16.43,4.28.11,6.51,0,.8.66,2,1.57,1.9-.52,1.62-2.89.14-2.82-1.22a22.68,22.68,0,0,1-.62-9.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-577",
    d: "M1265.77,722.82c.51-.63,5.81-1.92,3.6-.16-1.19.6-2.61.57-3.73,1.4-.78.66-1.8,1.45-2.27.47h0a9.93,9.93,0,0,1,.73-.72h0c.12-.16.35-.12.49-.25h0A2.81,2.81,0,0,1,1265.77,722.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1263.61,724.29l-.24.24c0-.08,0-.17,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-578",
    d: "M1262.63,711.94c1.24,1.88-.14,3.58,0,5.59.31,0,.29-.37.64-.26-.29,1.3.41,2.55.48,3.83-.31,1,.23,1.6,1.1,2,.1.07.1.24,0,.28a.17.17,0,0,1-.27,0c-1.3,0-1.87-2.12-2-3.21-1.17-1.36-.34-3.08-.79-4.57-.16-.93.86-1.76.1-2.63C1261.77,712.38,1262.18,712.11,1262.63,711.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-543",
    d: "M1262.15,712.18c.49.89-.87.89-.72,0l.24-.24h.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-540",
    d: "M1264.57,723.32l.23,0a.14.14,0,0,1,.25,0l-.47.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-540",
    d: "M1264.58,723.56l-.49.25A.71.71,0,0,1,1264.58,723.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-579",
    d: "M1270.38,707.57c1.1.07,2.08-.73,3.15-.23-.1,1-1.48.68-1.74,1.42a.47.47,0,0,0,.62.4c1.55-.53,3.31.78,4.63-.42.37-.35.69-.3.72.24s.43.47.77.55c.93.22,1.12.49.67,1.3-.28.49.09.74.14,1.11s.07.51.25.72a19.23,19.23,0,0,0,2.9.73l.24.24h0c.11,1.29.11,1.29-1,1.69-.27-.21-.61.37-.87-.06-.63-2.11-2.2-.49-3.06-1.56.05-.22,0-.33-.27-.27-.56-.31-.49-.79-.3-1.26s0-.65-.42-.91c-2.22-1.9-4.36-.3-6.13,1.33-.79.72-3,.53-1.85,2.07,1.56,1,.4,6.07,3.08,4.15,1.25-.64,2.46-1.52,4-1.41,1.32-.32,1.64,1.49.27,1.31-.58.27-1.74.92-.81,1.52,1.11.56.06,1.71,1,2.24.74.51,1.87,3.19,1,3.65-1.51.28-1.59-2.38-2.43-3.29-.58.15-.67-.4-1-.68-1.6-4.38-7,2.35-6.79-5.62h0c-2.35-2,1-4,.49-6.35a.85.85,0,0,1,.48-.9c.5-.31.56-1.06,1.21-1.22C1269.69,707.8,1270.11,707.84,1270.38,707.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-580",
    d: "M1268.2,709.28c.41,2.13-.42,3.43-1.33,5.44-.28.65.5,1.14.36,1.81-1.87.12-.94-1.85-1.06-3,.19-.66,1.14-1.09,1-1.67A3.49,3.49,0,0,1,1267,710C1267.4,709.78,1267.68,709.32,1268.2,709.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-574",
    d: "M1270.38,707.58a1,1,0,0,1-1,.48A1,1,0,0,1,1270.38,707.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-539",
    d: "M1262.14,712.17l-.23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-483",
    d: "M1269.38,744.63l-.45.46a.88.88,0,0,1,0-1A1.18,1.18,0,0,1,1269.38,744.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-483",
    d: "M1268.9,743.88l-.21-.47A.68.68,0,0,1,1268.9,743.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-552",
    d: "M1269.89,745.35l-.2-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1263.37,724.53c.71.33,1.13-.36,1.71-.47.73,0,1.31-.87,2.13-.39.47,1-1.13.77-1.31,1.6.57-.37,1.08-.18,1.7-.06.55-.11,1.26-.81,1.7-.12.16.89-.43,1-1.09,1.14-1,.1-1.8.68-2.81.34a1.63,1.63,0,0,1-1.32-.88C1263.9,725.3,1262.93,725.08,1263.37,724.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-564",
    d: "M1268.21,726.23c.22-.48.92-.58.94-1.22a.7.7,0,0,1,.91-.51c.51.27,2.07-.45,1.57.81-.89.26-1.34,1.15-2.21,1.39C1269.06,726.29,1268.35,726.87,1268.21,726.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-564",
    d: "M1269.17,726.94a1,1,0,0,1-.72.25A1,1,0,0,1,1269.17,726.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-564",
    d: "M1269.41,726.7l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-483",
    d: "M1268.2,744.37a.78.78,0,0,1,.23.49C1268.36,744.7,1268.28,744.54,1268.2,744.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-581",
    d: "M1285.88,721.13c.33,0,.68,0,.85-.37.51-1,1.57-.86,2.42-1,1.06.19,1.63,1.61,1.91,2.59,0,.1,0,.33-.07.33-.78.13-.76.93-1.16,1.36s-2,.81-2.11,0c.18-.62,1.23-1,.65-1.69-.36-.4-.69-.79-1.3-.46C1286.5,722.37,1285,722,1285.88,721.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-582",
    d: "M1287.82,724v.24c-1.45,1.08-3.8-1.37-4.87.48-.18.56-1.46,0-1.94-.27,1.32-.76-.7-1.36,1.24-2.38,1,.12,1.85-.36,2.78-.4.87,1.09-.13,1.7,2,1.76C1287.38,723.5,1287.86,723.4,1287.82,724Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-583",
    d: "M1279.6,732.53c-.85.08-1.16-.61-1.56-1.13-.53-.89,1-.89,1.31-1.55-.19-.5-.83,0-1-.49,1.72-.68,1.51-2.47,3.39-1.94a2.81,2.81,0,0,0,.94-.59c.14-.15.19-.52.48-.34s.19.45,0,.7h0c-.35.27-.4.81-.88.92-1.22.19-4.37,4.15-1.79,4.16A1.39,1.39,0,0,1,1279.6,732.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-584",
    d: "M1283.22,727.19c0-.85-.53,0-1,0,.38-.43.3-1.32,1.21-1.21A1.78,1.78,0,0,1,1283.22,727.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-582",
    d: "M1285.64,721.38l.24.48c-.31.81-1.15-.26-.48-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-583",
    d: "M1281.29,732.05a1,1,0,0,1-.74.22A.91.91,0,0,1,1281.29,732.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-554",
    d: "M1286.13,729.61a.78.78,0,0,1-.49.25A.78.78,0,0,1,1286.13,729.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-488",
    d: "M1290.73,724l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-584",
    d: "M1283,727.44l.24-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-582",
    d: "M1285.88,721.13l-.24.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-585",
    d: "M1288.53,729.11c0-.26.31-.61-.22-.71a1.13,1.13,0,0,1,.48-.49C1290.06,728.25,1289.06,728.76,1288.53,729.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-560",
    d: "M1287.1,729.36a.6.6,0,0,1-.47.28A.6.6,0,0,1,1287.1,729.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-586",
    d: "M1285.16,715.33c.45.68,2-.11,2.23.73,0,.58.56,1.15.15,1.7-1,1.11-1.76,3.15-3.29,3.49-.18-.42.47-.51.37-1-.75,0-1.31.84-2.13.6-.21-.85.45-1.13,1-1.33.91-.25,3-2.28,1.85-3C1284.76,716.21,1284.59,715.83,1285.16,715.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-587",
    d: "M1276.43,718.47a1.46,1.46,0,0,1,1.52,1.32c.45,1.82,1.83-1,3.34,1.35-.23.24-.77.17-.69.7-1,.16-.77,1.63-2.21,1-1.76-.34-1.5-1.93-2.16-3.12-.32-.32-.2-.66,0-1A2.72,2.72,0,0,0,1276.43,718.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-588",
    d: "M1281.29,721.14c-.46,0-.94.07-1.18-.53-.15-.36-.65-.06-.93-.25-.49-.69,0-1,.5-1.36.76-.13,1.44.67,2.17-.1a6.7,6.7,0,0,1,2-.55c.7-.14,1.19-1,2.05-.6-.51,1.69-2.29,2-3.39,3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-584",
    d: "M1281.52,727.43c-1.38-.09-1.56,1.74-2.9,1.69a3.73,3.73,0,0,0,1.46-1.79c-1.15,0-2.67-3.13-.88-2.8,1,.25,1.58,1.3,2.58,1.26C1281.94,726.47,1281,726.81,1281.52,727.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-589",
    d: "M1274.5,721.87a1.61,1.61,0,0,0,.48,1c-.15,1.92,1.62,3.25,1.46,5.11a1.36,1.36,0,0,0,.48,1.18c-.77.77-1.78-.43-1.66-1.2,0-1.71-1.15-3-1.45-4.65-.17-.87-1.2-1.08-2-1.25-.51-.07-1.23-.18-1.16-.89C1271.69,719.94,1273.53,720.73,1274.5,721.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-590",
    d: "M1285.16,715.33c-.18.48.1.73.48.93C1278,720.17,1275.84,716.44,1285.16,715.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-591",
    d: "M1279.33,727.82c0,.61-1.88,1.54-1.87.34A1,1,0,0,1,1279.33,727.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-592",
    d: "M1284.63,715.35c-.8.85-2.3.72-3.38,1.15-.16-.13-.52,0-.51-.37.51-.75,1.4-.13,2-.55.37-.31.85,0,1.23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-583",
    d: "M1276.43,729.12c.67,0,1.26.35,1.94.24h0C1278.45,730.48,1276.16,730.17,1276.43,729.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-553",
    d: "M1285.4,721.38l-.25.48h-1A2.66,2.66,0,0,1,1285.4,721.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-590",
    d: "M1284,715.35a2.18,2.18,0,0,1-1.23.23A1.44,1.44,0,0,1,1284,715.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-584",
    d: "M1282.25,727.19l-.49.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-593",
    d: "M1276.93,717.75c-.74,0-1.43.69-2.2.15,0,0-.2,0-.21.05-.26,1.11-1.34.61-2,1-1.67,1.36-4.33-.81-2.29-2.09,2.33-1.12-.23-2,.4-3.64.36-2,6.37-4.64,5.22-.9-.52.85-.07,1.17.59,1.26a8.14,8.14,0,0,0,2.84.31c.93-.18,1.21.86,1.72,1.42.24-.1.48-.23.72,0-.29.64-1.07.28-1.35.93C1279.62,716.72,1277.71,718.66,1276.93,717.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-590",
    d: "M1280.08,716.3v-.23c.37-.49,1-.27,1.45-.5h1.21c-.57.46-1.36.32-2,.7A.42.42,0,0,1,1280.08,716.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-594",
    d: "M1288.18,726.53c2.83-.92,3,1.51,2,1.1-.53-.64-1.32-.66-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-595",
    d: "M1282.74,733l-.7-.3c.45-.92.72-1.07,1.66-.94a1.42,1.42,0,0,1,.24.25c.13.07.07.18,0,.2C1283.66,732.64,1283.13,732.76,1282.74,733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-505",
    d: "M1280.13,733c-.36.36-.88.43-1.29.7-.4-.53-.95-.14-1.42-.23.47-.45,1.16-.41,1.68-.73a1.59,1.59,0,0,1,1.19.2A.44.44,0,0,1,1280.13,733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-596",
    d: "M1285.17,731.06a1,1,0,0,1-.49.8c-.61-.17-.48-.73,0-1A.42.42,0,0,1,1285.17,731.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-498",
    d: "M1285.17,731.06l-.25-.22a.92.92,0,0,1,.72-.27h0a.89.89,0,0,1,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-498",
    d: "M1285.64,730.57c.41-.69.78,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-571",
    d: "M1281.75,732.76l-.71,0A.47.47,0,0,1,1281.75,732.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-498",
    d: "M1284.67,730.85l-.25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-596",
    d: "M1283.93,732l-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-596",
    d: "M1283.92,732.24a1.36,1.36,0,0,1,0-.2h.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-596",
    d: "M1283.7,732.49l.22-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-505",
    d: "M1282,733.48a1.11,1.11,0,0,1,.74-.25A1,1,0,0,1,1282,733.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-597",
    d: "M1268,727.44c-.51,1.08-1.92,1.81-1.21,3.13a1.47,1.47,0,0,1-1,.25C1264.5,728.36,1265.11,727.2,1268,727.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-597",
    d: "M1267.23,731.06l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-597",
    d: "M1267.48,731.3l.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-598",
    d: "M1274,727.91c.3,1.05.23,2.68-.66,3.35-1.13.77-1.78,2.29-3.16.8-1.69-.69-1-1.26-1.86-2.31-1.46-1.19,1.83-2.57,2.78-2.81.29.67-.35.79-.67,1.09-.69.65-.38,2.76.51,3.09a1.18,1.18,0,0,0,1.42-.28c1.63-1.79.68-3-1.26-3.9.08-.48.15-1,.23-1.46a.64.64,0,0,1,.8.13C1272.64,726.45,1274.06,726.7,1274,727.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-599",
    d: "M1271.59,725c-.54-.51-1.2.48-1.7-.22,0-.78,1.91-2,2.63-1.23a3,3,0,0,0,1.47,1.88c1.3.69,1.68,3.52.75,4.65-.53-.65.11-1.7-.73-2.18C1273.68,726.47,1271.8,726.39,1271.59,725Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-600",
    d: "M1274.74,730.09c.38-6.13-2.8-2.91-2.42-6.53.48-.6,0-.82-.43-.85a3.89,3.89,0,0,1-2.26-1.14,4.15,4.15,0,0,1,5.31,3.34c1.07,1.45.49,6,3.44,4.46a3,3,0,0,0,1.95-.52c0,.67-.44.88-1,1C1277.8,730.3,1276.1,731.67,1274.74,730.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-560",
    d: "M1279.1,732.76l-.5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1279.59,712.66c-.21-.2-.42-.4-.25-.72A1,1,0,0,1,1279.59,712.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1282.73,713.63l-.24-.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-card-532",
    points: "1295.57 715.81 1295.53 715.85 1295.57 715.81 1295.57 715.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-580",
    d: "M1274.5,721.87c-2.62-2.07-5.69.42-6.88-.82-1-1.39-1.63-3-.39-4.52a3.16,3.16,0,0,1,.84,2.56C1268.39,721.79,1273.61,718.42,1274.5,721.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-601",
    d: "M1269.63,721.57c1,0,1.78.62,2.75.66,1.48.17,1.24,3-.06,1.33-.71.07-1.23.63-1.94.73-.37-1.32-1.59-.16-2.44-.86-.25-.69.61-.47.71-.88.25-.25.7-.17.91-.55-.25-.26-.59-.08-.87-.17A1.82,1.82,0,0,1,1269.63,721.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-541",
    d: "M1265.05,723.31h-.25a1.77,1.77,0,0,0,0-.23,2.24,2.24,0,0,1,1-.25A2,2,0,0,1,1265.05,723.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-602",
    d: "M1268.65,722.55c.68.33-.54.49-.67.82,0,.5-.26.7-.75.43-.74-.1-1.46.7-2.15.26v0A7.5,7.5,0,0,1,1268.65,722.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-471",
    d: "M1265.31,723.83l-.24.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-603",
    d: "M1281,715.32c-1.2-.37-1.26-1.62-2.84-1.07-.74.28-3.75-.25-3.28-1.16.41-.48-.71-.35-.44-.86s.83.09,1.24-.23c-.11-.33-.16-1.39-.68-1.15-.65.64-1.47-.22-2.13.46-1,.88-2.12,2-1.73,3.4.5.34.54-.38,1-.14.22.15.33.48.19.64-.59,1-.78,1.85-2.08,2.3-1.49.77,1.55,2.13,2.3,1.45-3.65,3.09-2.51-3.23-4.57-4.4-1-.72.2-1.28.66-1.85s.52-.56,1.16,0c.34,0,.3-.33.38-.54.13-.82,1.15-.32,1.45-.83.3-1.31,1.89-.72,2.43-1.68.08-.15.39-.16.56,0a20.47,20.47,0,0,0,2,.89c.13.08.3.25.41.22.91-.23,1,.53,1.29,1-1.34.74-.49,2.22.52,1.88.47-.17.93-.3,1.35.13.15.16.36.09.57.09C1281.94,713.84,1281.29,714.6,1281,715.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-604",
    d: "M1276.93,717.75h.47c.54.67,1.17-.87,1.71-.19a1.64,1.64,0,0,0,1,.2c.19.54-.37.61-.56.91-.4.56-.88,1.1-.17,1.78-.38,1.64-1.75.3-1.95-.6.06-.77-.6-.73-.75-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-558",
    d: "M1276.43,718.47l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-605",
    d: "M1267.23,723.8a1.42,1.42,0,0,0,.75-.43c.91.13,1.83-.75,2.62-.08-.35.72-.59,1.43-1.4,1.7-1.36.87-1.5-.08-2.69.28,0,.88,0,.88-1.46.88C1264.55,724.58,1266.45,724.59,1267.23,723.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-606",
    d: "M1266.51,725.27c.33-1,1.32-.13,2,0l0,.16a1.31,1.31,0,0,0-.74.27h-.25A7.5,7.5,0,0,1,1266.51,725.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-564",
    d: "M1267,725.52l.48.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-564",
    d: "M1268.46,725.44a.45.45,0,0,1,0-.16.24.24,0,0,1,.16,0A1.8,1.8,0,0,1,1268.46,725.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-564",
    d: "M1267.72,725.71l.23-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-601",
    d: "M1269.66,724.74l.43-1.17c.36.13.13.51.29.72l-.49.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-567",
    d: "M1271.59,725a.48.48,0,0,1,.24.72l-.49-.25a1.77,1.77,0,0,0,0-.23c.08-.08.17-.16.24-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-601",
    d: "M1269.2,725a.5.5,0,0,1,.43-.23A.56.56,0,0,1,1269.2,725Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-599",
    d: "M1271.59,725l-.24.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-607",
    d: "M1285.16,721.86c1,.35,1.6-.88,2.55-.89.56,0,.73.57,1.06.91,1.8.58,0,1.82-1,2.16C1286.45,724,1283.6,724,1285.16,721.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-608",
    d: "M1282.49,717a6.08,6.08,0,0,1,3.15-.77c1.91.88-.53,1.75-1.29,2.4a.46.46,0,0,1-.64.07c-.15-.54.29-1,.52-1.44C1283.69,716.86,1283,717.86,1282.49,717Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-609",
    d: "M1282.49,717c4.14-1.2,3.33,1.26,2,.5a4.78,4.78,0,0,1-1.51.68.16.16,0,0,0-.13.11c-.19,1.21-2.18.78-3,1C1278.63,718.2,1281.8,717.43,1282.49,717Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-610",
    d: "M1282,717.28c-.77.51-2.25.88-2.19,2-.18.37-.77.55-.5,1.11-.39-.09-.65-.44-1.11-.48A4.05,4.05,0,0,1,1282,717.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-611",
    d: "M1282.5,717.77a3.16,3.16,0,0,0,1.21-.25c.42.51.06.84-.27,1.18h0c-.51.09-1.7,1-2,.31.18-.23,1.35-.26.69-.58C1282.13,718.14,1282.41,718,1282.5,717.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-612",
    d: "M1281.51,719l.51.23c-1.12.6-1.27.6-2,0l.54-.57C1280.93,718.57,1281.18,718.94,1281.51,719Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-613",
    d: "M1283.44,718.7l.27-1.18a1.2,1.2,0,0,1,.75,0,4.26,4.26,0,0,1-.75,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-613",
    d: "M1283.23,718.8l.23-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-614",
    d: "M1279.11,717.55c-.49.12-1.29,1.11-1.5.17h0a4.56,4.56,0,0,1,2.21-1.19c.2-.23.52,0,.73-.23l.22,0,.47.22A5.05,5.05,0,0,0,1279.11,717.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-604",
    d: "M1280.6,717.52l-.28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-615",
    d: "M1277.61,717.72a1.05,1.05,0,0,0,.76.26c-.43.34-1.39.64-1-.24A.5.5,0,0,1,1277.61,717.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-555",
    d: "M1281.53,715.57a5.09,5.09,0,0,1-1.45.5C1280.41,715.47,1281,715.58,1281.53,715.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-592",
    d: "M1280.56,716.31a1,1,0,0,1-.73.23l.25-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-615",
    d: "M1277.88,717.47l-.26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-616",
    d: "M1271.11,726.94c.77-.5,1.3.21,1.77.76,1.52,1.21.61,2.73-.51,3.81-1,.72-2.32-.43-2.72-1.39-1-1.51.55-2.19,1.46-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-567",
    d: "M1271.83,725.73c1.1.36,2.08.83,2.18,2.18C1273.41,727.06,1272.34,726.68,1271.83,725.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-617",
    d: "M1277,730.24c-.07.39-1,.48-1,.1S1277,729.69,1277,730.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-618",
    d: "M1270.38,724.29c-.22-.19-.22-.47-.29-.72.17-.5,1.25-.23.68.29A5.39,5.39,0,0,0,1270.38,724.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-615",
    d: "M1278.37,718l.27-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-619",
    d: "M1269.08,724c0,.37-.76.47-.72.07S1269,723.59,1269.08,724Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-588",
    d: "M1283.72,718.71l.22-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-588",
    d: "M1284.21,718l.18-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-620",
    d: "M1282.5,717.77c.21.36-.12.48-.3.66h-.39C1281.31,718,1282.22,717.89,1282.5,717.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-611",
    d: "M1281.77,718l0,.41C1281.62,718.32,1281.59,718.18,1281.77,718Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-611",
    d: "M1281.28,718.92a.3.3,0,0,1-.29-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-611",
    d: "M1280.77,718.62c-.1,0-.27,0-.1-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-621",
    d: "M1270.43,728.79c0-1.88,2.7-.93,2.69.4C1272.7,731,1270.31,731.82,1270.43,728.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-card-622",
    d: "M1267,709.08s-.15.74,0,.92-3.77,2.23-4.48,2.39-.85.21-.93.54-.79-1.43,1.29-2.43A21.73,21.73,0,0,1,1267,709.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.25a2263bd1adce8dfc1603c206c7b789.svg";
export { ForwardRef as ReactComponent };